"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEST_NEWSINTERACT_DATA = {
    "list": [{
        "symbol": "600000.sh",
        "questioner": "guest_RzkBfEx0w",
        "question": "请问浦发是否有重大亏损或利空事件未公布？否则股价咋跌成这班模样？",
        "questondate": "20231218",
        "answerer": "浦发银行",
        "answer": "公司无相关应披露而未披露事项，股价受到证券市场等多方面的影响。公司将持续做好经营管理，进一步推进市场对公司的价值认同。感谢您的关注！",
        "answerdate": "20231228",
        "id": "1252159"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "你好！请问。浦发银行的大股东如何看待当前股价低迷？为何不积极增持股份，提升市场的信心。董事会应当提请大股东积极维护股票的市场信心",
        "questondate": "20231204",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！",
        "answerdate": "20231213",
        "id": "1242450"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_o21dZK5zh",
        "question": "请问您认为贵公司面临怎样程度的气候风险？其中面临的物理气候风险、转型气候风险分别为怎样的程度？请您分别为贵公司面临的气候风险（整体）、物理气候风险、转型气候风险的程度打分，请打1-5分，1为面临的风险程度最低，5为面临的风险程度最高。谢谢！",
        "questondate": "20231204",
        "answerer": "浦发银行",
        "answer": "为推进环境与气候风险管理工作，公司于2022年7月成立环境风险管控中心，组建专业团队，持续推进将环境、社会、治理要求纳入管理流程，并将环境风险管理要求纳入全面风险管理体系。感谢您的关注！",
        "answerdate": "20231213",
        "id": "1243318"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_b7MA7Obv1",
        "question": "您好，公司2023年三季报显示净现金流同比大幅下降。根据碧湾APP分析，净现金流大幅下降的主要原因是偿还债务支付的现金流本期为10036.20亿元，同比增加182.63亿元。请问本期筹资活动现金流净额减少的原因是什么？",
        "questondate": "20231120",
        "answerer": "浦发银行",
        "answer": "2023年前三季度筹资活动现金流净额同比减少，主要由于2023年已发行债务证券报表项目中的金融机构存单及债券余额减少，导致筹资活动现金流净额减少。感谢您的关注！",
        "answerdate": "20231129",
        "id": "1234247"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_2VHJqeThm",
        "question": "请问董秘：股东大会现场有网络直播吗？",
        "questondate": "20231117",
        "answerer": "浦发银行",
        "answer": "公司股东大会以现场会议形式召开。感谢您的关注！",
        "answerdate": "20231129",
        "id": "1233261"
    }, {
        "symbol": "600000.sh",
        "questioner": "zxcvbnm",
        "question": "尊敬的董秘你好！由于贵公司各分行，对于信用卡的发行、额度审核等，监管不利，导致用户不理性消费，消费后不还。贵公司部分分行也没派业务员进行催收。希望贵公司针对此事，出台相应的措施，已保证股东的权限。谢谢",
        "questondate": "20231121",
        "answerer": "浦发银行",
        "answer": "公司信用卡业务坚持以客户为中心聚焦商业新场景，打通普惠金融服务通道，助力消费扩容提质。公司不断加大相关领域风险监测力度，持续提升风险化解和不良资产处置的专业能力。感谢您的关注！",
        "answerdate": "20231129",
        "id": "1235113"
    }, {
        "symbol": "600000.sh",
        "questioner": "沪深6008000000",
        "question": "请问浦发银行最近三四年的业绩为什么这么差、越来越差、股价近乎腰斩？？？\n公司管理层到底能不能有为？？？公司到底会不会回归本源、专注主业、全面改革、自我革命？？？ 浦发银行到底能不能大刀阔斧全面改革、贯彻要求全面整改？？？",
        "questondate": "20231117",
        "answerer": "浦发银行",
        "answer": "公司将贯彻新发展理念，围绕服务国家战略和上海“四大功能”“五个中心”建设，切实提升经营服务能力，推进高质量发展。重点抓好以下几方面工作：一是抢抓机遇，加大合意资产投放力度；二是聚焦营收、中收、不良资产清收等重点领域，加快低成本存款拓展、提升中收贡献度、扩大不良清收战果，加快提升经营效益；三是抓好客户和项目储备，强化集团协同，守牢风险合规底线；四是提升专业能力、强化服务支撑，提升客户、产品、服务、管理的一体化经营水平，提高发展质效。感谢您的关注！",
        "answerdate": "20231129",
        "id": "1233099"
    }, {
        "symbol": "600000.sh",
        "questioner": "zxcvbnm",
        "question": "请问贵公司，目前使用贵公司信用卡，逾期5年没还的人和金额有多少？贵公司针对这部分逾期不还的人，接下来贵公司是怎么打算的？",
        "questondate": "20231113",
        "answerer": "浦发银行",
        "answer": "截至2023年6月末，公司信用卡及透支的不良贷款金额为101.81亿元，不良率2.49%。公司将进一步加大不良资产清收处置力度，提高风险资产处置化解效益。感谢您的关注！",
        "answerdate": "20231116",
        "id": "1230134"
    }, {
        "symbol": "600000.sh",
        "questioner": "张先生保均",
        "question": "尊敬的董秘：您好！目前公司股价很低，公积金和未分利润很多。鉴于公司没有回购计划，建议加大分红力度，让散户有钱购买公司股票。",
        "questondate": "20231113",
        "answerer": "浦发银行",
        "answer": "公司后续在制定分红政策时，将充分考虑行业发展情况、内外部经营环境、公司自身的经营状况和资本充足水平，以更好地平衡长远良性发展和投资者即期回报的关系，兼顾投资者的当期收益和远期利益。感谢您的关注！",
        "answerdate": "20231116",
        "id": "1229947"
    }, {
        "symbol": "600000.sh",
        "questioner": "問一問問題",
        "question": "想查询上海证券交易所统计年鉴（2022卷）会在什么时候发布? 谢谢。",
        "questondate": "20231027",
        "answerer": "浦发银行",
        "answer": "请咨询交易所。感谢您的关注！",
        "answerdate": "20231102",
        "id": "1221077"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行为啥落魄到这种程度？以前和招行一个梯队，如今2023年前三季度挣得钱加起来比不过招行一个季度挣的钱？",
        "questondate": "20231030",
        "answerer": "浦发银行",
        "answer": "公司效益指标阶段性下滑，主要是内外部因素叠加影响。一方面，受贷款市场利率处于低位以及存量资产重定价影响，利息净收入同比下降；同时受资本市场波动影响，财富管理、理财、信用卡等中间业务收入贡献减少。另一方面，近几年公司主动调整资产结构，持续推进不良压降，加大风险拨备计提，经营效益受到一定影响。\n公司将始终围绕经营主线，推进高质量发展。净利息收入方面，积极推动轻型化、“双碳”、数字化转型发展，培育营收增长的新动能，加强资产负债主动管理，做好贷款投放和存款付息率的管理。非息收入方面，提升多元中收竞争力和轻资本运营能力。推动财富、私行、投行、交易银行、托管等重点业务的增长。成本端，强化风险的主动防御，加大清收，减少成本耗用。\n感谢您的关注！",
        "answerdate": "20231102",
        "id": "1221304"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_0FsdmNCDb",
        "question": "董秘，您好。请问下截止10月31日，贵司股东人数情况。",
        "questondate": "20231101",
        "answerer": "浦发银行",
        "answer": "截至2023年9月30日，公司普通股股东总数196,192户。如需查询其他时点股东人数，请向公司提供证明其持有公司股份的种类以及持股数量的书面文件，公司经核实股东身份后按照相关规定予以提供。感谢您的关注！",
        "answerdate": "20231102",
        "id": "1223799"
    }, {
        "symbol": "600000.sh",
        "questioner": "破晓1988",
        "question": "公司业绩连续至少五年下滑，今年三季报在所有上市银行中业绩降幅最大，新的管理层上任后，将采取什么措施提高公司业绩，维护公司形象？",
        "questondate": "20231031",
        "answerer": "浦发银行",
        "answer": "公司认真贯彻新发展理念，树立新发展格局，推进高质量发展，围绕服务国家战略和上海“四大功能”“五个中心”建设，切实提升经营服务能力，重点抓好以下几方面工作：一是抢抓机遇，加大合意资产投放力度；二是聚焦营收、中收、不良资产清收等重点领域，加快低成本存款拓展、提升中收贡献度、扩大不良清收战果，加快提升经营效益；三是抓好客户和项目储备，强化集团协同，守牢风险合规底线；四是提升专业能力、强化服务支撑，提升客户、产品、服务、管理的一体化经营水平，提高发展质效。感谢您的关注！",
        "answerdate": "20231102",
        "id": "1222887"
    }, {
        "symbol": "600000.sh",
        "questioner": "张先生保均",
        "question": "尊敬的董秘：您好 ！公司公积金和未 分利润那么多，请问可不可以加大分红力度。",
        "questondate": "20231024",
        "answerer": "浦发银行",
        "answer": "公司在制定分红政策时，充分考虑行业发展情况、内外部经营环境、公司自身的经营状况和资本充足水平，以更好地平衡长远良性发展和投资者即期回报的关系，兼顾投资者的当期收益和远期利益。感谢您的关注！",
        "answerdate": "20231026",
        "id": "1218659"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行破净如此厉害，大股东和董事会的担当呢？为什么不能出来增持？",
        "questondate": "20231012",
        "answerer": "浦发银行",
        "answer": "公司无相关应披露而未披露事项。感谢您的关注！",
        "answerdate": "20231026",
        "id": "1211598"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_n189iJLrn",
        "question": "恒大欠浦发92亿，属实吗？",
        "questondate": "20231009",
        "answerer": "浦发银行",
        "answer": "公司积极贯彻落实国家及监管有关房地产贷款政策要求，重点支持刚需及改善型住房按揭信贷需求，助力房地产市场健康发展。感谢您的关注！",
        "answerdate": "20231026",
        "id": "1208296"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_LQX6Kokp5",
        "question": "公司既然不能回购，那是不是可以动员有实力的股东增持，以及高管带头增持，起码有点作为啊！别的银行很多高管都增持了。虽然资金量不大，起码也是个表率作用啊！难道贵公司高管对自己公司都这么不看好？一手都不想增持？请把重视投资者利益用实际行动体现！",
        "questondate": "20230920",
        "answerer": "浦发银行",
        "answer": "公司高管目前合计持有65.96万股的公司股票。感谢您的关注！",
        "answerdate": "20230925",
        "id": "1203832"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_FnHgZ5VPq",
        "question": "公司股东人数是多少？",
        "questondate": "20230922",
        "answerer": "浦发银行",
        "answer": "截至2023年6月末，公司普通股股东总数为201,993户。感谢您的关注！",
        "answerdate": "20230925",
        "id": "1205116"
    }, {
        "symbol": "600000.sh",
        "questioner": "koseii",
        "question": "上周美国硅谷银行破产后，股民十分关切浦发硅谷后续事宜，作为股东方的浦发银行周末、周一均未回应，但某上市公司及时公告与硅谷银行相关事宜，高低立判高下，作为浦发硅谷的股东，此次硅谷银行事件对上市公司是否存在利益损害，请于正面回应。",
        "questondate": "20230314",
        "answerer": "浦发银行",
        "answer": "浦发硅谷银行有限公司成立于2012年8月，现注册资本20亿元人民币，公司持有其50%的股份。截至2023年6月末，浦发硅谷银行资产总额231.71亿元，净资产20.69亿元。上半年，浦发硅谷实现营业收入4.01亿元，净利润0.52亿元。感谢您的关注！",
        "answerdate": "20230925",
        "id": "1112385"
    }, {
        "symbol": "600000.sh",
        "questioner": "蓝白123",
        "question": "请正面直接回答浦发银行是否与上海联交所或上海交易集团存在股权或业务及战略合作方面关联？不要所答非所问！",
        "questondate": "20230920",
        "answerer": "浦发银行",
        "answer": "公司广泛开展与金融同业、要素市场等机构的合作。感谢您的关注！",
        "answerdate": "20230925",
        "id": "1203818"
    }, {
        "symbol": "600000.sh",
        "questioner": "shagnhaixhh",
        "question": "请问董秘，公司今年业绩如何？",
        "questondate": "20230914",
        "answerer": "浦发银行",
        "answer": "公司详细经营情况参见公司发布的定期报告。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1201263"
    }, {
        "symbol": "600000.sh",
        "questioner": "shagnhaixhh",
        "question": "公司股东人数多少？",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "截至2023年6月末，公司普通股股东总数为201,993户。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1199370"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_FnHgZ5VPq",
        "question": "股东人数有增加吗？",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "截至2023年6月末，公司普通股股东总数为201,993户。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1198647"
    }, {
        "symbol": "600000.sh",
        "questioner": "蓝白123",
        "question": "请问浦发银行是否与上海联交所或上海交易集团存在股权或业务及战略合作方面关联？",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "公司加快推进客户全面经营，提升综合金融服务能力，进一步夯实客户基础。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1199000"
    }, {
        "symbol": "600000.sh",
        "questioner": "wpef",
        "question": "你好:近期公司多位高管辞职,管理层出现大变动.作为小投资者是否可以提名公司高管?如果可以我提请公司任命公司第二大股东富德生命人寿的张峻先生出任公司董事长.\n17年之前公司在全国股份制商业银行第一阵营排名前三(兴业、招商、浦发），公司16年分红送股，增发吸并上海信托前后，股价在资本市场一度领先招商、兴业。如今招行一骑绝尘，平安光大后来居上。公司市净率不足0.35倍，个人认为和公司任命的管理层能力有很大关系。谢谢！",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "提名董事和聘任高管需履行相应的程序。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1198755"
    }, {
        "symbol": "600000.sh",
        "questioner": "shagnhaixhh",
        "question": "公司股东人数多少？",
        "questondate": "20230907",
        "answerer": "浦发银行",
        "answer": "截至2023年6月末，公司普通股股东总数为201,993户。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1197539"
    }, {
        "symbol": "600000.sh",
        "questioner": "shagnhaixhh",
        "question": "公司业绩如何了？",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "公司详细经营情况参见公司发布的定期报告。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1198631"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_FnHgZ5VPq",
        "question": "公司经营情况怎么样？",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "公司详细经营情况参见公司发布的定期报告。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1198646"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_FnHgZ5VPq",
        "question": "目前住房贷款提前还贷的压力情况如何？",
        "questondate": "20230911",
        "answerer": "浦发银行",
        "answer": "公司聚焦服务民生、支持实体经济，推动个人住房贷款平稳发展。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1198935"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "你好！董秘！前期中国证监会会议提出有关长期股价低于每股净资产的上市公司问题提到，要求上市公司提市值管理方案。请问。浦发银行公司对于股价长期低于每股净资产的市值方案。董事会总经理是否有明确的制定方案的设计思考。",
        "questondate": "20230906",
        "answerer": "浦发银行",
        "answer": "公司股价受到证券市场等多方面的影响，将持续关注公司股票在资本市场的交易情况。2023年，公司将围绕经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1196482"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_LQX6Kokp5",
        "question": "董秘您好！贵公司可转债2025年到期，现在离转股价还有6元左右，况且新出的中报偏空。请问贵公司是否应该考虑进行股票分批回购来提升股价，切合实际的促进股价回升、促进转股？虽占用资本金，但是总不能宁可可转债到期偿还本息也一点不回购吧？希望贵公司能用实际行动让投资者看到管理层的职责与作为！",
        "questondate": "20230905",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的关注！",
        "answerdate": "20230914",
        "id": "1195739"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_gDLXl9tlh",
        "question": "存量房贷款利率下调对利润影响大不大",
        "questondate": "20230901",
        "answerer": "浦发银行",
        "answer": "公司积极落实相关监管要求，依法有序推进调整存量首套住房商业性个人住房贷款利率工作。存量房贷利率下降会对公司营收产生一定影响。 感谢您的关注！",
        "answerdate": "20230914",
        "id": "1194229"
    }, {
        "symbol": "600000.sh",
        "questioner": "Lily呀",
        "question": "你好，请问截止今年八月底，股东人数有多少？",
        "questondate": "20230904",
        "answerer": "浦发银行",
        "answer": "公司半年报披露截至2023年6月末，公司普通股股东总数为201,993户。感谢您的关注！",
        "answerdate": "20230904",
        "id": "1195014"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_LQX6Kokp5",
        "question": "董秘您好！贵公司股价截止9月1日收盘为7.01元，而可转债的转股价为13.24元，2025年就到期了。请问公司到底希不希望投资者债转股?还是公司已经做好了到不了转股价而到期偿还本息的打算？",
        "questondate": "20230904",
        "answerer": "浦发银行",
        "answer": "公司将持续做好经营管理夯实转股基础，同时进一步推进市场对公司的价值认同，努力提振股价表现，促进可转债转股，补充公司核心一级资本。感谢您的关注！",
        "answerdate": "20230904",
        "id": "1194628"
    }, {
        "symbol": "600000.sh",
        "questioner": "学习者1988",
        "question": "根据《国有企业、上市公司选聘会计师事务所管理办法》，公司是否需要进行会计师轮换，还是公司不属于国有企业，不适用该办法",
        "questondate": "20230830",
        "answerer": "浦发银行",
        "answer": "公司将严格执行有关规定，连续聘用同一会计师事务所年限不超过8年。公司于2019年选聘毕马威华振会计师事务所（特殊普通合伙）为公司提供审计服务至今。感谢您的关注！",
        "answerdate": "20230904",
        "id": "1193125"
    }, {
        "symbol": "600000.sh",
        "questioner": "Zzjeremy",
        "question": "公司股东户数",
        "questondate": "20230828",
        "answerer": "浦发银行",
        "answer": "截至2023年6月末，公司普通股股东总数为201,993户。感谢您的关注！",
        "answerdate": "20230904",
        "id": "1191411"
    }, {
        "symbol": "600000.sh",
        "questioner": "amay1106",
        "question": "浦发银行(600000)什么时候能完全开放T+0？",
        "questondate": "20230904",
        "answerer": "浦发银行",
        "answer": "公司证券的交易规则以上海证券交易所的相关规定为准。感谢您的关注！",
        "answerdate": "20230904",
        "id": "1194812"
    }, {
        "symbol": "600000.sh",
        "questioner": "蓝白123",
        "question": "尊敬的董秘：贵公司股票为何价值如此低估却得不到市场认可，股价距离历史最低位6.41元不到10%，请问1.贵公司发布的财务报表数据是否真实？2.是否存在已知的而未披露的重大利空事项。俗称的“雷”。",
        "questondate": "20230904",
        "answerer": "浦发银行",
        "answer": "公司披露的定期报告真实、准确、完整，不存在虚假记载、误导性陈述或者重大遗漏。公司无应披露而未披露的重大事项。感谢您的关注！",
        "answerdate": "20230904",
        "id": "1194621"
    }, {
        "symbol": "600000.sh",
        "questioner": "wpef",
        "question": "你好:公司2023年半年度业绩快报显示公司每股净资产20.55元,多家券商最新指标显示公司每股净资产24.29元,这种情况对投资者投资公司判断公司市净率造成困扰.在2022年年报时也出现过类似情况.请问是什么原因造成这种数据的不同,公司2023年中报每股净资产实际数据是什么情况.谢谢!",
        "questondate": "20230823",
        "answerer": "浦发银行",
        "answer": "截至2023年半年末，公司归属于母公司普通股股东的每股净资产为20.55元。相关财务数据和指标请以公司披露为准。感谢您的关注！",
        "answerdate": "20230828",
        "id": "1189668"
    }, {
        "symbol": "600000.sh",
        "questioner": "chen600273",
        "question": "请董秘咨询一下大股东，通过现金收购方式确立公司主营业务优质资产年内会启动吗？",
        "questondate": "20230825",
        "answerer": "浦发银行",
        "answer": "公司无应披露而未披露的重大事项。感谢您的关注！",
        "answerdate": "20230828",
        "id": "1190784"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "研究对于破发或破净的上市公司和行业，适当限制其融资活动，要求其提出改善市值的方案。作为市净率最低的几家上市公司之一，贵行是否有改善市值的方案？",
        "questondate": "20230823",
        "answerer": "浦发银行",
        "answer": "公司股价受到证券市场等多方面的影响，将持续关注公司股票在资本市场的交易情况。2023年，公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230828",
        "id": "1189579"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_Ho27G0EfQ",
        "question": "尊敬的董秘您好！7月23日14时52分，齐齐哈尔市第三十四中学体育馆发生屋顶坍塌事故，这是齐齐哈尔近年来最为严重的安全事故，这起事故暴露出安全隐患排查不到位、安全监管不到位、企业安全主体责任落实不到位等问题。根据齐齐哈尔市上市公司以往公告，贵银行在齐齐哈尔市有贷款业务。请问贵银行是否关注贷款客户的生产安全风险？此次事故是否会影响贵银行对齐齐哈尔市贷款客户的风险评估？",
        "questondate": "20230725",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20230828",
        "id": "1177409"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_TWSGK3n5u",
        "question": "浦发银行有证券公司吗",
        "questondate": "20230731",
        "answerer": "浦发银行",
        "answer": "公司全资子公司浦银国际控股有限公司，注册地址为香港，拥有香港证监会颁发的第一类“证券交易”、第四类“就证券提供意见”、第六类“就机构融资提供意见”、第九类“资产管理”、保荐上市及证券经纪业务等受规管活动许可，为客户提供包括上市保荐、收购兼并、债券承销、财务顾问、投资管理、企业融资顾问、资产管理、投资咨询等综合化、多元化金融服务。公司未参股境内证券公司。感谢您的关注！",
        "answerdate": "20230822",
        "id": "1179098"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_jzOS9Ar7o",
        "question": "请问：贵司2023年的半年财报，为何大幅提高拨备覆盖率这一指标？",
        "questondate": "20230810",
        "answerer": "浦发银行",
        "answer": "公司​坚持风险“控新降旧”并举，持续加大存量不良资产处置力度，风险压降成效显著。公司积极防范信用风险，对客户进行前瞻性的减值计提，不断增强风险抵补能力。感谢您的关注！",
        "answerdate": "20230822",
        "id": "1184408"
    }, {
        "symbol": "600000.sh",
        "questioner": "T_0",
        "question": "什么时候能完全开放T+0？",
        "questondate": "20230814",
        "answerer": "浦发银行",
        "answer": "​感谢您的关注！",
        "answerdate": "20230822",
        "id": "1185455"
    }, {
        "symbol": "600000.sh",
        "questioner": "Haward",
        "question": "您好，按照证监会的《公开发行证券的公司信息披露内容与格式准则第2号——年度报告的内容与格式》规定，公司应当以汇总方式披露公司向前5名客户销售额占年度销售总额的比例，以及前5名供应商采购额占年度采购总额的比例。但是我在贵公司2018年、2020年的年报中并没有找到前五名客户、前五名供应商的合计比例数据,请问没有披露的具体原因是什么？",
        "questondate": "20230816",
        "answerer": "浦发银行",
        "answer": "根据证监会的相关规定，商业银行等行业的上市公司，应当执行中国证监会制定的特殊行业或业务信息披露特别规定。公司遵照相关信息披露要求，适用银行行业规范，编制、披露年度报告，详见公司历年《年度报告》。感谢您的关注！",
        "answerdate": "20230822",
        "id": "1186528"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_qLSqzZpQ6",
        "question": "董秘你好，请问贵行是否与中融信托或中植系相关产品和公司有业务往来？风险敞口是多少？网络流传贵行广州分行与中植系控制的皓宸医疗有信托计划关联，请问是否属实？风险敞口情况怎样？",
        "questondate": "20230817",
        "answerer": "浦发银行",
        "answer": "公司始终坚持以客户为中心，不断增强金融市场业务经营水平和投资交易能力，强化风险合规管控。感谢您的关注！",
        "answerdate": "20230822",
        "id": "1187085"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_gcrqrsNa5",
        "question": "董秘好，2023年年中业绩快报显示让股东震惊，让同业震惊。贵行营收和净利润连续多年双降，特别是今年净利润同比下降超过20%。近几年贵行一直宣称坚定执着，夯实基础，转换模式，融合经营，打赢业绩增长突围战，从结果上看，您认为贵行业绩执行怎么样，效果怎么样，是否合格？贵行董事会是否有能力继续履行掌舵的能力？作为国资大行，连续多年下降就是不进则退，是否做到了守护国有资产不流失的底线？谢谢！",
        "questondate": "20230817",
        "answerer": "浦发银行",
        "answer": "今年以来，公司聚焦“十四五”战略规划，持续推进轻型化、“双碳”、数字化三大转型，紧紧围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，坚持长期主义、保持战略定力，积极服务实体经济，受资产重定价、市场利率下行、资本市场波动等影响，营业收入和净利润阶段性负增长。下半年公司将继续扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230822",
        "id": "1187204"
    }, {
        "symbol": "600000.sh",
        "questioner": "苏琪",
        "question": "回公司房贷金额占比贷款总额是多少？",
        "questondate": "20230821",
        "answerer": "浦发银行",
        "answer": "公司积极贯彻落实国家及监管有关房地产贷款政策要求，重点支持刚需及改善型住房按揭信贷需求，助力房地\n产市场健康发展，具体可参见公司定期报告中有关按行业划分的贷款结构信息，感谢您的关注！",
        "answerdate": "20230822",
        "id": "1188607"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行可转债发行快四年，股价跌了四年，可转债转股遥遥无期，贵行董事会是否有预案？",
        "questondate": "20230728",
        "answerer": "浦发银行",
        "answer": "公司未来将继续行积极推动可转债转股，通过良好的经营夯实转股基础，同时进一步推进市场对公司的价值认同，努力提振股价表现，促进可转债转股，补充公司核心一级资本，为公司后续业务发展奠定坚实基础。感谢您的关注！",
        "answerdate": "20230803",
        "id": "1178637"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "董事会睁开眼睛来看看吧，今天银行业涨那么多，贵行涨幅倒数第四，贵行长期涨的时候倒数，跌的时候前排跌，所以导致贵行跌了好多年，贵行董事会不做点什么吗？",
        "questondate": "20230731",
        "answerer": "浦发银行",
        "answer": "公司持续关注公司股票在资本市场的交易情况，公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230803",
        "id": "1178896"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_LWgbRJlxJ",
        "question": "尊敬的董秘你好，贵行的每股净资产是20.48元，股价一直在十元以下徘徊，股息率也比较高，收益率很稳定，估值却迟迟得不到修复，这是为什么呢？这么高的市净值，这么低的股价，回购股票的利润远比放贷款的收益率高很多倍，贵行为什么不做大量回购？",
        "questondate": "20230724",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的关注！",
        "answerdate": "20230803",
        "id": "1176555"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "你好！董秘：请问。有关子公司转让上投摩根基金公司股权的的款项支付已经到账了。超过公司本期半年报收入的10%增长了吗。应当及时发布信息披露，有利于投资者及时知晓投资信息。谢谢。",
        "questondate": "20230714",
        "answerer": "浦发银行",
        "answer": "请参见前述回答，谢谢。",
        "answerdate": "20230719",
        "id": "1173001"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好！董秘：请问。有关子公司转让上投摩根基金公司股权的变更登记后的款项支付已经到账了吗。超过本期年报收入的10%增长了吗。应当即使发布信息披露，有利于投资者即使知晓投资信息。谢谢。",
        "questondate": "20230711",
        "answerer": "浦发银行",
        "answer": "2023年4月3日，上投摩根股权转让交割完成。相关事项详见公司2023年4月5日发布的《关于投资企业股权转让交割完成的公告》。感谢您的关注！",
        "answerdate": "20230719",
        "id": "1171552"
    }, {
        "symbol": "600000.sh",
        "questioner": "爬山的牛",
        "question": "公司可转债将于2025年到期，请问公司将采取什么措施，使公司在近两年内提升公司业债，完成可转债转股？",
        "questondate": "20230628",
        "answerer": "浦发银行",
        "answer": "公司未来将继续行积极推动可转债转股，通过良好的经营确保效益增长、夯实转股基础；同时进一步推进市场对公司的价值认同，努力提振股价表现，促进可转债转股，补充公司核心一级资本，为公司后续业务发展奠定坚实基础。感谢您的关注！",
        "answerdate": "20230703",
        "id": "1165726"
    }, {
        "symbol": "600000.sh",
        "questioner": "杨丽娟ylj",
        "question": "请问董秘，公司股东人数有多少？",
        "questondate": "20230629",
        "answerer": "浦发银行",
        "answer": "截至2023年3月31日，公司普通股股东总数为211,836户。感谢您的关注！",
        "answerdate": "20230703",
        "id": "1166516"
    }, {
        "symbol": "600000.sh",
        "questioner": "bowiefan",
        "question": "请提供贵司最新一期的股东人数",
        "questondate": "20230629",
        "answerer": "浦发银行",
        "answer": "截至2023年3月31日，公司普通股股东总数为211,836户。感谢您的关注！",
        "answerdate": "20230703",
        "id": "1166547"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行自从可转债发行后，股价连年下跌，业绩也连年下跌，银行业的奇葩，请问贵行董事会不在乎可转债能否转股成功吗？还是说指望像光大银行一样有白衣骑士亏钱转股？还是打算到期还钱吗？",
        "questondate": "20230627",
        "answerer": "浦发银行",
        "answer": "​公司未来将继续行积极推动可转债转股，通过良好的经营确保效益增长、夯实转股基础；同时进一步推进市场对公司的价值认同，努力提振股价表现，促进可转债转股，补充公司核心一级资本，为公司后续业务发展奠定坚实基础。感谢您的关注！",
        "answerdate": "20230703",
        "id": "1165179"
    }, {
        "symbol": "600000.sh",
        "questioner": "你好fff",
        "question": "由于股价连续下跌，是否存在退市风险评估？建议按股价净值分给每一位股东可好",
        "questondate": "20230601",
        "answerer": "浦发银行",
        "answer": "公司无退市计划。感谢您的关注！",
        "answerdate": "20230602",
        "id": "1153127"
    }, {
        "symbol": "600000.sh",
        "questioner": "不知道对错",
        "question": "我就非常纳闷公司是属于银行板块吗？看年线银行板块指数最近几年是一路向上！反观公司的股票价格走势一路向下！这是多么痛的对比？公司这些年忙着干什么呢？股票价格仅仅有净资产的三分之一左右？请问贵公司怎么给投资者们回报？难道就靠那点分红？这点可怜的分红与股票价格大幅下跌相比，好像大海的一滴水一样啊？",
        "questondate": "20230525",
        "answerer": "浦发银行",
        "answer": "公司股价受到证券市场等多方面的影响，将持续关注公司股票在资本市场的交易情况。2023年，公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230602",
        "id": "1148621"
    }, {
        "symbol": "600000.sh",
        "questioner": "不知道对错",
        "question": "贵公司的股票价格涨幅已经与银行板块严重脱离了吗？2023年银行板块指数上涨六点几，公司跌零的几，2022年银行板块跌2.35，公司跌14.65。2021年银行板块微跌0.29，公司又跌11.88。2020年银行板块跌3.48.公司大跌21.75。公司的股票难道要一直跌到退市了吗？公司的股票价格涨幅已经严重的反常了？很严重啊？",
        "questondate": "20230601",
        "answerer": "浦发银行",
        "answer": "公司股价受到证券市场等多方面的影响，将持续关注公司股票在资本市场的交易情况。2023年，公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230602",
        "id": "1152980"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_2HF8cBb4t",
        "question": "上交所将召开沪市金融业专题座谈会 讨论促进金融业估值提升 提问，贵公司能按上层的规则，提高分红比例嘛，多分一些",
        "questondate": "20230516",
        "answerer": "浦发银行",
        "answer": "公司在制定分红政策时，充分考虑行业发展情况、内外部经营环境、公司自身的经营状况和资本充足水平，以更好地平衡长远良性发展和投资者即期回报的关系，兼顾投资者的当期收益和远期利益。感谢您的关注！",
        "answerdate": "20230523",
        "id": "1144653"
    }, {
        "symbol": "600000.sh",
        "questioner": "不知道对错",
        "question": "一个公司的估值高低是市场认可程度所左右的？看公司的市场认可程度极低？这是为什么呢？看公司年线已经大幅下跌了七八年，投资者们是亏损累累？难道公司自己已经麻木了，对于投资者常年累月的大幅亏损不闻不问？你们难道就没有一点点措施来维护投资者们是权益？",
        "questondate": "20230523",
        "answerer": "浦发银行",
        "answer": "公司持续关注公司股票在资本市场的交易情况，公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230523",
        "id": "1147225"
    }, {
        "symbol": "600000.sh",
        "questioner": "AA",
        "question": "什么时候分红配股",
        "questondate": "20230516",
        "answerer": "浦发银行",
        "answer": "公司2022年度利润分配方案案尚待股东大会审议通过后方可实施。分配方式为现金分红，无转增股本。感谢您的关注！",
        "answerdate": "20230523",
        "id": "1144270"
    }, {
        "symbol": "600000.sh",
        "questioner": "文和",
        "question": "相较于同行而言公司利润率连年走低，同时分红和ROE也在同步走低，请问公司管理层是无作为还是无法有效作为？董监高的考核是否包含经营业绩及利润率水平？有什么实质有效的惩戒措施？",
        "questondate": "20230515",
        "answerer": "浦发银行",
        "answer": "公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230523",
        "id": "1143550"
    }, {
        "symbol": "600000.sh",
        "questioner": "王者无敌8",
        "question": "您好，请问贵司员工降薪事件后续如何？",
        "questondate": "20230517",
        "answerer": "浦发银行",
        "answer": "网传事件系一业务外包公司与所属员工之间存在劳动纠纷所致，目前该外包公司正与员工沟通解决。感谢您的关注！",
        "answerdate": "20230523",
        "id": "1144945"
    }, {
        "symbol": "600000.sh",
        "questioner": "只投银行股",
        "question": "近几日，网传因浦发银行经营困难，大幅降薪引发员工罢工维权，请董秘给予必要解答，切实保障投资人的知情权。",
        "questondate": "20230512",
        "answerer": "浦发银行",
        "answer": "网传事件系一业务外包公司与所属员工之间存在劳动纠纷所致，目前该外包公司正与员工沟通解决。感谢您的关注！",
        "answerdate": "20230523",
        "id": "1142827"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "受益于中国特色估值体系、低估值、高分红和高股息等原因，低估值的银行股近期大涨，贵行连续跌了七八年，还在低位，为什么反弹不起来呢？别的银行涨你跟不上，别的跌的时候你排前面，是什么原因呢？贵行董事会是否能购重视投资者建议，持续稳定分红，做好业绩？其他行分红逐年上升，贵行连年下跌，是否能稳定投资者预期？持续稳定分红而不是董事会决定？",
        "questondate": "20230508",
        "answerer": "浦发银行",
        "answer": "公司2022年度利润分配方案案尚待股东大会审议通过后方可实施。公司在制定分红政策时，充分考虑行业发展情况、内外部经营环境、公司自身的经营状况和资本充足水平，以更好地平衡长远良性发展和投资者即期回报的关系，兼顾投资者的当期收益和远期利益。后续，公司将围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，扎实推动各项工作的落实，推进全行高质量发展，打赢业绩增长突围战，努力为股东创造更多价值。感谢您的关注！",
        "answerdate": "20230510",
        "id": "1140410"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_xUQ03Wfcp",
        "question": "根据贵司22年年报，贵司的信用卡中心人数为11975人，但其他可比同业的信用卡中心人数远低于贵司，如平安银行信用卡中心1992人、兴业银行信用卡中心1134人等，请问贵司的卡中心运营是否存在冗员，影响降本增效的现象，为何与同业相差这么多",
        "questondate": "20230424",
        "answerer": "浦发银行",
        "answer": "公司披露的信用卡中心人数包含了正式和非正式用工数量。感谢您的关注！",
        "answerdate": "20230510",
        "id": "1133362"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行营收连年下跌，今年一季报利润都下跌百分之二十左右，应该是股份行最差，请问贵行领导层干什么的呢？不搞搞业绩吗？",
        "questondate": "20230504",
        "answerer": "浦发银行",
        "answer": "公司将紧紧围绕“坚定执着、夯实基础、转换模式、融合经营”的经营主线，积极推进“十四五”战略规划实施，狠抓重点领域基础管理，持续推进业务结构调整，加快推动经营模式转换。感谢您的关注！",
        "answerdate": "20230510",
        "id": "1137392"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "国有大行和很多有担当的股份行都建立了绩效薪酬延期支付及追索扣回机制，请问贵行业绩越来越差，是不是因为缺乏绩效薪酬延期支付及追索扣回机制？所以导致干好干坏一个样，所以与招行，兴业差距越来越大？",
        "questondate": "20230417",
        "answerer": "浦发银行",
        "answer": "公司的薪酬制度中包含绩效薪酬延期支付和追索扣回相关规定，对员工发生违规处分或信贷风险事件等情况，根据问责处理决定，扣减当期或递延薪酬。对银行风险有重要影响岗位的员工，其延期支付薪酬不低于当年绩效薪酬总水平的40%且延付期限不少于3年。感谢您的关注！",
        "answerdate": "20230424",
        "id": "1128970"
    }, {
        "symbol": "600000.sh",
        "questioner": "杨丽娟ylj",
        "question": "请问公司股东人数是多少？",
        "questondate": "20230406",
        "answerer": "浦发银行",
        "answer": "截至2023年3月末，公司普通股股东总数为211,836户。感谢您的关注！",
        "answerdate": "20230424",
        "id": "1124218"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "您好。董秘。中小股东希望董事会对于2022年度的股份分红，不要吝啬了。不要让中小股东太失望。一定要超过30%以上的利润占比实施分红。请转告董事会各位。谢谢。",
        "questondate": "20230413",
        "answerer": "浦发银行",
        "answer": "公司高度重视投资者利益，致力于为股东提供持续性回报。公司认真听取了投资者的意见，考虑到投资者分享公司成长和发展成果、取得合理投资回报等诉求，同时兼顾公司未来业务发展、市场约束以及监管要求，适当增加了内生资本的留存。具体详见公司《2022年度利润分配的方案公告》。感谢您的关注！",
        "answerdate": "20230424",
        "id": "1127348"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "分红从0.6，0.48，0.41,今年将至0.32请问为什么不向其他行学习，稳步增长，贵行反而大幅下降，请问贵行领导层是都不作为？经营不善？社会责任感呢？",
        "questondate": "20230419",
        "answerer": "浦发银行",
        "answer": "公司高度重视投资者利益，致力于为股东提供持续性回报。公司认真听取了投资者的意见，考虑到投资者分享公司成长和发展成果、取得合理投资回报等诉求，同时兼顾公司未来业务发展、市场约束以及监管要求，适当增加了内生资本的留存。具体详见公司《2022年度利润分配的方案公告》。感谢您的关注！",
        "answerdate": "20230424",
        "id": "1130299"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_yDDGmZhp5",
        "question": "1\\. 根据证监会《公司债券发行与交易管理办法》，证券交易所收到注册申请文件后，在5个工作日内作出是否受理的决定。 2\\. 根据交易所《公司债券发行上市审核规则》，交易所收到发行上市申请文件后，在2个工作日内对申请文件是否齐备和是否符合规定形式要求进行核对。 请问实操中证券交易应当在5个还是2个工作日内作出是否受理的决定？谢谢",
        "questondate": "20230406",
        "answerer": "浦发银行",
        "answer": "投资者您好，请向有关部门进行咨询。感谢您的关注！",
        "answerdate": "20230411",
        "id": "1123349"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_RzkBfEx0w",
        "question": "贵行收益这么高，今年会不会加大分红力度加大回馈股东？",
        "questondate": "20230324",
        "answerer": "浦发银行",
        "answer": "公司制定利润分配方案将充分考虑考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20230411",
        "id": "1117257"
    }, {
        "symbol": "600000.sh",
        "questioner": "一言",
        "question": "2022年公司放贷总额等都在提高，为何利润在下降，具体原因是什么？公司调整优化了这么多年，利润应该提高才对，优化变成劣化了？另外公司员工的年平均工资水平46万多，员工收入在银行排名第16位，而利润水平好像排在30多位，这种错位公司有内部制度约束吗？何时得以改变？",
        "questondate": "20230330",
        "answerer": "浦发银行",
        "answer": "公司当前正处于转型发展的重要阶段，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，发挥长三角区位优势，打造“轻型银行、绿色银行、全景银行”，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20230411",
        "id": "1120112"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_RzkBfEx0w",
        "question": "请问贵公司近期是否有重大事项未公布？",
        "questondate": "20230323",
        "answerer": "浦发银行",
        "answer": "公司无应披露而未披露的重大事项。感谢您的关注！",
        "answerdate": "20230329",
        "id": "1116682"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_RzkBfEx0w",
        "question": "请问贵行每股收益这么高，股价这么低，近期有没股份回购计划？还是说贵行有重大亏损或违法犯罪行为？",
        "questondate": "20230321",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的关注！",
        "answerdate": "20230329",
        "id": "1115866"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好！公司的浦惠到家有境外境内旅游可贷款产品吗？",
        "questondate": "20230310",
        "answerer": "浦发银行",
        "answer": "您可以下载并登录“浦惠到家”APP，查询有关产品情况。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110854"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好!公司的浦惠到家有海内外学习贷款产品吗？谢谢！",
        "questondate": "20230310",
        "answerer": "浦发银行",
        "answer": "您可以下载并登录“浦惠到家”APP，查询有关产品情况。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110858"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好！公司浦惠到家电商平台会发展成亚马逊世界级的电商模式吗，谢谢！",
        "questondate": "20230309",
        "answerer": "浦发银行",
        "answer": "“浦惠到家”平台是公司专注于打造“惠生活，更会生活”理念的智能型 APP，基于商户及物业板块功能，有效整合线上和线下资源，为用户提供优质的商品、权益以及便捷的生活服务。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110340"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好！公司的浦惠到家有\"红娘牵线平台吗″因为存款人与贷款人有这个市场需求，希望有青中老这个红娘牵线平台作为购物商品推广，建立各年龄人民的婚姻信息需求商品谢谢！",
        "questondate": "20230309",
        "answerer": "浦发银行",
        "answer": "您可以下载并登录“浦惠到家”APP，查询有关产品情况。感谢您的建议！",
        "answerdate": "20230317",
        "id": "1110344"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好！公司的浦惠到家有音乐商品购买下载吗？谢谢！",
        "questondate": "20230309",
        "answerer": "浦发银行",
        "answer": "您可以下载并登录“浦惠到家”APP，查询有关产品情况。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110358"
    }, {
        "symbol": "600000.sh",
        "questioner": "koseii",
        "question": "地处上海，辐射长三角，如此先天优势，请问造成经营业绩下滑以及风险管控不利的主要原因有哪些？",
        "questondate": "20230313",
        "answerer": "浦发银行",
        "answer": "公司加强转型发展、调整业务结构、强化风险压降，经营效益稳中略降。公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1111905"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好！浦发银行与外国金融消费顾客在业务办理结算怎样建立良好快速联系的？是用大数据云存储技术？谢谢！",
        "questondate": "20230309",
        "answerer": "浦发银行",
        "answer": "公司加强数字科技应用，提升消保管理效率和水平，努力实现“价值共创”。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110631"
    }, {
        "symbol": "600000.sh",
        "questioner": "刘俊生",
        "question": "中移动做为浦发笫二大持股股东，中移动股价天天创新高，浦发银行为什么一直停止不涨呢？",
        "questondate": "20230310",
        "answerer": "浦发银行",
        "answer": "公司股价受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2023年，公司将继续推进完成各项经营目标任务，促进价值提升。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110892"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行2019到2021业绩1.95+1.88+1.62合计5.45分红0.6+0.48+0.41合计1.49占比不足百分之28.与公司章程(最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十)不符合，为什么呢？",
        "questondate": "20230306",
        "answerer": "浦发银行",
        "answer": "参照中国证监会的相关规定，公司章程明确“除特殊情况外，最近三年对普通股股东现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十”。其中，分配的利润为三年累计，而可分配利润的计算则为年均。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1108339"
    }, {
        "symbol": "600000.sh",
        "questioner": "清竹",
        "question": "一家年赚10亿多的上市央企天坛生物的董秘工资有数百万元年薪，为何贵公司年赚千亿级别的董秘年薪却少得可怜，是否有提高待遇打算？留住人才。",
        "questondate": "20230315",
        "answerer": "浦发银行",
        "answer": "公司的薪酬政策与本公司的发展战略、经营计划、企业文化相一致，与公司治理要求和行业监管要求相统一，坚持“支撑战略、激励人才、市场导向、结构清晰、绩效导向、约束并重”的薪酬管理原则。在公司领薪的董事、监事、高级管理人员的薪酬政策依据主管部门相关规定制定，经董事会提名与薪酬考核委员会审核，并报董事会审议通过。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1113246"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_CJoTSR3Hi",
        "question": "您好！浦惠到家有保险产品购买吗？比如说车险，出国旅游险，，，，谢谢！",
        "questondate": "20230309",
        "answerer": "浦发银行",
        "answer": "您可以下载并登录“浦惠到家”APP，查询有关产品情况。感谢您的关注！",
        "answerdate": "20230317",
        "id": "1110445"
    }, {
        "symbol": "600000.sh",
        "questioner": "小小股民",
        "question": "请问公司说持续加大处置不良，请问这些要大量处的不良是哪里来的，公司以前的风控是摆设吗？",
        "questondate": "20230227",
        "answerer": "浦发银行",
        "answer": "近年来，公司持续加强风险管理，严格不良贷款分类管理，着力夯实资产质量基础。公司不断加快不良资产处置节奏，推动风险化解工作取得突破，从源头上优化资产质量，提升全面风险管理能力。感谢您的关注！",
        "answerdate": "20230303",
        "id": "1105810"
    }, {
        "symbol": "600000.sh",
        "questioner": "小小股民",
        "question": "请问贵行的股东回报规划是如何描述分红的。",
        "questondate": "20230227",
        "answerer": "浦发银行",
        "answer": "公司终坚持为股东创造价值的核心发展理念，致力于为股东提供持续、稳定的回报，让投资者分享公司价值增长成果。《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。感谢您的关注！",
        "answerdate": "20230303",
        "id": "1105834"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_4F8AyYnY2",
        "question": "公司一直强调正处转型发展的重要阶段，请问董秘公司这几年转型在原地空转吗？估值要突出重围是否要等到2049年？曾经和招行平齐平坐的浦发在哪里？",
        "questondate": "20230215",
        "answerer": "浦发银行",
        "answer": "近年公司持续推进业务结构转型和优化，加大支持实体经济力度，坚持风险“控新降旧”并举，持续加大存量不良资产处置力度，资产质量稳步夯实。未来，公司将继续聚焦“十四五”战略规划，加快推进轻型化、“双碳”、数字化三大转型，全力推进各项经营管理工作提质增效。感谢您的建议！",
        "answerdate": "20230220",
        "id": "1101274"
    }, {
        "symbol": "600000.sh",
        "questioner": "koseii",
        "question": "公司是否有增持或回购股票计划？",
        "questondate": "20230215",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。公司无应披露而未披露的股东增持计划。感谢您的关注！",
        "answerdate": "20230215",
        "id": "1100753"
    }, {
        "symbol": "600000.sh",
        "questioner": "koseii",
        "question": "公司一直强调正处转型发展的重要阶段，还提出“争取在新的银行估值体系中突出重围”但近几年未曾看到实质变化，PB0.37(行业倒数第三）、不良1.53%（倒数第七）、拨备155%（倒数第三）,请问董秘公司这几年转型在原地空转吗？估值要突出重围是否要等到2049年？曾经和招行平齐平坐的浦发在哪里？",
        "questondate": "20230210",
        "answerer": "浦发银行",
        "answer": "近年公司持续推进业务结构转型和优化，加大支持实体经济力度，坚持风险“控新降旧”并举，持续加大存量不良资产处置力度，资产质量稳步夯实。未来，公司将继续聚焦“十四五”战略规划，加快推进轻型化、“双碳”、数字化三大转型，全力推进各项经营管理工作提质增效。感谢您的建议！",
        "answerdate": "20230215",
        "id": "1099546"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "董秘您好。提请公司赶快发布2022年度快报，还有一个问题。注册制开启了。子公司浦发硅谷银行应该争取发行新股上市。无论是以科创板，或者主板，从财报上看。基本也符合条件了。董事会应该积极作为，谢谢。",
        "questondate": "20230206",
        "answerer": "浦发银行",
        "answer": "公司不断强化集团协同力度，推动子公司高质量发展。感谢您的建议！",
        "answerdate": "20230208",
        "id": "1096642"
    }, {
        "symbol": "600000.sh",
        "questioner": "zrf",
        "question": "董秘还是敬业的，回复问题及时。浦发银行上市二十多年了，公司业绩很好，净资产也是年年增长，就是股价下跌的厉害。我的问题是，公司已经过了成长期了，为什么不能稳健经营，每年像中石油一样分红，比例百分之五十五，每年分红二次？公司中层领导很多吧，比如分行，支行领导，为什么不能要求他们增持公司股份，拿那么高的工资，低位增持公司股份不应该吗？跟公司的发展捆绑。",
        "questondate": "20230117",
        "answerer": "浦发银行",
        "answer": "​​公司每年利润分配方案的制定，需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求，《公司章程》亦明确“​除特殊情况外，最近三年对普通股股东现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十”；此外公司高级管理层也多次增持公司股份，增进管理层与股东利益更趋一致。感谢您的建议！",
        "answerdate": "20230130",
        "id": "1093032"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行，贵行下跌再行，上涨外行，所以导致贵行严重滞后大盘和银行业指数，贵行领导是否反思为什么吗？",
        "questondate": "20230116",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2023年，公司将继续推进完成各项经营目标任务，促进价值提升。感谢您的关注！",
        "answerdate": "20230117",
        "id": "1092501"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "2022年11月至2023年1月16日，A股银行板块累计涨幅达19.60%，请问贵行呢？",
        "questondate": "20230117",
        "answerer": "浦发银行",
        "answer": "公司高度重视股东对股价的合理诉求，将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20230117",
        "id": "1092857"
    }, {
        "symbol": "600000.sh",
        "questioner": "zrf",
        "question": "请问董秘，之前公司高管高调增持公司股份，现在股价大幅下跌，为何看不到公司高管增持了呢？公司现在的基本面出现问题了吗？长期持有公司股份的小股东该如何对待公司股价长期下跌呢？",
        "questondate": "20230112",
        "answerer": "浦发银行",
        "answer": "公司高管目前合计持有129.06万股的公司股票，这也形成了我们的一项激励机制，促进管理层与广大投资者利益更趋一致，持续向市场传递了公司管理层对未来发展的信心。公司当前经营正常，未来将加快 “轻型银行”“绿色银行”“全景银行”建设，强化风险防控，以高质量发展推动估值提升；同时，公司将进一步加强与市场的沟通，为股东持续提供稳定回报，完善价值传递。感谢您的关注！",
        "answerdate": "20230117",
        "id": "1091401"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行业绩近几年越来越差，招行等其他行越来越好，贵行是否考虑，从其他优秀行引进人才，向优秀行学习呢？",
        "questondate": "20230112",
        "answerer": "浦发银行",
        "answer": "公司牢固树立“以人为本，知人善任”的人才观，紧紧围绕全行发展战略目标，加强人才梯队建设，推动整体素质进一步提升，努力构建任人唯贤、唯才是用的管理机制和制度环境。感谢您的关注！",
        "answerdate": "20230117",
        "id": "1091069"
    }, {
        "symbol": "600000.sh",
        "questioner": "琴姐",
        "question": "浦发银行(600000) 您好，此前国内外多家媒体、报纸均报道“凤凰卫视”旗下的“凤凰金融”诈骗7万个家庭约100亿人民币，并提供了相应的证据。请问贵司与诈骗集团“凤凰卫视、凤凰网”有商业合作吗？",
        "questondate": "20230110",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作。感谢您的关注！",
        "answerdate": "20230110",
        "id": "1089306"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_IwdK7hw91",
        "question": "您好，此前国内外多家媒体、报纸均报道“凤凰卫视”旗下的“凤凰金融”诈骗7万个家庭约100亿人民币，并提供了相应的证据。内地多家企事业单位得知此消息后第一时间便停止了与凤凰卫视、凤凰网的合作，请问贵司与诈骗集团“凤凰卫视、凤凰网”有商业合作吗？",
        "questondate": "20230106",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作。感谢您的关注！",
        "answerdate": "20230110",
        "id": "1089052"
    }, {
        "symbol": "600000.sh",
        "questioner": "凤凰网金融",
        "question": "请问贵公司有与凤凰（黄）网（卫视）业务吗，凤凰金融在海南暴雷，怕影响投资股价？",
        "questondate": "20221220",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作。感谢您的关注！",
        "answerdate": "20230103",
        "id": "1081623"
    }, {
        "symbol": "600000.sh",
        "questioner": "@ooms_oops",
        "question": "尊敬的董事会（长）秘书，你好啊，贵司2019年发行的可转债，在第三年利率即将达到两厘，而公司八成五收入来自于『利息差』，目前储蓄~放贷业务之间差距不足百分之二，加之房贷可以「延期交付」，建议公司提前做好现金流动性管理准备！",
        "questondate": "20221219",
        "answerer": "浦发银行",
        "answer": "公司将做好相关的资金安排。感谢您的建议！",
        "answerdate": "20230103",
        "id": "1081146"
    }, {
        "symbol": "600000.sh",
        "questioner": "标识老股东",
        "question": "你好，请问贵公司最近有机构来调研吗？",
        "questondate": "20221220",
        "answerer": "浦发银行",
        "answer": "公司持续与各类投资者开展沟通交流。感谢您的关注！",
        "answerdate": "20230103",
        "id": "1081921"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "您好！董秘：提请董事会一定赶快发布2022年报快报。有利于市场稳定预期。董事会应当积极呵护公司价值。分配预案最好同时发布。笨鸟先飞的效果。",
        "questondate": "20221229",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！",
        "answerdate": "20230103",
        "id": "1085884"
    }, {
        "symbol": "600000.sh",
        "questioner": "多彩籽玉",
        "question": "近期贵公司的股价，似乎有无限的压力，每个交易日内盘绝大多数时间大于、甚至远大于外盘，跟跌却不怎么跟涨，基本面并不比同期差但股价接近十年最低，公司是否会于近期收购参股公司或是进行定增？",
        "questondate": "20221226",
        "answerer": "浦发银行",
        "answer": "公司无应披露而未披露的收购或定向增发计划。感谢您的关注！",
        "answerdate": "20230103",
        "id": "1084369"
    }, {
        "symbol": "600000.sh",
        "questioner": "乔哲",
        "question": "对比今年上半年上海疫情，公司认为下半年影响与之相比有什么区别？",
        "questondate": "20221222",
        "answerer": "浦发银行",
        "answer": "公司将努力克服新冠疫情持续不利影响，坚持转型发展，大力服务实体经济，稳步夯实高质量发展基础，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20230103",
        "id": "1083127"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_hZPpOdQjr",
        "question": "请问最新股东人数",
        "questondate": "20221108",
        "answerer": "浦发银行",
        "answer": "截至2022年9月30日，公司普通股股东总数为218,756户。感谢您的关注！",
        "answerdate": "20221117",
        "id": "1061448"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行股价连跌七八年，贵行董事会无动于衷吗？前几年高价董事会还增持一下，如今跌了那么多还不增持吗？",
        "questondate": "20221104",
        "answerer": "浦发银行",
        "answer": "公司高管目前合计持有129.06万股的公司股票，这也形成了我们的一项激励机制，促进管理层与广大投资者利益更趋一致，持续向市场传递了公司管理层对未来发展的信心。未来，公司将持之以恒推进战略执行，加快 “轻型银行”“绿色银行”“全景银行”建设，强化风险防控，以高质量发展推动估值提升；同时，公司将进一步加强与市场的沟通，为股东持续提供稳定回报，完善价值传递，争取在新的银行估值体系中突出重围，擦亮浦发银行这一金字招牌。感谢您的关注！",
        "answerdate": "20221117",
        "id": "1059852"
    }, {
        "symbol": "600000.sh",
        "questioner": "嘿大兄弟",
        "question": "据央行与银保监会消息，浦发银行入选我国2022年度系统重要性银行第二组。被分至哪一组对公司经营和业务开展带来的影响有哪些不同？公司将来是否有进一步提高系统重要性评分至第三组的考量？",
        "questondate": "20220913",
        "answerer": "浦发银行",
        "answer": "根据人民银行2021年10月首次公布的年度系统重要性银行名单，浦发银行入选第二组并适用0.5%的资本附加要求。公司将努力推动发展方式转型，持续优化风险加权资产配置效率，继续贯彻强化资本节约、资本集约的经营意识，持续提高资本使用效率，降低风险加权资产及资本耗用速度。同时，公司将继续稳妥、有序推进各类资本工具发行，持续丰富和完善资本补充渠道，增强资本实力、优化资本结构、控制资本成本，不断完善资本补充长效机制。感谢您的关注！",
        "answerdate": "20221104",
        "id": "1037072"
    }, {
        "symbol": "600000.sh",
        "questioner": "香香h",
        "question": "你好，请问什么时候可以恢复二手房贷款业务，停了两年了，这样对贵公司少了很多利息收入。",
        "questondate": "20221027",
        "answerer": "浦发银行",
        "answer": "公司正常开展按揭贷款业务。公司积极贯彻落实国家及监管政策要求，重点支持刚需及改善型住房按揭信贷需求，助力房地产市场健康发展。感谢您的关注！",
        "answerdate": "20221104",
        "id": "1056294"
    }, {
        "symbol": "600000.sh",
        "questioner": "金雪峰",
        "question": "贵公司的股价已不能反映其价值。回购注销是最好的反映价值的手段。不断的回购注销后每股净资产到1000元时，我不相信股价还在现在的价格。可是这又受政策的限制。贵公司能否向监管部门反映，把这一政策修改一下。让贵公司本用于分红的资金用来回购注销股票。",
        "questondate": "20221101",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的关注和建议！",
        "answerdate": "20221104",
        "id": "1058145"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "今年2月底曾就贵行所受处罚远高于自身业务的市场占比，而在此向公司进行提醒及建议，当时提请“贵行领导们不要喊口号，再认真、努力一些，争取两年内能有质的变化和飞跃”，如今半年多过去了，不知贵行内部是否认真接受了建议并进行了跟踪、对比？两年的要求应该不算高吧，至少最近看到贵行所受处罚的报导显示还没有好转的迹象。还剩一年多的时间，希望能从这个方面看出贵行的希望。",
        "questondate": "20221024",
        "answerer": "浦发银行",
        "answer": "公司将不??断完善公司治理结构，努力建设成为资本充足、内控严密、运营安全、效益良好的具有较强社会责任意识的现代金融服务企业。感谢您的建议！",
        "answerdate": "20221104",
        "id": "1055082"
    }, {
        "symbol": "600000.sh",
        "questioner": "喜欢八卦",
        "question": "能否简单介绍一下公司的RPA财务目前可以实现功能？和华为、阿里巴巴等互联网企业比，公司RPA财务有哪些差距？请问公司未来如何提升RPA财务智能化水平？谢谢！",
        "questondate": "20221013",
        "answerer": "浦发银行",
        "answer": "近年来，公司深耕新金融科技领域研究，运用RPA、OCR、API、大数据、云计算等技术，对财务管理进行了流程设计和系统建设，构建起联通内外、互动良好的财务数字生态圈。后续将通过自动化的数据采集、监测预警、逻辑算法等手段，不断开启以数据解析为支点、以分析结果为导向的财务管理新模式。感谢您的关注！",
        "answerdate": "20221104",
        "id": "1050797"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行，以前利润和招行差不多，如今连招行的一般都没有，是什么原因呢？",
        "questondate": "20221031",
        "answerer": "浦发银行",
        "answer": "公司当前正处于转型发展的重要阶段，2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，发挥长三角区位优势，打造“轻型银行、绿色银行、全景银行”，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20221104",
        "id": "1056967"
    }, {
        "symbol": "600000.sh",
        "questioner": "刘俊生",
        "question": "请问全亚洲笫一金融中心上海本地龙头银行股为什么从07年一直跌至现在巳经16年了还没反转向上，",
        "questondate": "20221026",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2022年，公司将发挥长三角区位优势，打造“轻型银行、绿色银行、全景银行”，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20221104",
        "id": "1055715"
    }, {
        "symbol": "600000.sh",
        "questioner": "temprory",
        "question": "您好，请问贵公司是否建立财务共享中心，如建立，请问具体是在哪一年？如果按照1-5分对财务共享相关的组织人员、业务流程、运营管理以及信息系统的运行水平进行评分（1代表水平较差，5代表水平极高）您对这四项分别打多少分？如果按照初建期，提升期，稳定期，成熟期，卓越期和衰退期来描述财务共享实施的阶段，您认为是在哪一阶段？如果没有建立，请问贵公司是否有使用大数据等信息技术进行财务集中核算处理？期待您的回答，感谢",
        "questondate": "20220926",
        "answerer": "浦发银行",
        "answer": "公司在对多家建设财务共享服务中心的银行同业进行调研的基础上，结合图像识别（OCR）、机器人流程自动化（RPA）、大数据等信息技术及我行实际，2019年起自主建设了财务集约化系统平台，实现了财务线上化，形成“单据看得见、流程跑得快、数据算得出、检核控得住、用户用得好”的财务系统能力，并持续推进财务集约化系统与上下游系统互联互通，实现预算、事项、采购、合同、报销等财务开支事项全流程闭环管理，不断提升我行财务核算管理集约化水平。感谢您的关注！",
        "answerdate": "20221104",
        "id": "1042933"
    }, {
        "symbol": "600000.sh",
        "questioner": "韭菜中的大熊猫",
        "question": "董秘，你好：请问我行2019，2020，2021年的拨备覆盖率分别为多少？谢谢。",
        "questondate": "20220919",
        "answerer": "浦发银行",
        "answer": "截至2021年末，公司拨备覆盖率为143.96%；2020年末为152.77%；2019年末为134.94%。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1039691"
    }, {
        "symbol": "600000.sh",
        "questioner": "一定",
        "question": "持有浦发银行整三年了，亏损累累。同样2019年9月买入的其它股都收益了很多。后来看网上股评，说浦发和民生是银行股中最差的2只股， 我觉的不是，至少浦发绝对不是，依然坚定持有。希望公司给股东多点回报，啥亮点也没有，连想象空间都没有，这么低的股价，不考虑回购吗？又或者管理层认为现在股价不算低?",
        "questondate": "20220921",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同。公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，发挥长三角区位优势，打造“轻型银行、绿色银行、全景银行”，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1041605"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_R40aLNlSC",
        "question": "董秘你好，今年利润？",
        "questondate": "20220914",
        "answerer": "浦发银行",
        "answer": "截至2022年6月末，公司经营效益实现“双增”，本集团实现营业收入986.44亿元，同比增加12.79亿元，增长1.31%；归属于母公司股东的净利润301.74亿元，同比增加3.36亿元，上升1.13%。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1038263"
    }, {
        "symbol": "600000.sh",
        "questioner": "放牧小哥",
        "question": "公司今年的目标是什么",
        "questondate": "20220916",
        "answerer": "浦发银行",
        "answer": "公司将深入学习贯彻党中央、国务院决策部署和监管各项要求，坚持稳字当头、稳中求进工作总基调，围绕“坚守长期、夯实基础、整体推进、数字赋能”经营主线，面向未来、坚守长期、坚定信心、保持定力、狠抓落实，继续统筹抓好疫情防控和经营发展，加快结构调整和转型步伐，努力在服务实体经济稳增长大局中推动全行发展取得新成效。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1038817"
    }, {
        "symbol": "600000.sh",
        "questioner": "韭菜中的大熊猫",
        "question": "董秘，你好：请问我行近3年消费贷款占各项贷款的比重是多少？消费贷款近3年的数量为多少？谢谢",
        "questondate": "20220913",
        "answerer": "浦发银行",
        "answer": "截至2022年6月末，公司普惠及消费贷款余额 3,734 亿元。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1037237"
    }, {
        "symbol": "600000.sh",
        "questioner": "洛阳李开兰",
        "question": "\"浦发银行年内罚款金额超2000万元，贷款增速低至2.82%位列A股上市股份制银行倒数第一\",请董秘解释下，如何做到这个成绩的？",
        "questondate": "20220914",
        "answerer": "浦发银行",
        "answer": "公司将坚持依法合规经营，严守合规经营底线，持续强化内控合规管理， 推进业务结构转型和优化；同时公司将持续加大支持实体经济力度，推动资产投放实现较快增长。谢谢！",
        "answerdate": "20220923",
        "id": "1038053"
    }, {
        "symbol": "600000.sh",
        "questioner": "韭菜中的大熊猫",
        "question": "董秘，你好： 请问2019 2020 2021偿还我行房地产贷款违约率为多少？ 近三年用于房地产贷款的金额是多少？ 谢谢",
        "questondate": "20220905",
        "answerer": "浦发银行",
        "answer": "截至2022年6月末，公司企业贷款中房地产业贷款余额为3,245.96亿元，占总贷款比例为6.65%。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1033543"
    }, {
        "symbol": "600000.sh",
        "questioner": "bowiefan",
        "question": "请问最新一期的股东人数是多少？",
        "questondate": "20220913",
        "answerer": "浦发银行",
        "answer": "截至2022年6月末，公司普通股股东共217,677户。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1037145"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_HYCD2nF6B",
        "question": "董秘你好！经常短信收到：【浦发联名卡】贵宾您好，您的高级信用卡已开通绿色申请通道，请3小时内填表单 (网站信息略去) 过期作废！银审为准，回T退订，请问董秘该信息是否贵司官方短信？是否不通过（网站略去）而去柜台直接办理高级信用卡？请问该高级信用卡额度是多少？",
        "questondate": "20220905",
        "answerer": "浦发银行",
        "answer": "详情请咨询我行客服热线（95528）或通过我行信用卡官网（https://ccc.spdb.com.cn/）了解有关情况。谢谢！",
        "answerdate": "20220923",
        "id": "1034212"
    }, {
        "symbol": "600000.sh",
        "questioner": "778",
        "question": "股东人数",
        "questondate": "20220829",
        "answerer": "浦发银行",
        "answer": "截至2022年6月末，公司普通股股东共217,677户。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1029514"
    }, {
        "symbol": "600000.sh",
        "questioner": "金石",
        "question": "为何浦发银行在银行股中表现最弱，股价为何长期如此低迷？",
        "questondate": "20220829",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1030044"
    }, {
        "symbol": "600000.sh",
        "questioner": "栩桉",
        "question": "尊敬的董秘，你好。请问贵公司是否开通微博？如有开通，请问微博开通时间和微博名是什么？",
        "questondate": "20220831",
        "answerer": "浦发银行",
        "answer": "公司官方微博名为“浦发银行”。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1031129"
    }, {
        "symbol": "600000.sh",
        "questioner": "778",
        "question": "股东多少人",
        "questondate": "20220824",
        "answerer": "浦发银行",
        "answer": "截至2022年6月末，公司普通股股东共217,677户。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1027589"
    }, {
        "symbol": "600000.sh",
        "questioner": "嘿大兄弟",
        "question": "2022年半年报有业绩发布会视频链接么？",
        "questondate": "20220822",
        "answerer": "浦发银行",
        "answer": "公司于2022年9月8日下午15:00-16:30参加了“2022年上海辖区上市公司集体接待日暨中报业绩说明会”活动，详见http://rs.p5w.net。感谢您的关注！",
        "answerdate": "20220923",
        "id": "1026186"
    }, {
        "symbol": "600000.sh",
        "questioner": "koseii",
        "question": "自浦发成都分行违规发放贷款被处罚后，浦发在全国各地接连有违规，近期大连分行被处罚，作为上市超过20年的老牌上市公司20年来带给投资者回报的同时不可否认近几年在公司治理、业务发展、股东回报等方面远远落后兄弟行，在银行业已然调入第三甚至第四梯队，和上海金融中心的地位更是不相匹配，浦发缺少闯劲缺少创新更缺少野心。",
        "questondate": "20220812",
        "answerer": "浦发银行",
        "answer": "公司将不??断完善公司治理结构，努力建设成为资本充足、内控严密、运营安全、效益良好的具有较强社会责任意识的现代金融服务企业。再次感谢您的建议！",
        "answerdate": "20220923",
        "id": "1021943"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "贵行股价创7年新低，贵行董事会有何感想？无动于衷吗？",
        "questondate": "20220803",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220816",
        "id": "1017708"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问董秘，贵行董事会成员2021年10块多都增持，今年7块反而不增持，是有什么雷他们提前知道了？还是什么缘故？",
        "questondate": "20220805",
        "answerer": "浦发银行",
        "answer": "公司始终坚持为股东创造价值的核心发展理念，高度重视投资者利益，致力于为股东提供持续、稳定的回报，让投资者分享公司价值增长成果。感谢您的支持与关注！",
        "answerdate": "20220816",
        "id": "1018828"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "看着浦发近年的低迷着实有些着急，提三点建议（二）：2、各个金融机构都在喊财富管理，但都做得不好，即使是招商银行的客户满意度也并不高，这就使一些机构在此领域异军突起成为可能。浦发这块的创收占比并不是很高，因而改革的成本相对较低，可以招一两位真正懂资本市场的人引领产品及财富管理方向，且不以短期创收为重，而以客户利益为重，赢得信任并树立品牌，经过三五年，一定能奠定良好的基础，进而快速赶超对手！",
        "questondate": "20220808",
        "answerer": "浦发银行",
        "answer": "感谢您的建议，公司坚持“为客户创造价值”的核心理念，以合规为先、服务为本为主线，深入推进零售数字化建设，提升“浦发卓信”的财富管理品牌价值，提供有温度的财富管理服务体验。谢谢！",
        "answerdate": "20220816",
        "id": "1019421"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "看着浦发近年的低迷着实有些着急，提三点建议（三）：3、公司的董事结构以政府及国企背景为主，这难免会造成公司的机制及效率不如优秀的民营企业，进而难以带动公司摆脱低迷。虽然公司也重视市场股东的声音，但毕竟影响力有限，且有些声音也是偏短视的，对公司的积极作用还不够。而公司的股东生命人寿则没有派董事，公司不妨在董事会建设中更市场化一些，多听一些不同的声音，应该能代表更多股东的利益，进而有益于员工。",
        "questondate": "20220808",
        "answerer": "浦发银行",
        "answer": "公司将不断完善公司治理结构，努力构建清晰的股权结构、健全的组织架构，确保各治理主体按照各司其职、各负其责、协调运转、有效制衡的原则行使权利、履行义务，维护各利益相关者的合法权益；努力建设成为资本充足、内控严密、运营安全、效益良好的具有较强社会责任意识的现代金融服务企业。再次感谢您的中肯建议！",
        "answerdate": "20220816",
        "id": "1019429"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "看着浦发近年的低迷着实有些着急，提三点建议（一）：1、进一步提升智能银行水平，以提升效率、降低成本，争取成为行业的领头羊。举个例子，我个人近期在逐步把浦发卡用起来，前期想买你们浦发的天添盈增利1号短期理财产品，还要先到柜台办理一些手续，否则无法线上购买，还不如买你们代销的其他银行产品方便。难道上海疫情期间此类业务仍如此不便吗？可能是我对有些规则了解的不清楚，也可能是公司的“数字赋能”还很不足。",
        "questondate": "20220808",
        "answerer": "浦发银行",
        "answer": "感谢您的中肯建议。您提到的应该是初次购买银行理财产品需要进行的风险评估等监管要求，公司将持续加快线上线下全栈式数字化建设，更好地提升客户体验。感谢您的关注！",
        "answerdate": "20220816",
        "id": "1019415"
    }, {
        "symbol": "600000.sh",
        "questioner": "星星",
        "question": "请问公司在提升经营业绩方向有哪些增长点？在业务方面还存在哪些风险点？谢谢",
        "questondate": "20220726",
        "answerer": "浦发银行",
        "answer": "公司将坚持稳字当头、稳中求进工作总基调，积极服务实体经济，坚决防范金融风险，围绕“十四五”规划，发挥我们在长三角、上海地区的传统主场优势，履行上海金融旗舰企业职责，深耕长三角、助力京津冀一体化发展和粤港澳大湾区建设，打响“长三角自己的银行”这一特色品牌。一季度末，我们在长三角区域内贷款余额1.51万亿元，存款余额1.95万亿元，存贷款余额均稳居股份制银行第一位。同时围绕打造“轻型银行”“绿色银行”“全景银行”这三个银行，朝着轻型化、“双碳”、数字化三大转型方向，重构客户、产品、服务经营体系，加快构建可持续增长的盈利模式。2022年，我们将聚焦“降风险、促发展、严管理、提能力”的工作主线，全面提升风险管理能力，保持资产质量总体稳定。感谢您的关注！",
        "answerdate": "20220802",
        "id": "1013530"
    }, {
        "symbol": "600000.sh",
        "questioner": "000438",
        "question": "请问浦发银行是如何做到把一个预期收益率仅仅1.7%的理财产品搞成亏损将近7%兑付给客户的",
        "questondate": "20220721",
        "answerer": "浦发银行",
        "answer": "公司2021年度利润分配现金红利发放日为2022年7月21日。感谢您的关注！",
        "answerdate": "20220802",
        "id": "1011748"
    }, {
        "symbol": "600000.sh",
        "questioner": "美好我最好",
        "question": "贵公司有没有代发工资系统都为那些公司代发，有没有中国移动？",
        "questondate": "20220722",
        "answerer": "浦发银行",
        "answer": "公司持续继续做大做强代发业务，深化客户黏性，推动形成企业级、一体化客户经营新格局，加速推动结算性存款增长。感谢您的关注！",
        "answerdate": "20220802",
        "id": "1012093"
    }, {
        "symbol": "600000.sh",
        "questioner": "66636",
        "question": "分红发了吗？怎么显示20号分红的金额到账了，21号分红金额又扣了？",
        "questondate": "20220722",
        "answerer": "浦发银行",
        "answer": "公司2021年度利润分配现金红利发放日为2022年7月21日。感谢您的关注！",
        "answerdate": "20220802",
        "id": "1012102"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行，以前市值和招行一个梯队，如今市值连招行零头都没有，是否意味贵行管理层能力远远不如招行管理层？至少对广大投资者来说是的。",
        "questondate": "20220729",
        "answerer": "浦发银行",
        "answer": "公司高度重视股东对股价的合理诉求，将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220802",
        "id": "1015408"
    }, {
        "symbol": "600000.sh",
        "questioner": "13198288367",
        "question": "贵公司利润怎么样",
        "questondate": "20220725",
        "answerer": "浦发银行",
        "answer": "2022年第一季度，公司实现税后归属于母公司股东的净利润193.88亿元，同比增加6.91亿元，增长3.70%。感谢您的关注！",
        "answerdate": "20220802",
        "id": "1013120"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行，近3年利润不断增长，分红逐年下降百分之二十左右，不拿出年利润百分之三十分红，一点担当都没有，前几年董事会还装模作样增持，今年跌成这样，居然不增持，请问贵行董事会做的决定合情合理吗？",
        "questondate": "20220727",
        "answerer": "浦发银行",
        "answer": "公司始终坚持为股东创造价值的核心发展理念，高度重视投资者利益，致力于为股东提供持续、稳定的回报，让投资者分享公司价值增长成果。近三年公司利润分配超437亿元。感谢您的支持与关注！",
        "answerdate": "20220802",
        "id": "1014404"
    }, {
        "symbol": "600000.sh",
        "questioner": "flora",
        "question": "你好 请问今年分红除权日是？几月几日之前持有股票参与分红？",
        "questondate": "20220714",
        "answerer": "浦发银行",
        "answer": "公司2021年度利润分配股权登记日为2022年7月20日，除权（息）和现金红利发放日为2022年7月21日。感谢您的关注！",
        "answerdate": "20220718",
        "id": "1007154"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "你好：董秘：有关房地产停货的事件。很多银行都发布报告了。还没有看到浦 发银行的报告。这个需要立即发布公告。让中小股东知情安心！！",
        "questondate": "20220715",
        "answerer": "浦发银行",
        "answer": "公司已于2022年7月15日公告了有关情况。感谢您的关注！",
        "answerdate": "20220718",
        "id": "1007685"
    }, {
        "symbol": "600000.sh",
        "questioner": "帅哥宋00",
        "question": "你们老说夯实基础，你们的基础还得多久才能夯实呀！你们究竟遇到什么问题，还有多少雷，什么雷？",
        "questondate": "20220713",
        "answerer": "浦发银行",
        "answer": "2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的支持与关注！",
        "answerdate": "20220718",
        "id": "1006188"
    }, {
        "symbol": "600000.sh",
        "questioner": "大哀专治各种不服",
        "question": "董秘你好 请问今年的疫情对公司业绩影响如何",
        "questondate": "20220705",
        "answerer": "浦发银行",
        "answer": "今年3月以来，全国多个省市出现新冠疫情反弹，上海更是遭遇了严峻的防控考验。面对复杂严峻的形势，公司深入贯彻落实党中央、国务院和上海市委市政府关于防疫抗疫工作的各项决策部署，一方面确保业务连续性，公司积极运用数字化转型成果助力企业生产经营和社会民生正常有序运转，推出“全线上、无接触”的创新服务模式，上线“空中开户”服务，持续升级“浦供赢”线上供应链金融服务，为居民提供7×24小时智能财富管理服务，切实提升金融服务的可得性和便利性。另一方面在业务拓展上，公司持续加强经济、政策、产业等各领域研究，准确把握内外部形势变化，积极顺应国家战略导向和政策趋势，聚焦重点领域，调整优化业务布局，进一步提升未来发展动能。目前，随着上海疫情防控取得重大进展，公司将继续做好线上线下金融服务，同时积极推进复工复产，全力攻坚，把疫情的影响降到最低。感谢您的提问！",
        "answerdate": "20220712",
        "id": "1001287"
    }, {
        "symbol": "600000.sh",
        "questioner": "测试主账号111",
        "question": "你好。董秘。赶快分红，早点分红。股价暴跌到这个份上。还不积极赶快分红。",
        "questondate": "20220712",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20220712",
        "id": "1004170"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好。董秘。赶快分红，早点分红。股价暴跌到这个份上。还不积极赶快分红。",
        "questondate": "20220705",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20220712",
        "id": "1000908"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问，比贵行晚开股东大会的好多银行都公布分红除权除息日期了，为啥贵行这么没效率，迟迟不公布？从这件事就可以看出，贵行办事效率如此低下，请问董事会是否能提高办事效率？",
        "questondate": "20220705",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20220712",
        "id": "1001695"
    }, {
        "symbol": "600000.sh",
        "questioner": "刘俊生",
        "question": "股价从07年连年跌至现在没个象样反弹，人家招行连年创新高，真不知你行经营方向问题，本行做为亚洲金融中心上海笫一龙头银行股，股价多年走低，有点不解！",
        "questondate": "20220708",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220712",
        "id": "1003250"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "您好：董秘。希望董事会尽快发布2022中期业绩快报。稳定提升市场对于浦发 银行的信心。结合红利发放和股市趋势。董事会应该考虑股价暴跌对于中小股 东的损失。当然公司也是巨大损失。谢谢。",
        "questondate": "20220706",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！",
        "answerdate": "20220712",
        "id": "1001727"
    }, {
        "symbol": "600000.sh",
        "questioner": "summerlive",
        "question": "贵公司高管好，请问贵公司的毫米波雷达传感器是否有应用于医疗器械如心跳和呼吸检测、特殊病人监护、睡眠障碍检测、生命探测、婴儿监护领域，谢谢！",
        "questondate": "20220712",
        "answerer": "浦发银行",
        "answer": "公司不涉及所述业务，请咨询相关企业，谢谢。",
        "answerdate": "20220712",
        "id": "1004475"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行，17日开完股东大会这么多天，为啥还不公布分红除权除息日期呢？交通银行今天6月28开会，7月12都分红了。为什么贵行办事效率如此低？",
        "questondate": "20220629",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20220701",
        "id": "997268"
    }, {
        "symbol": "600000.sh",
        "questioner": "张弛有度",
        "question": "你好，股东分红应该是所有持股股东吧！不是仅持有优先股股东吧",
        "questondate": "20220628",
        "answerer": "浦发银行",
        "answer": "根据公司2021年年度股东大会审议通过的《公司2021年度利润分配的预案》，本次分配对象为届时实施利润分配的股权登记日登记在册的全体普通股股东。感谢您的关注！",
        "answerdate": "20220701",
        "id": "996782"
    }, {
        "symbol": "600000.sh",
        "questioner": "9933",
        "question": "尊敬的董秘，你好。请问贵公司是否开通微博？如有开通，请问微博开通时间和微博名是什么？",
        "questondate": "20220622",
        "answerer": "浦发银行",
        "answer": "公司官方微博名为“浦发银行”。感谢您的关注！",
        "answerdate": "20220621",
        "id": "992312"
    }, {
        "symbol": "600000.sh",
        "questioner": "上坡一号",
        "question": "我是贵司上海用户和小股东 浦发银行能不能在闵行区浦江镇南部永康城瑞和城地区开设个支行 取钱办业务太不方便了",
        "questondate": "20220620",
        "answerer": "浦发银行",
        "answer": "公司将审慎考虑发展布局，设置分支机构，稳步推进网点建设，线下提高网点智能化服务水平。感谢您的建议！",
        "answerdate": "20220621",
        "id": "992164"
    }, {
        "symbol": "600000.sh",
        "questioner": "Xzy9551223",
        "question": "为什么不按规定比例分红？不要老讲你们的特殊性？不要利用大股东的优势地位损害我们的利益！",
        "questondate": "20220620",
        "answerer": "浦发银行",
        "answer": "《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。公司利润分配结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，又兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。2021年度利润分配方案已经公司股东大会审议通过，利润分配相关决策程序符合《公司章程》的规定。感谢您的关注！",
        "answerdate": "20220621",
        "id": "991175"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "请问董秘，香港这个所谓白玉兰联合慈善基金会是干什么慈善的？他都做了哪些慈善事？这个白玉兰慈善基金会注册成立于2019年9月4日，而浦发银行2019年7月23日就通过对白玉兰捐赠的议题。难道浦发银行董事会能预卜先知吗？还是转移输送利益，坑害中小股东利益。跪求请董秘大人正面回答我的问题。",
        "questondate": "20220614",
        "answerer": "浦发银行",
        "answer": "为更好地发挥上海企业在促进香港长期繁荣稳定中的积极作用，我行参与发起设立香港白玉兰联合慈善基金会有限公司。该基金会秉持“服务民生、雪中送碳”的宗旨，服务范畴包括扶贫助困、救急助危、赈灾助学等方面。谢谢您的关注！",
        "answerdate": "20220621",
        "id": "988605"
    }, {
        "symbol": "600000.sh",
        "questioner": "chedijiang",
        "question": "您好，问一下公司有供应链金融相关产品吗？",
        "questondate": "20220616",
        "answerer": "浦发银行",
        "answer": "公司围绕国家建设现代化产业体系的战略部署，持续优化业务产品服务体系，强化供应链金融等业务创新，助力提升产业链供应链现代化水平，促进制造业优化升级。更多关于公司供应链金融金融服务方案内容可至公司官网（https://www.spdb.com.cn/）中“公司金融”栏目下查询。感谢您的关注！",
        "answerdate": "20220621",
        "id": "990025"
    }, {
        "symbol": "600000.sh",
        "questioner": "千秋",
        "question": "浦发在西北去年亏损高达198亿，是否考虑退出西北市场，有这亏的钱，用来回购，提高员工积效也比年年亏了好啊！",
        "questondate": "20220610",
        "answerer": "浦发银行",
        "answer": "公司将持续优化西部地区信贷结构，保持高质量投放，同时强化风险管控力度，努力控制风险成本，提升整体盈利水平。感谢您的关注！",
        "answerdate": "20220621",
        "id": "986965"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "请董秘正面回答给最近五年对香港的捐款，我记得当时公告了捐款2500万，是否涉及不当利益输送。涉嫌侵犯中小股东利益。",
        "questondate": "20220606",
        "answerer": "浦发银行",
        "answer": "2019年7月23日，公司第六届董事会第四十七次会议审议通过《公司关于向香港白玉兰联合慈善基金会有限公司捐赠的议案》，同意向香港白玉兰联合慈善基金会捐赠港币2,000万元，并纳入2020年度公司对外捐赠额度。感谢您的关注。",
        "answerdate": "20220614",
        "id": "983893"
    }, {
        "symbol": "600000.sh",
        "questioner": "Xzy9551223",
        "question": "把每股未分配利润7.21元分给我们吧。那是我们的钱。靠你们股票涨点好难。亏大了。你们那个经营水平还是少点资产好。",
        "questondate": "20220606",
        "answerer": "浦发银行",
        "answer": "公司2021年度利润分配方案为每10股派发现金股利人民币 4.1元（含税）,该方案尚需公司年度股东大会审议，通过后再实施。感谢您的关注",
        "answerdate": "20220608",
        "id": "983849"
    }, {
        "symbol": "600000.sh",
        "questioner": "刘俊生",
        "question": "请问贵行从07年至今十五个年头了，长期市净率几乎在银行板块中处于最低，而且长期股价低于净资产，对此各位高管未来有什么方针扭转，在未来竞争激烈中盈利点能否力压群雄，能否成为银行板块领头龙头股？",
        "questondate": "20220606",
        "answerer": "浦发银行",
        "answer": "2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的支持与关注！",
        "answerdate": "20220608",
        "id": "984048"
    }, {
        "symbol": "600000.sh",
        "questioner": "人生如汤",
        "question": "董秘，最近河南村镇银行存款不能取已经过去四十几天了，不知道贵银行的监管是否到位，不会出现同样问题吧？",
        "questondate": "20220602",
        "answerer": "浦发银行",
        "answer": "公司在相关省市共发起设立了28家村镇银行，目前经营正常。感谢您的关注！",
        "answerdate": "20220608",
        "id": "982788"
    }, {
        "symbol": "600000.sh",
        "questioner": "大数据",
        "question": "你好！请问公司最近有增持计划吗？",
        "questondate": "20220606",
        "answerer": "浦发银行",
        "answer": "公司无相关应披露而未披露事项，感谢您的关注！",
        "answerdate": "20220608",
        "id": "983607"
    }, {
        "symbol": "600000.sh",
        "questioner": "小股东大志向",
        "question": "浦发银行现在股价如此之低，董监高为什么不增持？ 大股东是否有增持计划？ 上海此次疫情持续3个月之久，是否对公司经营造成重大负面影响？",
        "questondate": "20220527",
        "answerer": "浦发银行",
        "answer": "（1）公司高管已连续四年从二级市场购入公司股票，目前合计持有129万股；未来如有增持，公司将及时披露。（2）股票交易属于股东自主决策行为，公司无相关应披露而未披露事项。（3）公司认真贯彻落实党中央、国务院和上海市政府关于疫情防控的各项部署和要求，压实疫情防控责任。与此同时，公司持续加大服务实体经济的力度，主动加强卫生防疫、医药产品等企业的金融服务；对于受疫情影响企业不盲目抽贷、断贷，以高效的金融服务助力打赢疫情防控阻击战。感谢您的关注！",
        "answerdate": "20220602",
        "id": "979622"
    }, {
        "symbol": "600000.sh",
        "questioner": "爱海油",
        "question": "董秘您好，近期上海地区首套及二套房贷利率均出现下调，对咱们的业绩会出现多大影响？",
        "questondate": "20220523",
        "answerer": "浦发银行",
        "answer": "公司将积极贯彻监管要求，加强市场研判，持续做好前瞻性的利率管理，优化资产负债结构，努力稳定息差，提升业绩增长。感谢您的关注",
        "answerdate": "20220602",
        "id": "976862"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "另一个今天业绩说明会想请领导解答而未如愿的问题：鉴于贵行是总部设在上海的少数全国性银行之一，加上公司业务在长三角占比很高，此次上海疫情对公司的影响应该是行业内最大的，公司的数字小浦也是业内最早推出的。疫情的封控对公司提出了更高及现实的问题和挑战，不知公司从中发现了哪些不足？及由这些不足催生公司如何提升，进而成为银行业智能银行、数字银行的领头羊？谢谢！",
        "questondate": "20220527",
        "answerer": "浦发银行",
        "answer": "今年疫情发生以来，公司积极运用数字化转型成果助力企业生产经营和社会民生正常有序运转，推出“全线上、无接触”的创新服务模式，上线业内领先的“空中开户”服务方式，持续升级“浦供赢”线上供应链金融服务，积极推广全线上的“浦银点贷”，为居民提供7×24小时智能财富管理服务，切实提升金融服务的可得性和便利性。感谢您的关注！",
        "answerdate": "20220602",
        "id": "979696"
    }, {
        "symbol": "600000.sh",
        "questioner": "我们都是好朋友",
        "question": "郑董事长明确贵行将逐步将资产质量提升至主要股份制银行的中上水平，请问1、这一目标有没有量化的数据指标（如何判断达到这一目标），2、预期达到该目标有无时间计划？3、如果在目标时间内达不到该目标，董事长行长及高管有何种处罚措施？ 最后，请点评一下公司被上交所剔除出上证50指数，谢谢",
        "questondate": "20220530",
        "answerer": "浦发银行",
        "answer": "近年来，公司一直聚焦风险压降核心目标，“控新降旧”两手抓，持续加大不良处置力度，逐步消化成都事件造成的不良压力。至今年一季度末，已连续9个季度实现不良双降，资产质量稳中向好、持续夯实。2022年，我们将聚焦“降风险、促发展、严管理、提能力”的工作主线，全面提升风险管理能力，保持资产质量总体稳定。2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220602",
        "id": "979841"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "在今天的业绩说明会互动区提的问题，还没得到回复，特在这里再次提问：与2021年度业绩相比，今年1季度业绩还是很不错的，而去年1季度的业绩也不错，但随后几个月的利润就大幅下滑了，有了前车之鉴，还是很担心今年后3个季度业绩重演去年的一幕。请公司介绍一下去年1季度与后几个季度业绩差异大的原因，今年是否还存在相似问题而导致未来几个季度业绩大幅下滑？",
        "questondate": "20220527",
        "answerer": "浦发银行",
        "answer": "2021年，公司在合规审慎经营的框架下，主动调整业务结构，利息净收入和手续费及佣金净收入同比阶段性负增长；同时公司持续加大风险处置力度，前置压降风险，净利润也因此承压。2022年，公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220602",
        "id": "979691"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "请董事长正面回应2020年捐赠2500万给香港紫荆花慈善协会是怎么回事？对方是干什么的？是否不当利益输送？是否坑害中小股东利益？对方背景是计么？是否为乱港分子提供支持？在网上查询不到该慈善协会信息！",
        "questondate": "20220520",
        "answerer": "浦发银行",
        "answer": "投资者您好，公司没有与您提到的协会开展过合作。 公司致力于依托金融专业优势，认真履行并主动承担经济、环境、社会三重责任，促进自身与利益相关方共同可持续发展。感谢您的关注。",
        "answerdate": "20220527",
        "id": "975387"
    }, {
        "symbol": "600000.sh",
        "questioner": "互动12138",
        "question": "尊敬的董秘，您好，请问交易所对贵公司季度、半年度、年度业绩预告、业绩快报是否有强制披露的要求？ 期待答复，谢谢。",
        "questondate": "20220520",
        "answerer": "浦发银行",
        "answer": "上海证券交易所就上市公司业绩预告与业绩快报制定了相应的规范指引，公司将严格遵照上海证券交易所的相关要求，履行信息披露义务。感谢您的关注！",
        "answerdate": "20220527",
        "id": "975365"
    }, {
        "symbol": "600000.sh",
        "questioner": "远山",
        "question": "近两年业绩如何？",
        "questondate": "20220516",
        "answerer": "浦发银行",
        "answer": "近年来，公司深入贯彻落实党中央、国务院决策部署和监管要求，聚焦“十四五”战略规划，以“全面建设具有国际竞争力的一流股份制商业银行”为目标，服务国家重大战略，助力实体经济发展，主动优化业务结构，坚定推动转型发展，大力强化风险压降，高质量发展基础稳步夯实，各领域工作取得积极进展。具体经营业绩详见公司披露的定期报告，感谢您的关注！",
        "answerdate": "20220527",
        "id": "972133"
    }, {
        "symbol": "600000.sh",
        "questioner": "宏筑含草",
        "question": "请告知下2021年度分红派息及时间，谢谢。",
        "questondate": "20220517",
        "answerer": "浦发银行",
        "answer": "公司2021年度利润分配方案尚需公司年度股东大会审议，通过后再实施。感谢您的关注！",
        "answerdate": "20220527",
        "id": "973171"
    }, {
        "symbol": "600000.sh",
        "questioner": "qqqwe",
        "question": "我作为一个低层市场销售人员就是给商家安装销售pos机刷卡机的业务人员！深有感悟！春节+疫情！很多让信用卡持卡人出现逾期问题，在国家及时下调存款保证金。贵行以恶意透支起诉人家，怎么也不像中国人干的事吗？请问企业责任，企业使命是什么！公司高层是否有欧美管理人员？请董秘回复下！谢谢",
        "questondate": "20220516",
        "answerer": "浦发银行",
        "answer": "公司积极践行企业社会责任，为股东、客户、员工、社会、环境及其他利益相关方创造价值，在促进社会和谐进步的同时，实现公司可持续发展。公司经营管理层简历可详见年度报告，公司高级管理人员中无外籍管理人员。感谢您的关注！",
        "answerdate": "20220527",
        "id": "971948"
    }, {
        "symbol": "600000.sh",
        "questioner": "甘草",
        "question": "请问目前每股净资产19元，未分配利润及公积金合计高达10元，为何股价如此之低。",
        "questondate": "20220518",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220527",
        "id": "973771"
    }, {
        "symbol": "600000.sh",
        "questioner": "千秋",
        "question": "浦发银行最近几年的业绩对比其他几家银行落差较大，拨备覆盖率相差也极大，应该和转行中有较大关系，投资者也非常关注，请问进度完成了多少，能够给个准确答复吗！",
        "questondate": "20220520",
        "answerer": "浦发银行",
        "answer": "公司当前正处于转型发展的重要阶段，将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220527",
        "id": "975059"
    }, {
        "symbol": "600000.sh",
        "questioner": "许士杰",
        "question": "科技金融在线说贵行2021年在西部地区巨亏逾198亿？是真？还是故意抹黑？",
        "questondate": "20220520",
        "answerer": "浦发银行",
        "answer": "2021年年度报告“3.4.1营业收入”披露了集团营业收入地区分部（包括西部地区营业收入和营业利润）的情况，感谢您的关注！",
        "answerdate": "20220527",
        "id": "975342"
    }, {
        "symbol": "600000.sh",
        "questioner": "成都人爱成都银行",
        "question": "您好，我查阅公司年报2020年和2019年年报中，关于贷款损失准备计提情况，前后数据矛盾？求答案",
        "questondate": "20220524",
        "answerer": "浦发银行",
        "answer": "公司在编制2020年年报时，已在“主要会计数据和财务指标”就相关情况予以了说明，主要系根据监管统计要求及行业惯例，应收融资租赁款列报项目从“其他资产”调整至“发放贷款和垫款”所致，其准备金也相应的调整到贷款减值准备。谢谢您的关注！",
        "answerdate": "20220527",
        "id": "977597"
    }, {
        "symbol": "600000.sh",
        "questioner": "姜女士",
        "question": "公司是否有召开业绩说明会的计划？",
        "questondate": "20220506",
        "answerer": "浦发银行",
        "answer": "根据相关规范指引，召开年度业绩说明会应发布公告，敬请您关注公司公告，谢谢！",
        "answerdate": "20220516",
        "id": "966678"
    }, {
        "symbol": "600000.sh",
        "questioner": "价值投资人员",
        "question": "公司有没有考虑过缩股方式进行市值管理？上交所有缩股的先例也允许进行缩股，青海贤成矿业股份有限公司在2014年6月25号进行过缩股！公司是否会争取做上交所有缩股记录的第二家上市公司？",
        "questondate": "20220513",
        "answerer": "浦发银行",
        "answer": "上市商业银行与普通上市公司不一样，需严格遵守银保监会对资本须保持充足与稳定的监管要求，谢谢您的关注与建议！",
        "answerdate": "20220516",
        "id": "971301"
    }, {
        "symbol": "600000.sh",
        "questioner": "annly",
        "question": "据悉浦发银行应用于灵活用功平台的支付渠道，有两个问题：第一，是否有对灵工平台涉嫌洗钱的风控措施？第二，很多零工平台，对于给零工支付的报酬支出是白条入账，也就是用银行凭证作为成本支出凭证所得税税前扣除，如果平台被税务机关稽查，是否会牵连我们浦发银行",
        "questondate": "20220327",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注！",
        "answerdate": "20220516",
        "id": "942141"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股最穷的小股民",
        "question": "董秘你好，别的银行利润大部分都增长了，贵银行经营出现了什么问题利润下滑的？贵银行有没有贷款给恒大这些房企？",
        "questondate": "20220509",
        "answerer": "浦发银行",
        "answer": "2021年度，公司加强转型发展、调整业务结构、强化风险压降，经营效益稳中略降；2022年公司将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220516",
        "id": "967772"
    }, {
        "symbol": "600000.sh",
        "questioner": "JY",
        "question": "近三年分红是否未达到公司发布浦发银行2019一2021三年股东投资回报规划的分红标准。",
        "questondate": "20220510",
        "answerer": "浦发银行",
        "answer": "公司积极贯彻落实中国证监会、上海证券交易所等监管机构有关上市公司现金分红的要求，切实保护投资者的合法利益，公司最近三年现金分红累计分配的利润已达到相关《公司章程》及《三年股东回报规划（2019-2021年）》有关标准， 优先采取现金分红的方式进行股利分配，最近三年对普通股股东现金分红累计分配的利润已达最近三年实现的年均可分配利润的百分之三十以上。",
        "answerdate": "20220516",
        "id": "969083"
    }, {
        "symbol": "600000.sh",
        "questioner": "大爷",
        "question": "董秘好：根据年报浦发资产质量形势严峻，我们关心①近期有私银部干部员工出事，代销产品按“卖者有其责〞如华信、中科建有刚兑责任的有多少余额，表外总预计损失多少？②年报披露后三类贷款760亿，逾期贷款995亿，关注类1036亿，请披露欠息贷款多少余额？浦发对海航、恒大余额多少，分类结果在哪一档？浦发银行贷款风险分类结果是否全面、真实，中介机构有无查证？",
        "questondate": "20220505",
        "answerer": "浦发银行",
        "answer": "公司坚持风险“控新降旧”并举，持续加大存量不良资产处置力度，严控风险成本、把控投放质量，不良贷款余额及不良率连续九个季度实现“双降”。截至一季度末，按五级分类口径统计，本集团后三类不良贷款余额765.11亿元，较上年末减少3.18亿元；不良贷款率1.58%，较上年末下降0.03个百分点；谢谢您的关注与建议！",
        "answerdate": "20220516",
        "id": "966354"
    }, {
        "symbol": "600000.sh",
        "questioner": "时尚王",
        "question": "上交所APP不能交易股票吗？",
        "questondate": "20220511",
        "answerer": "浦发银行",
        "answer": "请咨询您的开户券商，谢谢。",
        "answerdate": "20220516",
        "id": "969979"
    }, {
        "symbol": "600000.sh",
        "questioner": "mikeyuan",
        "question": "查看上证所官网每天发布的上证市值在41万亿，加上科创板5万亿左右，总值应该在46玩亿。但是下载了所有上证股票，收盘单价乘以总股本，总值在49万亿，问这里是不是哪里有计算差异？什么原因导致的？单独看科创板的股票，市值和科创板指数发布的市值是一样的。差异应该在主板市场。B股即便考虑进去但由于市值不过万亿，应该不是B股的原因",
        "questondate": "20220427",
        "answerer": "浦发银行",
        "answer": "请您咨询相关券商，谢谢您的关注！",
        "answerdate": "20220429",
        "id": "962307"
    }, {
        "symbol": "600000.sh",
        "questioner": "陈健",
        "question": "董秘，公司可以考虑收购腾龙股份吗？它的子公司新源动力是国际一流的氢能源燃料电池龙头企业，主要产品包括膜电极、电堆及系统等都是核心高利润产品！强烈建议收购腾龙股份，谢谢！",
        "questondate": "20220417",
        "answerer": "浦发银行",
        "answer": "银行业对外投资有相应的规定。感谢您的关注！",
        "answerdate": "20220429",
        "id": "955143"
    }, {
        "symbol": "600000.sh",
        "questioner": "佰懿",
        "question": "凤凰卫视旗下的凤凰金融诈骗7万出借人100亿资金，已经被立案调查，严重危害了社会稳定。凤凰卫视在此次事件中，采用甩锅的态度，已完全丧失了媒体的公信力和影响力。请问贵公司还会与凤凰卫视合作吗？",
        "questondate": "20220406",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作。感谢您的关注！",
        "answerdate": "20220429",
        "id": "947980"
    }, {
        "symbol": "600000.sh",
        "questioner": "天空",
        "question": "董秘您好！请问作为凤凰卫视凤凰网合作商，我相信你们肯定会考虑我们的感受的？我们 相信凤凰卫视凤凰各大主持人大力站台宣传凤凰卫视凤凰网旗下凤凰金融平台是服务全球华人的金融平台，所以就把自己的血汗钱全部出借给该平台。凤凰卫视诈骗7万人100亿元，2021年4月29日被海南政府立案。请问董秘：凤凰卫视凤凰网这种不负责任的表现，你们还能和失信与民的媒体合作？？",
        "questondate": "20220406",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作，无相关托管业务。感谢您的关注！",
        "answerdate": "20220429",
        "id": "947727"
    }, {
        "symbol": "600000.sh",
        "questioner": "zhuzhu123",
        "question": "凤凰卫视金融诈骗100亿，中心百信银行为托管银行，管理失职，造成14万家庭重大损失，请问贵银行是否有相关托管业务？",
        "questondate": "20220408",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰卫视金融的合作，无相关托管业务。感谢您的关注！",
        "answerdate": "20220429",
        "id": "949524"
    }, {
        "symbol": "600000.sh",
        "questioner": "lilynet1210",
        "question": "凤凰卫视旗下的凤凰金融诈骗7万出借人100亿资金，已经被立案调查，严重危害了社会稳定。凤凰卫视在此次事件中，采用甩锅的态度，已完全丧失了媒体的公信力和影响力。请问贵公司还会与凤凰卫视合作吗？",
        "questondate": "20220406",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作，无相关托管业务。感谢您的关注！",
        "answerdate": "20220429",
        "id": "948047"
    }, {
        "symbol": "600000.sh",
        "questioner": "赢德",
        "question": "请问贵公司不良拨备率是多少？谢谢",
        "questondate": "20220415",
        "answerer": "浦发银行",
        "answer": "截至2022年3月末，公司拨备覆盖率为146.95%。感谢您的关注！",
        "answerdate": "20220429",
        "id": "953968"
    }, {
        "symbol": "600000.sh",
        "questioner": "投诉金融欺诈",
        "question": "浦发银行(600000)浦发银行(600000)的全球视野系列365天美元理财计划，没有按照协议约定操作，没有履行管理人职责，误导消费者！！！你们作为一个上市银行，投资者投诉无门，内部管理有多差！！！董秘回复别打官腔，官腔谁都会甩，投资者要一个说法，怎么保护",
        "questondate": "20220419",
        "answerer": "浦发银行",
        "answer": "本产品主要通过QDII资产管理计划投资境外中资美元债市场，底层标的为标准化债券，使用市场交易价格即市值法进行定价估值。相关投资严格按照产品说明书的约定进行，同时内部也有严格的监督约束，无违反协议约定的操作。谢谢您的关注。",
        "answerdate": "20220429",
        "id": "956554"
    }, {
        "symbol": "600000.sh",
        "questioner": "曾经的炉粉",
        "question": "请问刘总，宁夏尼龙66项目具备哪些市场竞争力，现有产能多少，预计年营收多少？有扩产计划吗？",
        "questondate": "20220426",
        "answerer": "浦发银行",
        "answer": "请您咨询对应的公司，谢谢您的关注！",
        "answerdate": "20220429",
        "id": "960993"
    }, {
        "symbol": "600000.sh",
        "questioner": "腾龙顾问",
        "question": "董秘，你好 请问公司可以考虑收购腾龙股份吗？它的子公司新源动力是国际一流的氢能源燃料电池龙头企业！腾龙股份目前资产都高达35亿了，而且还有百亿多订单，子公司新源动力也要上市了！建议公司可以考虑低价腾龙股份，谢谢",
        "questondate": "20220417",
        "answerer": "浦发银行",
        "answer": "根据监管规定，商业银行对外投资有行业限制。感谢您的关注！",
        "answerdate": "20220429",
        "id": "955110"
    }, {
        "symbol": "600000.sh",
        "questioner": "投诉金融欺诈",
        "question": "浦发银行(600000)的全球视野系列365天美元理财计划，没有按照协议约定操作，没有履行管理人职责，误导消费者！！！你们作为一个上市银行，投资者投诉无门，内部管理有多差！！！董秘回复别打官腔，官腔谁都会甩，投资者要一个说法，怎么保护投资者权益，维护金融业稳定！！！",
        "questondate": "20220415",
        "answerer": "浦发银行",
        "answer": "本产品主要通过QDII资产管理计划投资境外中资美元债市场，底层标的为标准化债券，使用市场交易价格即市值法进行定价估值。相关投资严格按照产品说明书的约定进行，同时内部也有严格的监督约束，无违反协议约定的操作。后续管理人将持续关注净值变化，尽力提升产品表现。感谢您的关注！",
        "answerdate": "20220429",
        "id": "953838"
    }, {
        "symbol": "600000.sh",
        "questioner": "凤凰打假人",
        "question": "悉贵司同无良媒体凤凰卫视合作，导致品牌价值受损，股价暴跌，贵公司执意选择跟凤凰卫视合作，是出于什么原因？",
        "questondate": "20220318",
        "answerer": "浦发银行",
        "answer": "公司不涉及与凤凰金融的合作。感谢您的关注！",
        "answerdate": "20220429",
        "id": "937118"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "请问浦发银行董事长，南京分行存款单抵押事件是如何处理的？你的不良资产处理是不是涉及利益输送？",
        "questondate": "20220311",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注！",
        "answerdate": "20220429",
        "id": "932836"
    }, {
        "symbol": "600000.sh",
        "questioner": "小木头莽子",
        "question": "希望你们成立浦发金控持股平台，把浦发银行作为其控股子公司装入到浦发金控，把浦发金控置换作为上市公司，这样浦发金控可以根据市场行情需要时进行回购注销，而不影响浦发银行注册资本。这样做的好处是，浦发金控从浦发银行分红所得红利可以选择是继续分红给股民还是用于回购注销浦发金控的股份。",
        "questondate": "20220405",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！",
        "answerdate": "20220412",
        "id": "946604"
    }, {
        "symbol": "600000.sh",
        "questioner": "Xzy9551223",
        "question": "能不能公司清盘。把净资产、未分配利润和公积金分给我们股东？这样我们投资就赚大了",
        "questondate": "20220401",
        "answerer": "浦发银行",
        "answer": "公司经营正常，感谢您的关注！",
        "answerdate": "20220412",
        "id": "945932"
    }, {
        "symbol": "600000.sh",
        "questioner": "dingxibo",
        "question": "作为本行的小股东，向公司提点建议:由于现在疫情较重，很多地方封城，导致一些人失业或收入大幅减少，看到很多有房贷的人断供了，所以建议银行对失业和低收入房奴的贷款展期或减免部分利息，毕竟把这些人逼上绝路银行坏账率会剧增，这样就是双输:房奴破产，银行不良率上升，希望银行高层能注意到这些。",
        "questondate": "20220404",
        "answerer": "浦发银行",
        "answer": "公司结合疫情情况积极推出相关举措，以切实提升金融服务便利性，助力保障生产生活平稳有序，感谢您的建议和关注！",
        "answerdate": "20220412",
        "id": "947125"
    }, {
        "symbol": "600000.sh",
        "questioner": "帅哥宋00",
        "question": "你好，公司股价不升，一定是公司内部治理或业务出了问题，内部治理不想问，问了也听不懂，我就想问业务方面，是不是有大笔贷款很有可能收不回的风险，我想知道这种可能性最大的五笔贷款是多少金额，分别是哪些公司的贷款？你们不会没有预估吧？",
        "questondate": "20220304",
        "answerer": "浦发银行",
        "answer": "公司主动调整业务结构，目前正处在转型期，营业收入受到阶段性影响。有关贷款质量可参阅公司定期报告中披露的风险管理情况，公司将通过强化风险压降、推动业务转型、夯实基础，实现公司高质量可持续发展。谢谢您的关注！",
        "answerdate": "20220331",
        "id": "928530"
    }, {
        "symbol": "600000.sh",
        "questioner": "一定",
        "question": "浦发银行已经成为估价表现最差的银行了，请问是否有回购打算，这么低了。如果不回购，是否就表示贵行高层认为股票还不算便宜。",
        "questondate": "20220307",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的关注！",
        "answerdate": "20220331",
        "id": "929572"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "董秘回复别打官腔，官腔谁都会甩，我们股东要实实在在的具体数字和利益。",
        "questondate": "20220325",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！",
        "answerdate": "20220331",
        "id": "941363"
    }, {
        "symbol": "600000.sh",
        "questioner": "omnicourage",
        "question": "请问今年会开几次业绩说明会？",
        "questondate": "20220323",
        "answerer": "浦发银行",
        "answer": "公司召开业绩说明会前将发布公告，敬请您关注公司公告。谢谢！",
        "answerdate": "20220331",
        "id": "939415"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好！董秘！公司业绩也不错！有关年度分配的事项提出建议：现在是回购股票最佳时机，可以有效提升浦发银行每股盈利！按照三季度财报有能力拿出200亿元回购股票提升公司价值！证明公司有价值！无论从社会责任和公司管理能力体现上，都是非常划算的！董事会做个改革榜样，此时此刻非常有利！希望董事会认真考虑！谢谢",
        "questondate": "20220324",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的建议！",
        "answerdate": "20220331",
        "id": "940458"
    }, {
        "symbol": "600000.sh",
        "questioner": "13181886056",
        "question": "该股的详细研报是如何的",
        "questondate": "20220326",
        "answerer": "浦发银行",
        "answer": "可参阅有关券商研究报告，谢谢关注！",
        "answerdate": "20220331",
        "id": "941996"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "董秘！你好！看了业绩快报，感觉公司有好转趋势！对于年度分红提个建议：按照净利润情况，当前回购股票是最好方式，今年高管没有购买股票提升市场信心，当前回购股票可以提升公司价值和每股收益按照回购20亿股计算，有效提升每股收益到前几年水平。对于公司非常有利。希望董事会采纳！谢谢",
        "questondate": "20220324",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。感谢您的建议！",
        "answerdate": "20220331",
        "id": "940480"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "近日看到银保监会统计的2021年银行业投诉情况，我们浦发的投诉数量排名第七，投诉量占比达4.85%，均明显高于我行的业务排名及市场份额，而业绩更优的招行和兴业的投诉量还更低一些。估计我们的基础服务比竞争对手还有明显不足，希望管理层能从根子上重视投诉背后深层的原因，提升全行服务，赶上并超越对手！我们日后会定期对比这些数据的变化，来督促经营的提升，共同迈向最佳银行！",
        "questondate": "20220309",
        "answerer": "浦发银行",
        "answer": "公司将坚持以客户为中心的经营理念，加强消费者权益保护，提升客户体验，感谢您的建议！",
        "answerdate": "20220331",
        "id": "931272"
    }, {
        "symbol": "600000.sh",
        "questioner": "股海沉浮11",
        "question": "董秘，您好，国家现在倡导推广电子合同、电子认证，公司是否也考虑借来提升公共服务水平呢?",
        "questondate": "20220301",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！",
        "answerdate": "20220331",
        "id": "926929"
    }, {
        "symbol": "600000.sh",
        "questioner": "小木头莽子",
        "question": "贵行市净率那么低，股价太低了，建议响应中央金融工作会议精神股份回购稳定股价。请求银监会证监会创造银行股回购机制。学习最近的汇丰控股天天回购！",
        "questondate": "20220317",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议。",
        "answerdate": "20220331",
        "id": "936659"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "董秘！你好！提个建议，有关2021年度的公司分红方案，希望董事会学习中国移动公司，采取回购股票的方式回报股东。有利于提升公司价值，浦发银行应当积极创新树立品牌！成为作为上海国际金融中心地位的积极因素！不能惰性墨守成规，希望董秘也积极建议，同时转告董事长总经理！谢谢！",
        "questondate": "20220315",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率。谢谢您的建议！",
        "answerdate": "20220331",
        "id": "934892"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "上个月特地在银监会网站查了一下过去几个月贵行所受处罚情况，整体感觉贵行受处罚的占比远高于自身业务的市场占有率，在国内业务排名相近的8家银行中，贵行所受处罚的数量也是很高的。这说明你们“坚守长期、夯实基础、整体推进、数字赋能”经营主线中的“夯实基础”一项还做得远远不够，更别说“坚守长期”了。这也是股价低迷的重要原因之一。请贵行领导们不要喊口号，再认真、努力一些，争取两年内能有质的变化和飞跃。",
        "questondate": "20220228",
        "answerer": "浦发银行",
        "answer": "感谢您的建议。公司将进一步加强合规内控管理，坚持问题导向，加快实现风险合规内控管理全覆盖，确保经营行稳致远。谢谢！",
        "answerdate": "20220304",
        "id": "925490"
    }, {
        "symbol": "600000.sh",
        "questioner": "TIAN183",
        "question": "请问贵司对西部地区营业利润连续几年为负值，且亏损金额逐年增加，有何应对方案？",
        "questondate": "20220228",
        "answerer": "浦发银行",
        "answer": "公司将强力推进处置化解，加速存量风险出清；同时坚定推进转型发展，夯实高质量发展的基础。感谢您的关注！",
        "answerdate": "20220304",
        "id": "926344"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行，最近贵行股价屡创新低，为啥？别的银行很多都新高了。是贵行业绩太差？",
        "questondate": "20220225",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司当前正处于转型发展的重要阶段，将按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报。感谢您的关注！",
        "answerdate": "20220304",
        "id": "925092"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "浦发银行近几年发展速度相对较慢，但还是有不错的基础和潜力的。在此，希望通过上证e互动来将发现的一些问题提出供贵行改进，进而推动贵行行稳致远、成为最佳银行。作为一名新客户，在25日的凌晨1点多收到了你们“鸿瑞2号”理财产品的推荐短信，虽然这款产品很受欢迎，但那个时间让客户收到短信，不打扰客户休息么？至少给我的体验不好。细节决定成败！一定要多为客户着想，才有可能成为最佳银行！",
        "questondate": "20220228",
        "answerer": "浦发银行",
        "answer": "感谢您的建议和意见，公司将进一步提升客户体验。谢谢！",
        "answerdate": "20220304",
        "id": "925496"
    }, {
        "symbol": "600000.sh",
        "questioner": "easondong2008",
        "question": "哪天发年报",
        "questondate": "20220225",
        "answerer": "浦发银行",
        "answer": "公司年报披露请以实际披露时间为准。感谢您的关注！",
        "answerdate": "20220304",
        "id": "925327"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "你好董秘！请转告贵行董事长总经理！公司股价残酷下跌到如此地步，作为大股东代表的童事长总经理。应该有责任的。对于公司的价值的认同难道没有吗？ 每股净资产18.83元的财务报告。涉嫌造假吗？如果不是造假。股价为什么如此下跌 作为大股东应当有责任。公司的价值。你们最有发言权。中小股东有知情权 股价不是任由市场操纵的。作为上市公司的高级管理人员。应当有公众公司的 责任承担！！希望公司不要熟视无睹！",
        "questondate": "20220225",
        "answerer": "浦发银行",
        "answer": "公司年报、半年报披露的财务指标已经会计师事务所审计或审阅，数据真实、准确；公司高度重视股东对股价的合理诉求，将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220304",
        "id": "925335"
    }, {
        "symbol": "600000.sh",
        "questioner": "帅哥宋00",
        "question": "请问，公司股价这么低，是不是还有隐藏的贷款风险，或者说审计报告还不需披露，但在行业人氏认为可能收不回来的大额贷款？",
        "questondate": "20220301",
        "answerer": "浦发银行",
        "answer": "公司已在定期报告中详尽披露了风险管理情况，公司亦将在积极服务实体经济的同时强化风险压降、推动业务转型、夯实基础，实现公司高质量可持续发展。感谢您的关注！",
        "answerdate": "20220304",
        "id": "926668"
    }, {
        "symbol": "600000.sh",
        "questioner": "",
        "question": "1.贵公司目前是否有采用深信服监控员工的行为感知系统或类似系统？ 2.公司以后是否有计划采用类类似的员工监控系统？ 3.公司企业文化对员工的社会责任方面如何定义？",
        "questondate": "20220215",
        "answerer": "浦发银行",
        "answer": "公司重视员工成长与关怀，坚持公平、公正的用工原则，致力于构建和谐、稳定的劳动关系， 切实保障员工劳动权益。公司牢固树立“以人为本，知人 善任”的人才观，紧紧围绕全行发展 战略目标，努力构建任人唯贤、唯才是用的管理机制和制度环境。感谢您的关注！",
        "answerdate": "20220301",
        "id": "919658"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "华夏银行2021年净利润增速低于商业银行均值 日前行长、副董事长曾双双辞职，请问贵行如业绩差，会咋办？",
        "questondate": "20220223",
        "answerer": "浦发银行",
        "answer": "公司将以“十四五”战略规划为引领，按照“坚守长期、夯实基础、整体推进、数字赋能”的经营主线，培育增长新动能，为投资者创造回报，感谢您的关注！",
        "answerdate": "20220301",
        "id": "923833"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的慢慢",
        "question": "浦发银行的互动问答是机器人答的吗？公司年报为何要拖到最后一刻才发布？投资者近半年时间看不到公司财报，对公司现运营状况一无所知。投资者交流平台上的问答，回答都比问题的字数少得多，答非所问。请问公司重视股东和股价吗？",
        "questondate": "20220215",
        "answerer": "浦发银行",
        "answer": "公司年报披露请以实际披露时间为准。公司高度重视股东的意见和建议，将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220301",
        "id": "919753"
    }, {
        "symbol": "600000.sh",
        "questioner": "吾牛市如虹",
        "question": "浦发银行：你好，国务院印发“十四五”国家应急体系规划，引导企业加大应急能力建设投入，支持安全应急领域有实力的企业做强做优，培育一批在国际、国内市场具有较强竞争力的安全应急产业大型企业集团，请问国泰君安在政策指导下，如何认真贯彻执行，落实助力相应规划实行？",
        "questondate": "20220217",
        "answerer": "浦发银行",
        "answer": "您好，请咨询相关企业，谢谢！",
        "answerdate": "20220301",
        "id": "920973"
    }, {
        "symbol": "600000.sh",
        "questioner": "陈帥",
        "question": "目前银证监会逐步放开银行业开展证券经纪业务，请问贵公司有没有资格或意向开展这方面的业务？",
        "questondate": "20220221",
        "answerer": "浦发银行",
        "answer": "目前公司将依托集团拥有的信托、理财、基金、境外投行、金融 租赁、科技银行、货币经纪等多牌照优势，加大集团协同，持续提升综合化金融服务能力。感谢您的建议！",
        "answerdate": "20220301",
        "id": "922769"
    }, {
        "symbol": "600000.sh",
        "questioner": "youzs",
        "question": "您好！公司人均薪资在银行业名列前茅，可是公司经营业绩在同行处于中下游水平，目前股价与民生中信差不多水平，反映了资本市场对公司经营管理业绩的评价。作为上海国资控股企业，请问新年有什么打算，提高公司业绩水平？向招商兴业宁波银行看齐？ 谢谢！期待您的回复。",
        "questondate": "20220215",
        "answerer": "浦发银行",
        "answer": "公司将按照“十四五”战略规划，围绕“坚守长期、夯实基础、整体推进、数字赋能”经营主线，奋力开创新发展格局。感谢您的关注！",
        "answerdate": "20220215",
        "id": "919325"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "前期向公司提问为何在行业整体营收增长的情况下，公司营收却在下滑。而公司给的答复第一句就是：“公司积极落实国家相关政策，支持国内经济复苏。”如果这是营收下滑的重要原因的话，那其他银行就没有积极落实国家相关政策了？就不支持国内经济复苏了？还请说关键性原因，这样的回答就是不能正视自己的问题，自然也就难以改进和提高，何有前景？你们确实从上到下都需要好好反醒了。我在这里提建议是在帮助你们改进和提升！",
        "questondate": "20220215",
        "answerer": "浦发银行",
        "answer": "感谢您的建议。",
        "answerdate": "20220215",
        "id": "918341"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问2022年好银行股价上涨百分之二十，中等百分之十，贵行极少，是因为太差了吗",
        "questondate": "20220215",
        "answerer": "浦发银行",
        "answer": "公司将努力完成各项经营目标任务，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220215",
        "id": "918261"
    }, {
        "symbol": "600000.sh",
        "questioner": "kozmol",
        "question": "我的科远智慧股票由于你们公司的原因，造成股票不正常下跌，这个损失你们要承担。否则我要告你们！！！",
        "questondate": "20211116",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20220211",
        "id": "872623"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "科远智慧都起诉贵行了，为啥贵行还不公告相关进展？辟谣或做实？",
        "questondate": "20220121",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20220211",
        "id": "909659"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行牛年结束收近3年最低，屡创新低，贵行董事会是否该反思一下为什么？而不是借口受各种影响，为啥别的银行不受影响呢？",
        "questondate": "20220128",
        "answerer": "浦发银行",
        "answer": "公司主动调整业务结构，目前正处在转型期，营业收入受到阶段性影响。公司将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220211",
        "id": "914234"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "董秘你好！浦发银行2021年业绩快报为什么还不发布！即使很差，也不要落后于招商银行！股东损失惨重！早发布！稳定信心！看未来吗！",
        "questondate": "20220207",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议!",
        "answerdate": "20220211",
        "id": "914805"
    }, {
        "symbol": "600000.sh",
        "questioner": "Iandyz",
        "question": "看公司2021年半年报及三季报中营业收入都较2020年同期下降，但报告中并未说明下降原因，而行业整体是上涨的。请介绍一下营业收入下降的具体原因是什么？以便我们对公司有更深的了解。谢谢！",
        "questondate": "20220207",
        "answerer": "浦发银行",
        "answer": "公司积极落实国家相关政策，支持国内经济复苏。同时公司主动调整业务结构，目前正处在转型期，营业收入受到阶段性影响。公司将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220211",
        "id": "915559"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "2022年2月7和8日，银行业大涨，为啥贵行连平均涨幅都没有？是贵行管理有问题吗？为啥连跌这么多年？",
        "questondate": "20220209",
        "answerer": "浦发银行",
        "answer": "公司经营正常，将继续努力完成各项工作任务，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220211",
        "id": "916188"
    }, {
        "symbol": "600000.sh",
        "questioner": "千秋",
        "question": "请问贵公司的转型什么时间能够完成，请回答完成的时间！",
        "questondate": "20220121",
        "answerer": "浦发银行",
        "answer": "公司将持续推进高质量发展。感谢您的关注！",
        "answerdate": "20220207",
        "id": "909749"
    }, {
        "symbol": "600000.sh",
        "questioner": "大爱无疆335",
        "question": "请问贵公司和尔康制药是否有业务往来。",
        "questondate": "20220120",
        "answerer": "浦发银行",
        "answer": "公司以服务国家战略和经济社会发展大局为己任，依法合规开展各项业务。感谢您的关注！",
        "answerdate": "20220207",
        "id": "908911"
    }, {
        "symbol": "600000.sh",
        "questioner": "千秋",
        "question": "浦发能够在转型后几年赶上兴业和招商，有无目标，每年分红派息是否能够做到稳定上升。",
        "questondate": "20220118",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20220207",
        "id": "907292"
    }, {
        "symbol": "600000.sh",
        "questioner": "千秋",
        "question": "浦发银行的业绩和招商、兴业等银行比起来越来越差，找过自身原因吗！总是说在转型升级中，每年业绩才是让人信服的，高额分红派息回报投资者才是真正的好公司！",
        "questondate": "20220117",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报，促进公司的价值提升。公司利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20220119",
        "id": "906554"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "其他行都有业绩快报，利润预增都百分之二十以上，贵行是否业绩太差，不敢发业绩快报？",
        "questondate": "20220113",
        "answerer": "浦发银行",
        "answer": "公司各项披露请以实际公告时间为准。感谢您的关注！",
        "answerdate": "20220119",
        "id": "904792"
    }, {
        "symbol": "600000.sh",
        "questioner": "千秋",
        "question": "贵公司转型准备什么时候完成",
        "questondate": "20220113",
        "answerer": "浦发银行",
        "answer": "当前公司正处于转型发展的重要阶段，业务收入结构发生调整，公司各项经营保持总体平稳。我们按照“十四五”战略规划，凝心聚力、攻坚克难、锐意进取，发挥主场优势，持续提升服务实体经济的能级，推动轻型化、“双碳”、数字化三大领域转型。感谢您的关注！",
        "answerdate": "20220119",
        "id": "904429"
    }, {
        "symbol": "600000.sh",
        "questioner": "上市小猪",
        "question": "尊敬的董秘:您好！方便说一下贵行的管理机制吗，当一个分行或者支行的业绩没完成的时候，对分行行长和支行行长是怎么考核的呢，会不会扣除他们的绩效或者降职呢？还是他们只需要在背后挥鞭子出张嘴，把业绩指标和风险责任全部都压在基层，另外浦发是否有统计一下管理层和基层员工的比例数是否合理。相信当郑书记和潘行长搞明白这个问题，浦发业绩就会好转起来。",
        "questondate": "20220117",
        "answerer": "浦发银行",
        "answer": "公司紧紧围绕五年战略规划部署，积极探索干部人事和激励约束机制改革，有关人员结构比例详见公司已披露的定期报告。感谢您的关注！",
        "answerdate": "20220119",
        "id": "907002"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的慢慢",
        "question": "何时出21年业绩快报？为何21年年报披露时间推后到4月30日发布？比往年发布时间迟近一个月，同时也是最后发布年报的银行，请问有何原因造成年报难产？如果出现重大事故，为何不直面股东？这样拖延是否人为造成市场恐慌？在银行板块走强的背景下，浦发银行股价长期低迷，能否有人能承担起责任？去直面问题，解决问题？",
        "questondate": "20220106",
        "answerer": "浦发银行",
        "answer": "公司年报披露请以实际披露时间为准。感谢您的关注！",
        "answerdate": "20220112",
        "id": "900477"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "以前贵行和招行，兴业一个梯队，如今市值差太多，是否意味贵行管理存在问题？比不过招行和兴业银行？",
        "questondate": "20220112",
        "answerer": "浦发银行",
        "answer": "当前公司正处于转型发展的重要阶段，业务收入结构发生调整，公司各项经营保持总体平稳。我们按照“十四五”战略规划，凝心聚力、攻坚克难、锐意进取，发挥主场优势，持续提升服务实体经济的能级，推动轻型化、“双碳”、数字化三大领域转型。感谢您的关注！",
        "answerdate": "20220112",
        "id": "903368"
    }, {
        "symbol": "600000.sh",
        "questioner": "Nicolas_7788",
        "question": "公司这几年从对标招行一路下滑到对标兴业，业绩越来越差，风险越爆越多？公司是否有反思在管理上是不是存在问题？非常多不懂业务的领导身居高位，越来越多溜须拍马的人提拔上位，公司是否应该反思一下企业文化和干部任用上的问题？",
        "questondate": "20220106",
        "answerer": "浦发银行",
        "answer": "公司紧紧围绕五年战略规划部署，积极探索干部人事和激励约束机制改革，公司将持续推进干部队伍建设，优化干部选用机制，推动干部队伍素质提升。感谢您的关注！",
        "answerdate": "20220112",
        "id": "900587"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "董秘！您好！提个建议！希望董事会赶快发布2021年度业绩快报。越早越好提升中小股东信心！希望董事会把2021年度年报发布时间提前到3月份。不要等到4月30日。",
        "questondate": "20220106",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！",
        "answerdate": "20220106",
        "id": "899988"
    }, {
        "symbol": "600000.sh",
        "questioner": "长线长胜",
        "question": "中移动获得消费支付牌照，会和浦发有进一步合作吗？",
        "questondate": "20211230",
        "answerer": "浦发银行",
        "answer": "公司与主要股东保持良好合作关系，合规开展各项业务。感谢您的关注！",
        "answerdate": "20220106",
        "id": "896709"
    }, {
        "symbol": "600000.sh",
        "questioner": "金雪峰",
        "question": "如果贵公司每年拿出150亿用来回购股票并注销，连续十年，股价还不涨，那么贵公司只剩下1000亿的市值，并且十年中未分配利润4000亿。如果20年不涨，我坐等成为大股东。因此对于贵公司价值低估的情况最好的办法是宣布把每年的分红用来回购股票并注销，直到市净率到0.8以上。",
        "questondate": "20220104",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率，提升银行服务实体经济的能力。感谢您的关注！",
        "answerdate": "20220106",
        "id": "898543"
    }, {
        "symbol": "600000.sh",
        "questioner": "快乐2",
        "question": "浦发银行大股东是谁",
        "questondate": "20211224",
        "answerer": "浦发银行",
        "answer": "上海国际集团有限公司直接持有公司股份6,331,322,671股，占总股本21.57%，其与一致行动人上海上国投资产管理有限公司、上海国鑫投资发展有限公司、上海国际集团资产管理有限公司合并持有公司股份8,709,396,441股，占比29.67%，为公司第一大股东。感谢您的关注！",
        "answerdate": "20211229",
        "id": "893698"
    }, {
        "symbol": "600000.sh",
        "questioner": "只投银行股",
        "question": "浦发董秘你好，听闻浦发近期可能进行大规模降薪减酬，但投资人从贵行批露的中报和季报看，贵行公报收入和利润尚可，这个反差是否预示着贵行账务报表上存在问题，面临隐形坏账和经营困难。望董秘回复公众关切！",
        "questondate": "20211214",
        "answerer": "浦发银行",
        "answer": "今年以来，面对日益复杂的内外部环境，公司凝心聚力、攻坚克难、锐意进取，坚定推进转型发展，持续提升服务实体经济的能级。目前公司经营正常。感谢您的关注！",
        "answerdate": "20211217",
        "id": "887715"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问董秘，为啥银行业指数大涨，贵行跟不上，银行业指数大跌，贵行跌幅居前，长期这样，导致贵行这几年整体跌幅不小，偏离上证指数和银行业指数较多，贵行今年营收和业绩同比降低较多，与其他行相反，董事会是否有措施？还是无动于衷？",
        "questondate": "20211208",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20211217",
        "id": "885043"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "董秘你好：请问，有关中国恒大集团债务问题，浦发银行涉及多少恒大债务？？？希望公司可以澄清",
        "questondate": "20211215",
        "answerer": "浦发银行",
        "answer": "公司坚决贯彻落实国家房地产调控政策，严格落实房地产贷款集中度管理制度和重点房地产企业融资管理规定。感谢您的关注！",
        "answerdate": "20211217",
        "id": "888592"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的慢慢",
        "question": "自从成为浦发股东，生活一年不如一年，想了解一下公司战略情况。公司率先推出“绿色银行”，区块链业务，服务科创公司、“专精特新”企业，之前设立的浦发硅谷银行，这些业务是否给公司带来回报？为何在同行间各项指标比较中，公司各项指标长期处于最差一档？是管理问题吗？",
        "questondate": "20211215",
        "answerer": "浦发银行",
        "answer": "公司全力推动“双碳”转型，服务产业转型升级，打造“绿色银行”模式；聚焦“双碳”目标，打响“浦发绿创”品牌。科技金融业务方面，公司聚焦“硬科技”创新，打响“科创板上市找浦发”品牌。科技金融持续做大生态圈，推出全周期、全流程、跨市场、智能化的综合金融服务。感谢您的关注！",
        "answerdate": "20211217",
        "id": "888344"
    }, {
        "symbol": "600000.sh",
        "questioner": "你好fff",
        "question": "看看兴业，招商，平安的股价，再看看浦发的股价请问公司管理层是否知道？公司的股价代表着公司管理水平和发展请问公司管理层是否明白？谢谢！",
        "questondate": "20211207",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，为投资者创造回报，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20211209",
        "id": "884251"
    }, {
        "symbol": "600000.sh",
        "questioner": "上市公司长线投资者小股东",
        "question": "能不能多给投资者分红？把分红率提高到和四大行一样百分之30的水准，股价天天跌，请以股息率提高的方式给我们补偿。不要增收不增利，多考虑回报股东。",
        "questondate": "20211201",
        "answerer": "浦发银行",
        "answer": "公司利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20211209",
        "id": "880996"
    }, {
        "symbol": "600000.sh",
        "questioner": "无良公司",
        "question": "请问，截至2021年11月21日，公司的股东数是多少？谢谢！！",
        "questondate": "20211125",
        "answerer": "浦发银行",
        "answer": "截至2021年9月30日，公司股东总数为 213,211 户。感谢您的关注！",
        "answerdate": "20211201",
        "id": "878039"
    }, {
        "symbol": "600000.sh",
        "questioner": "你好fff",
        "question": "退市风险如何评估？",
        "questondate": "20211125",
        "answerer": "浦发银行",
        "answer": "公司不存在退市风险。感谢您的关注！",
        "answerdate": "20211201",
        "id": "877936"
    }, {
        "symbol": "600000.sh",
        "questioner": "monkar",
        "question": "贵行在最近是否加大了个人住房贷款投放，客户一般要等多久放款？",
        "questondate": "20211112",
        "answerer": "浦发银行",
        "answer": "截至2021年6月30日，公司住房按揭贷款余额8,964.52亿元，年内保持稳定增长。感谢您的关注！",
        "answerdate": "20211125",
        "id": "871007"
    }, {
        "symbol": "600000.sh",
        "questioner": "上市公司长线投资者小股东",
        "question": "可否今年利润百分之30给分红？",
        "questondate": "20211122",
        "answerer": "浦发银行",
        "answer": "公司利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。公司在制定利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的关注！",
        "answerdate": "20211125",
        "id": "875068"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "最近几年分红年年提取公积金，公积金户头没涨。这笔钱用来做啥义务了？",
        "questondate": "20211102",
        "answerer": "浦发银行",
        "answer": "公司从年度可供普通股股东分配的当年利润中提取任意盈余公积，主要是为了长期可持续发展，留存利润充实资本。感谢您的关注！",
        "answerdate": "20211112",
        "id": "865007"
    }, {
        "symbol": "600000.sh",
        "questioner": "路锦程",
        "question": "尊敬的董秘您好，看到贵公司去年的年度报告及今年的中度报告和三季报有这样一个疑问。请问贵司已经很长一段时间存贷比高于10%了，虽然今年情况有所好转但贷款规模仍高于存款规模逾3100亿元。请问多出这部分同业或金融债资金对贵公司的风险准备金影响有多大？三季报当中显示拨付率已低于150%（原监管红线），另外贷款规模扩张过大在不良贷款总额当中已经开始有所体现，那么贵司对此有何应对措施？",
        "questondate": "20211103",
        "answerer": "浦发银行",
        "answer": "公司积极关注宏观经济变化，把握信贷政策和货币政策的调控节奏，结合自身资产负债结构和资金总体平衡状况，及时调整公司现金流缺口方向、规模和结构，积极防范流动性风险，业务经营运行稳健，流动性水平保持合理平衡。感谢您的关注！",
        "answerdate": "20211112",
        "id": "865525"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行股价长期走弱，如果董事会不采取措施，可转债两年后极高概率会触发回售，那样对贵行的冲击和负面影响将造成不可估量的损失，请慎重考虑。",
        "questondate": "20211112",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报；公司将加强与投资者沟通，增进投资者对公司的了解，促进公司的价值提升。感谢您的建议！",
        "answerdate": "20211112",
        "id": "870240"
    }, {
        "symbol": "600000.sh",
        "questioner": "梧桐哥",
        "question": "浦发2021年前三季度手续费及佣金净收入比上年同期下降54.67亿元,下降幅度约20%,大幅下降的原因是什么?",
        "questondate": "20211112",
        "answerer": "浦发银行",
        "answer": "公司手续费及佣金净收入同比下降主要系投行承销业务、资金理财业务和信用卡业务累计同比下降较大所致。公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报。感谢您的关注！",
        "answerdate": "20211112",
        "id": "870228"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问董秘，贵行股价2021年11月8日收盘创34个月新低，银行业新股外闻所未闻，股价如此下跌，贵行董事会是否有措施？另贵行分红不能保持年利润百分之三十的比率，是否意味贵行业绩有问题？",
        "questondate": "20211108",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到证券市场等多方面的影响。公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报；公司将加强与投资者沟通，增进投资者对公司的了解，促进公司的价值提升。公司利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。公司在制定利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的关注！",
        "answerdate": "20211112",
        "id": "868645"
    }, {
        "symbol": "600000.sh",
        "questioner": "麻地湾蜡",
        "question": "你好，请问公司内部人员是如何管理及办公的呢，有使用专门的软件吗？比如，HR人事系统，泛微OA系统等？",
        "questondate": "20211108",
        "answerer": "浦发银行",
        "answer": "公司坚持以着眼于“高效、直达、智能、共享”，全面推进“智慧运营+”体系建设。一是跨前联动，支持业务高质量发展。二是主动站位，携手共渡抗疫难关。三是技术引入，提升作业智能程度。四是夯实基础，降低运营风险隐患。感谢您的关注！",
        "answerdate": "20211112",
        "id": "868626"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的慢慢",
        "question": "贵司股价长期低迷，远弱于板块及大盘。据本人观察，股价长期低迷已严重损害浦发银行声誉，不少原浦发银行股东，被低迷的股价伤透了心而抵触浦发银行，转投他行。请问贵司有何措施对股东释放善意，挽回股东们的信心？",
        "questondate": "20211026",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报；加深投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20211103",
        "id": "860791"
    }, {
        "symbol": "600000.sh",
        "questioner": "当心电信诈骗",
        "question": "公司的浦大喜奔app性能有待提高啊，体验感不是很好，希望公司能够改进！",
        "questondate": "20211028",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！",
        "answerdate": "20211103",
        "id": "861965"
    }, {
        "symbol": "600000.sh",
        "questioner": "cykkk",
        "question": "您好！以下针对贵公司在2020年1月-3月期间的捐赠信息的问题，希望得到您的解答。 1\\. 2020年1月-3月期间，是否有针对抗击新冠疫情的对外捐赠？ 2.其中，实物捐赠和货币捐赠金额分别是多少？ 3.是否有涉及定向捐赠，具体金额是多少？ 4.相关的捐赠信息是否对外披露？ 谢谢！",
        "questondate": "20211027",
        "answerer": "浦发银行",
        "answer": "2020年，浦发银行共实施防疫捐赠3,016万元、定点扶贫捐赠1,453万元、公益捐赠823万元。详见公司披露的《2020年度企业社会责任报告》。感谢您的关注！",
        "answerdate": "20211103",
        "id": "861041"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问三季报，其他银行利润都回升，都增长，为啥贵行营收和利润都下降？为啥与行业指数偏离如此之大？是否意味贵行管理层工作不合格？说得好做的差。",
        "questondate": "20211029",
        "answerer": "浦发银行",
        "answer": "当前公司正处于转型发展的重要阶段，收入结构发生较大调整。尽管效益指标有所波动，但公司各项经营保持总体平稳。我们将保持战略定力，推动轻型化转型，将继续深调负债结构，压降成本、提升资产收益和息差水平，推动公司经营稳定增长与效益提升。感谢您的关注！",
        "answerdate": "20211103",
        "id": "863434"
    }, {
        "symbol": "600000.sh",
        "questioner": "丸子踹翻天",
        "question": "为什么上交所的融资融券余额和股票软件如大智慧不一样，差很多",
        "questondate": "20211025",
        "answerer": "浦发银行",
        "answer": "您好，请咨询有关公司，谢谢！",
        "answerdate": "20211025",
        "id": "859761"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股最穷的小股民",
        "question": "董秘你好，贵公司近两年派息为什么降低了？希望加大分红回馈二级投资者",
        "questondate": "20211025",
        "answerer": "浦发银行",
        "answer": "利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果。公司在制定年度利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的建议！",
        "answerdate": "20211025",
        "id": "859854"
    }, {
        "symbol": "600000.sh",
        "questioner": "当心电信诈骗",
        "question": "请问公司有养猪的计划吗？猪周期现在在今年的底部，非常适合公司布局，请务必认真考虑",
        "questondate": "20211020",
        "answerer": "浦发银行",
        "answer": "公司所属行业为金融业。感谢您的关注！",
        "answerdate": "20211022",
        "id": "858045"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行股价长期偏离银行业指数和大盘指数是为什么？为啥贵行营收下降？其他行基本都是上涨的。",
        "questondate": "20211020",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司上半年受净利息收入和手续费收入下降等因素的影响，营业收入同比有所下降。公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报；感谢您的关注！",
        "answerdate": "20211022",
        "id": "857565"
    }, {
        "symbol": "600000.sh",
        "questioner": "了不起的乔伊斯",
        "question": "您好，请问贵公司是否建立了财务共享中心，具体是哪一年建立的？谢谢！",
        "questondate": "20211008",
        "answerer": "浦发银行",
        "answer": "公司建立了独立的会计核算体系和财务管理制度。感谢您的关注！",
        "answerdate": "20211012",
        "id": "852012"
    }, {
        "symbol": "600000.sh",
        "questioner": "那一天守望",
        "question": "你好，董秘，我问下咱们浦发银行有外国资本介入吗，如果有，能否告知下是哪家外国公司",
        "questondate": "20210928",
        "answerer": "浦发银行",
        "answer": "根据相关规定，境外投资者可通过合格境外投资者形式或通过沪港通等股票市场交易互联互通机制参与投资A股上市公司。感谢您的关注！",
        "answerdate": "20211012",
        "id": "849731"
    }, {
        "symbol": "600000.sh",
        "questioner": "还没想好",
        "question": "给恒大的九十多亿贷款有抵押吗？",
        "questondate": "20210927",
        "answerer": "浦发银行",
        "answer": "公司坚决贯彻落实国家房地产调控政策，严格落实房地产贷款集中度管理制度和重点房地产企业融资管理规定，风险平稳可控。感谢您的关注！",
        "answerdate": "20211012",
        "id": "847765"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股最穷的小股民",
        "question": "董秘你好，最近新闻看到恒大资金链出现了问题，请问恒大有没有向贵公司贷款？",
        "questondate": "20211008",
        "answerer": "浦发银行",
        "answer": "公司坚决贯彻落实国家房地产调控政策，严格落实房地产贷款集中度管理制度和重点房地产企业融资管理规定。感谢您的关注！",
        "answerdate": "20211012",
        "id": "852133"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股最穷的小股民",
        "question": "董秘你好，贵公司股票每股净资产18块多，股价跌到惊人的九元。我就搞不懂银行股为何那么低估？",
        "questondate": "20211008",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报，感谢您的关注！",
        "answerdate": "20211012",
        "id": "852135"
    }, {
        "symbol": "600000.sh",
        "questioner": "祥珍哥",
        "question": "请问浦发银行是属于地方银行吗",
        "questondate": "20210913",
        "answerer": "浦发银行",
        "answer": "浦发银行系全国性股份制商业银行，总行设在上海。感谢您的关注！",
        "answerdate": "20210923",
        "id": "840752"
    }, {
        "symbol": "600000.sh",
        "questioner": "嘿大兄弟",
        "question": "股份行理财子公司大多已开业，而浦银理财筹备工作进展缓慢，迟迟未能开业。另外，根据公司较近的公告，浦银理财注册资本为50亿元，较最初公告中拟出资100亿元缩水一半。 请管理层就以上两点说明原因。",
        "questondate": "20210909",
        "answerer": "浦发银行",
        "answer": "资管新规正式发布以来，公司积极向监管部门申请理财子公司牌照，经银保监会批准，同意公司在上海筹建浦银理财有限责任公司，注册资本金为50亿元人民币。筹建工作完成后，公司将按照有关规定和程序向银保监会提出开业申请。感谢您的关注！",
        "answerdate": "20210923",
        "id": "839769"
    }, {
        "symbol": "600000.sh",
        "questioner": "qwerg",
        "question": "请问贵公司与恒大的业务往来规模有多少？在地产行业的开发贷有多少？",
        "questondate": "20210923",
        "answerer": "浦发银行",
        "answer": "截至今年6月末，公司对公房地产业贷款余额3,453.57亿元。公司坚决贯彻落实国家房地产调控政策，严格落实房地产贷款集中度管理制度和重点房地产企业融资管理规定。感谢您的关注！",
        "answerdate": "20210923",
        "id": "845922"
    }, {
        "symbol": "600000.sh",
        "questioner": "施二公",
        "question": "请问，浦发银行对现在颇受市场关注的恒大、蓝光、泛海，华夏幸福等房企的投资敞口情况，是否风险可控。华夏幸福等房企债务危机是否对浦发银行有影响。",
        "questondate": "20210923",
        "answerer": "浦发银行",
        "answer": "公司坚决贯彻落实国家房地产调控政策，严格落实房地产贷款集中度管理制度和重点房地产企业融资管理规定，风险平稳可控。感谢您的关注！",
        "answerdate": "20210923",
        "id": "844723"
    }, {
        "symbol": "600000.sh",
        "questioner": "rmd王",
        "question": "请问贵公司对地产行业开发贷款存量有多少？其中恒大、碧桂园、融创分别有多少？",
        "questondate": "20210923",
        "answerer": "浦发银行",
        "answer": "截至今年6月末，公司对公房地产业贷款余额3,453.57亿元。公司坚决贯彻落实国家房地产调控政策，严格落实房地产贷款集中度管理制度和重点房地产企业融资管理规定。感谢您的关注！",
        "answerdate": "20210923",
        "id": "845809"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行股价表现如此差，债转股的很少，股价迟迟不涨，到时候还钱压力就很大了。请问是否有措施促进股价上涨，增加债转股比率，减少利息成本和后期还债压力？",
        "questondate": "20210902",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报；公司将加强与投资者沟通，增进投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20210915",
        "id": "836002"
    }, {
        "symbol": "600000.sh",
        "questioner": "金融圈十八线写手",
        "question": "董秘你好，贵司2020年4月25日在上交所发布的《2019社会责任报告》第36页表1显示2018年营业收入为1715亿，同日发布的《2019年财务报表及审计报告》第103页显示2018年营业收入为1708.65亿，请问哪个数据是准确的？",
        "questondate": "20210819",
        "answerer": "浦发银行",
        "answer": "2019年度报告和财务报表中对2018年度营业收入进行了重述。感谢您的关注！",
        "answerdate": "20210915",
        "id": "826506"
    }, {
        "symbol": "600000.sh",
        "questioner": "没有未来的男人",
        "question": "请问，截至2021年8月20日，公司的股东数是多少？谢谢",
        "questondate": "20210830",
        "answerer": "浦发银行",
        "answer": "截至2021年6月30日，公司普通股股东总数为203,736户。感谢您的关注！",
        "answerdate": "20210901",
        "id": "833345"
    }, {
        "symbol": "600000.sh",
        "questioner": "挖掘秘密",
        "question": "河南郑州特大洪灾损失惨重,请问是否考虑适当捐一些，为郑州灾区奉献一份爱心？",
        "questondate": "20210722",
        "answerer": "浦发银行",
        "answer": "公司第七届董事会第二十六次会议审议通过《公司关于捐资支持河南省抗汛救灾及灾后重建的议案》，同意公司捐款 700 万元，用于河南省抗汛救灾及灾后重建。感谢您的关注！",
        "answerdate": "20210831",
        "id": "808192"
    }, {
        "symbol": "600000.sh",
        "questioner": "cykkk",
        "question": "您好！请问贵公司在2018年是否进行了社会捐赠？具体数额是多少？这些捐赠信息是否在公司的CSR报告中公开？如果并未披露，请问原因是什么？谢谢！",
        "questondate": "20210817",
        "answerer": "浦发银行",
        "answer": "2018年度公司对外捐赠总额1,019.17万元，详见公司《2018年企业社会责任报告》。感谢您的关注！",
        "answerdate": "20210831",
        "id": "824617"
    }, {
        "symbol": "600000.sh",
        "questioner": "股鸦",
        "question": "一方有难，八方支援。最近郑州、新乡、鹤壁遭遇强大水灾，沪深交易所、多家上市公司及社会各界亦奉献了爱心！！为何不见贵公司履行社会责任，向灾区捐助？是公司认为没有责任和义务向该灾区施予援手吗？",
        "questondate": "20210730",
        "answerer": "浦发银行",
        "answer": "公司第七届董事会第二十六次会议审议通过《公司关于捐资支持河南省抗汛救灾及灾后重建的议案》，同意公司捐款 700 万元，用于河南省抗汛救灾及灾后重建。感谢您的关注！",
        "answerdate": "20210831",
        "id": "814290"
    }, {
        "symbol": "600000.sh",
        "questioner": "pbk",
        "question": "董秘你好！商业银行股份回购注销受限，为何不号召大股东增持，股价连续创新低？有没有具体企稳策略？",
        "questondate": "20210730",
        "answerer": "浦发银行",
        "answer": "股票交易属于公司各股东自主决策行为。公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报，感谢您的关注！",
        "answerdate": "20210809",
        "id": "814236"
    }, {
        "symbol": "600000.sh",
        "questioner": "热情如沸氺",
        "question": "董秘好，房贷利率可以下调一点吗？",
        "questondate": "20210726",
        "answerer": "浦发银行",
        "answer": "当前，央行持续深化利率市场化改革，促进贷款市场报价利率（LPR）推广运用，推进存量浮动利率贷款定价基准转换。公司各贷款产品利率由市场决定。感谢您的关注！",
        "answerdate": "20210809",
        "id": "809717"
    }, {
        "symbol": "600000.sh",
        "questioner": "霸王花",
        "question": "请问：这个公司的财务管理如何？",
        "questondate": "20210712",
        "answerer": "浦发银行",
        "answer": "公司设有独立的财务部门，并建立了独立的会计核算体系和财务管理制度。感谢您的关注！",
        "answerdate": "20210809",
        "id": "800389"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默的石头",
        "question": "浦发银行在同业、理财、委托贷款等业务中分别或同时存在以下问题：内控管理不完善，业务制度不健全，前期检查发现的部分违法违规行为整改不到位，甚至屡查屡犯；风险隔离不到位，理财产品之间、理财产品与自营业务之间的不当交易仍时有发生；产品管理不规范，未完全执行“穿透式管理”要求，部分理财产品未准确登记、报告和披露底层资产信息；资金投向不合规，为房地产市场或地方政府违规提供融资.被处罚6920万，董秘详解下！",
        "questondate": "20210719",
        "answerer": "浦发银行",
        "answer": "该处罚是2019年9月监管部门对我行2018-2019年度相关业务开展检查后实施的行政管理措施。 发现问题后，我行高度重视，2019年至今采取了多项整改措施，一方面修订业务制度规范，完善管理机制，加强信息系统建设，加快推进理财业务转型；另一方面聚焦重点问题，规范经营行为，提升风险管控能力，对相关责任人开展严肃问责，强化警示教育。目前相关整改工作已基本完成。 下一步，我行将坚决贯彻落实党中央、国务院和监管部门各项政策要求，加大服务实体经济力度，防范和化解金融风险，严守合规经营底线，坚持走高质量可持续发展之路。感谢您的关注！",
        "answerdate": "20210809",
        "id": "804501"
    }, {
        "symbol": "600000.sh",
        "questioner": "帅哥宋00",
        "question": "公司股票这么低，可考虑回购股票注销，以提高市值？",
        "questondate": "20210628",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率，提升银行服务实体经济的能力。感谢您的关注！",
        "answerdate": "20210707",
        "id": "790685"
    }, {
        "symbol": "600000.sh",
        "questioner": "文达王",
        "question": "请问贵行什么时候公布分红？",
        "questondate": "20210705",
        "answerer": "浦发银行",
        "answer": "公司将于2021年7月13日在《中国证券报》《上海证券报》《证券时报》以及上海证券交易所网站（http://www.sse.com.cn）刊登公司2020年度普通股分红派息实施公告。感谢您的关注！",
        "answerdate": "20210707",
        "id": "796589"
    }, {
        "symbol": "600000.sh",
        "questioner": "笑对人生19",
        "question": "为啥贵行开完股东大会三周了，还不公布分红除权除息日期？要等到7月才公布吗？",
        "questondate": "20210701",
        "answerer": "浦发银行",
        "answer": "公司将于2021年7月13日在《中国证券报》《上海证券报》《证券时报》以及上海证券交易所网站（http://www.sse.com.cn）刊登公司2020年度普通股分红派息实施公告。感谢您的关注！",
        "answerdate": "20210707",
        "id": "793548"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "为啥贵行开完股东大会两周了，还不公布分红除权除息日期？要等到7月才公布吗？",
        "questondate": "20210624",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20210629",
        "id": "789099"
    }, {
        "symbol": "600000.sh",
        "questioner": "monkar",
        "question": "目前的延期还本付息贷款余额有多少，已经到期里的贷款有多少是不良？",
        "questondate": "20210624",
        "answerer": "浦发银行",
        "answer": "随着疫情的控制和经济复苏，大多数企业都恢复至正常经营情况，受疫情影响无法还本付息的贷款占比很小，不会对资产质量造成冲击。公司将持续加大处置、加大防控，确保资产质量总体保持平稳可控。感谢您的关注！",
        "answerdate": "20210629",
        "id": "788642"
    }, {
        "symbol": "600000.sh",
        "questioner": "pbk",
        "question": "董秘你好！请我现在浦发市值连招行零头都不到，请问管理层是否尽职尽责？频频违规遭罚，请问有和措施？",
        "questondate": "20210622",
        "answerer": "浦发银行",
        "answer": "公司股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成经营目标和工作任务，为投资者创造回报；公司将加强与投资者沟通，增进投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20210624",
        "id": "787220"
    }, {
        "symbol": "600000.sh",
        "questioner": "不知姑娘她心所愿",
        "question": "亲爱的董秘，我想问一下贵银行在中小城市为啥不设分行？比如西双版纳就没有。",
        "questondate": "20210618",
        "answerer": "浦发银行",
        "answer": "公司持续推进网点建设和布局。感谢您的关注！",
        "answerdate": "20210624",
        "id": "784725"
    }, {
        "symbol": "600000.sh",
        "questioner": "LBNJZTZ",
        "question": "您好董秘 公司在财务稳健上有没有采取什么措施？",
        "questondate": "20210621",
        "answerer": "浦发银行",
        "answer": "公司根据相关监管要求，建立了独立的会计核算体系和财务管理制度，感谢您的关注！",
        "answerdate": "20210624",
        "id": "786023"
    }, {
        "symbol": "600000.sh",
        "questioner": "玲玲GG",
        "question": "董秘对公司股价长期低迷怎么看",
        "questondate": "20210618",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报，感谢您的关注！",
        "answerdate": "20210624",
        "id": "785142"
    }, {
        "symbol": "600000.sh",
        "questioner": "射电望远镜",
        "question": "现在银行可以控股券商了。公司和国泰君安的第一大股东为同一主体，同时国泰君安目前业绩在券商板块中数一数二的头部券商，估值则是券商板块中最低，增长持续稳定。公司能否利用国泰君安目前估值超低的良机参股或者控股国泰君安，让公司股东分享中国证券市场的发展，让公司的业绩有更大的增长？另外，能否让第一大股东撮合浦发银行与国泰君安的合并，达到强强联合，为上海奠定国际金融中心的地位做出贡献？",
        "questondate": "20210608",
        "answerer": "浦发银行",
        "answer": "目前，证券业和银行业依旧实行分业经营、分业管理。公司将依托集团拥有的信托、基金、境外投行、金融 租赁、科技银行、货币经纪等多牌照优势，加大集团协同，持续提升综合化金融服务能力。感谢您的建议！",
        "answerdate": "20210608",
        "id": "777354"
    }, {
        "symbol": "600000.sh",
        "questioner": "韭菜中的大熊猫",
        "question": "董秘，你好：注意到，我行因为未按规定开展代销业务，被处罚760万元。我行近年来被监管当局多次处罚。1.想请问我行是否会向社会招聘更为专业的稽核人员来替换原来稽核部门的人员？我行对于风险内控领导岗位的要求有哪些？2.“未按规定开展代销业务”具体是哪一块业务？是个人理财业务还是代理证券业务？又或是其它？3.我行内部控制建立起了哪些原则和内容？每一次被监管当局的处罚都会对我行的商誉和投资人造成直接的损害。",
        "questondate": "20210506",
        "answerer": "浦发银行",
        "answer": "公司将认真贯彻落实法律法规规定和监管要求，坚持依法合规经营，积极维护金融消费者合法权益，以更优质的服务回馈广大客户。感谢您的关注！",
        "answerdate": "20210608",
        "id": "759984"
    }, {
        "symbol": "600000.sh",
        "questioner": "lrq631",
        "question": "你好，在多年前，感觉浦发与招行差距不太大，现在看下，3个浦发银行市值抵不上一个招行，是什么原因？有一个案例，办理一个经营贷，贷款人有着完整的材料，房产证都有，在浦发银行贷款，贵行的业务经理说1周放款，结果，还要贷款人送礼给业务经理，1个月才放款。相反，同样的材料，去招行办理贷款，业务经理说3天放款，没有送礼，真的就3天就放款了。得民心者得天下，招行越做越大。浦发的高层难道不应该反思一下这个问题吗？",
        "questondate": "20210527",
        "answerer": "浦发银行",
        "answer": "感谢您的提示！",
        "answerdate": "20210608",
        "id": "772060"
    }, {
        "symbol": "600000.sh",
        "questioner": "股林寻贝",
        "question": "今后怎么减少坏账的问题？",
        "questondate": "20210428",
        "answerer": "浦发银行",
        "answer": "截至2021年一季度末，本集团后三类类不良贷款余额 781.57 亿元，较上年末减少 3.04 亿元；不良贷款率 1.66%，较上年末下降 0.07 个百分点。公司未来将继续通过有质量的信贷增量投放，持续开展行业限额管理，继续加强不良压降与处置工作，加强风险预警管理和各类业务风险排查，并持续深化保全专业机制体制建设，以企业级数字化风控体系建设，提升全面风险管理的专业化、数字化水平。感谢您的关注！",
        "answerdate": "20210517",
        "id": "756497"
    }, {
        "symbol": "600000.sh",
        "questioner": "焱子",
        "question": "啥时候分红派息？",
        "questondate": "20210514",
        "answerer": "浦发银行",
        "answer": "公司2020年度利润分配方案尚待年度股东大会审议通过后方可实施。感谢您的关注！",
        "answerdate": "20210517",
        "id": "764788"
    }, {
        "symbol": "600000.sh",
        "questioner": "Tjp",
        "question": "股权登记日在几时",
        "questondate": "20210506",
        "answerer": "浦发银行",
        "answer": "公司2020年度利润分配方案尚待年度股东大会审议通过后方可实施。感谢您的关注！",
        "answerdate": "20210517",
        "id": "759177"
    }, {
        "symbol": "600000.sh",
        "questioner": "孙姐",
        "question": "我问浦发银行(600000)股东有多少",
        "questondate": "20210510",
        "answerer": "浦发银行",
        "answer": "截至2021年一季度末，公司股东总数为191,362户。感谢您的关注！",
        "answerdate": "20210517",
        "id": "762014"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "董秘你好，看了公司年报季报，尤其是一季度季报，中国证券金融股份公司大幅度减仓公司股票，是不是提前知道了公司季报数据？？？希望公司仔细说明一下，一季度营业收入减少10%以上的原因！？？谢谢！",
        "questondate": "20210430",
        "answerer": "浦发银行",
        "answer": "受净利息收入和手续费收入下降等因素的影响，公司一季度营业收入同比有所下降。感谢您的关注！",
        "answerdate": "20210517",
        "id": "758456"
    }, {
        "symbol": "600000.sh",
        "questioner": "赢德",
        "question": "请问贵公司去年的年报和今年的一季报什么时候发布？",
        "questondate": "20210428",
        "answerer": "浦发银行",
        "answer": "公司2020年度报告已于3月27日对外公告；2021年一季度报告已于4月30日对外公告。感谢您的关注！",
        "answerdate": "20210517",
        "id": "756693"
    }, {
        "symbol": "600000.sh",
        "questioner": "许士杰",
        "question": "一个朋友打算买银行理财，我推荐的是贵行，他问我股票价格哪个好，他根据股票价格选定了去招行，虽然几百万的金额的理财对贵行没什么影响，但是股价给人了一个小行的感觉。",
        "questondate": "20210428",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报；也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20210517",
        "id": "756967"
    }, {
        "symbol": "600000.sh",
        "questioner": "许士杰",
        "question": "这几年多次被罚款近6亿，市值是招行的四分之一，股价五分之一，贵行管理出了多大的问题？",
        "questondate": "20210510",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报；也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20210517",
        "id": "762029"
    }, {
        "symbol": "600000.sh",
        "questioner": "a125",
        "question": "你好这个月业绩好不好",
        "questondate": "20210510",
        "answerer": "浦发银行",
        "answer": "公司将按照监管规定和上市规则，在定期报告中披露财务数据。感谢您的关注！",
        "answerdate": "20210517",
        "id": "761831"
    }, {
        "symbol": "600000.sh",
        "questioner": "老闺",
        "question": "你股息高不高?",
        "questondate": "20210419",
        "answerer": "浦发银行",
        "answer": "公司董事会通过的2020年度利润分配方案为：每股派发现金股利人民币0.48元（含税）。本次利润分配方案尚待公司2020年年度股东大会审议通过后方可实施。感谢您的关注！",
        "answerdate": "20210419",
        "id": "748949"
    }, {
        "symbol": "600000.sh",
        "questioner": "学友",
        "question": "2020年底，官网显示的可信交易总额是1054亿元，截止2021年3月31日，可信交易总额是1140亿元，3个月净增加仅86亿元。2021年的三个月增加额几乎是2020年12月最后一周的增加量，请公司说明可信交易记录的都是什么业务，为什么前后倒差这么大？这么大的倒差对公司业绩影响怎么样？",
        "questondate": "20210401",
        "answerer": "浦发银行",
        "answer": "您好，请您咨询从事可信交易的公司。感谢您的关注！",
        "answerdate": "20210419",
        "id": "739891"
    }, {
        "symbol": "600000.sh",
        "questioner": "股市投资者重庆团",
        "question": "贵司子公司七四六公司是什么性质企业，做什么行业的公司？",
        "questondate": "20210406",
        "answerer": "浦发银行",
        "answer": "公司主要投资企业中不含您提到的公司。感谢您的关注！",
        "answerdate": "20210419",
        "id": "742049"
    }, {
        "symbol": "600000.sh",
        "questioner": "若水致远",
        "question": "啥时候分红？",
        "questondate": "20210413",
        "answerer": "浦发银行",
        "answer": "公司利润分配方案尚需股东大会审议通过后方可实施。感谢您的关注！",
        "answerdate": "20210419",
        "id": "746545"
    }, {
        "symbol": "600000.sh",
        "questioner": "大信",
        "question": "您好！年报中财报P73披露，报告期末应交“所得税”余额23,804百万元，年报中财报P91披露，报告期“当期所得税费用”13,177百万元。 请问：期末应交“所得税”余额超过“当期所得税费用”的原因？ 谢谢！",
        "questondate": "20210406",
        "answerer": "浦发银行",
        "answer": "税务与会计口径存在差异，应交所得税与当期计提的所得税费用不一致。感谢您的关注！",
        "answerdate": "20210419",
        "id": "742248"
    }, {
        "symbol": "600000.sh",
        "questioner": "frozenhalo",
        "question": "你们家的理财子公司怎么还没有获批开业，去年8月份就筹建了，已经过了筹建期了啊，原来批的那些，基本上都是6个月就开业了。是不是银保监会不批了？",
        "questondate": "20210413",
        "answerer": "浦发银行",
        "answer": "公司理财子公司正在筹建中。感谢您的关注！",
        "answerdate": "20210419",
        "id": "746452"
    }, {
        "symbol": "600000.sh",
        "questioner": "又亏钱了",
        "question": "公司向集团租赁使用土地，每年的租金增速大概是多少呢？",
        "questondate": "20210329",
        "answerer": "浦发银行",
        "answer": "公司有关租赁费用可以在年度报告 “业务及管理费用”栏目中查阅。感谢您的关注！",
        "answerdate": "20210331",
        "id": "735121"
    }, {
        "symbol": "600000.sh",
        "questioner": "一颗韭菜就是我",
        "question": "公司什么时候分红啊",
        "questondate": "20210329",
        "answerer": "浦发银行",
        "answer": "2020年度利润分配实施方案尚需股东大会审议通过后方可实施。感谢您的关注！",
        "answerdate": "20210331",
        "id": "735124"
    }, {
        "symbol": "600000.sh",
        "questioner": "钟名皓",
        "question": "董秘您好，请问股东是否可以获得一份免费的2020年年报呢？谢谢",
        "questondate": "20210329",
        "answerer": "浦发银行",
        "answer": "年报目前还在印制当中。请您联系我行对外投资者热线021-63611226或公众邮箱bdo@spdb.com.cn提供邮寄方式。感谢您的关注！",
        "answerdate": "20210331",
        "id": "734869"
    }, {
        "symbol": "600000.sh",
        "questioner": "宇使",
        "question": "你好！贵公司的主营业务收入是什么？",
        "questondate": "20210329",
        "answerer": "浦发银行",
        "answer": "公司营业收入主要由利息净收入、手续费及佣金净收入、和其他净收入构成。感谢您的关注！",
        "answerdate": "20210331",
        "id": "734892"
    }, {
        "symbol": "600000.sh",
        "questioner": "川峰SCNFG",
        "question": "贵公司你好，我代表SING女团向贵行提问一下： 贵行目前有没有推进数字人民币相关的推广工作？ 谢谢董秘!祝公司越做越好！",
        "questondate": "20210325",
        "answerer": "浦发银行",
        "answer": "公司不断拓展数字化创新生态，加快推进数字化转型，同时公司将根据中国人民银行等监管机构有关推进数字人民币的部署与要求予以落实。感谢您的关注！",
        "answerdate": "20210331",
        "id": "733454"
    }, {
        "symbol": "600000.sh",
        "questioner": "星梦无痕",
        "question": "最新的股东人数是多少？？",
        "questondate": "20210324",
        "answerer": "浦发银行",
        "answer": "截至2021年2月末，公司普通股股东总数200,882户。感谢您的关注！",
        "answerdate": "20210330",
        "id": "732911"
    }, {
        "symbol": "600000.sh",
        "questioner": "北逸",
        "question": "目前公司有多少人？？",
        "questondate": "20210319",
        "answerer": "浦发银行",
        "answer": "截至2020年末，母公司在职员工59,051人，感谢您的关注！",
        "answerdate": "20210330",
        "id": "730827"
    }, {
        "symbol": "600000.sh",
        "questioner": "韭菜中的大熊猫",
        "question": "你好：请问贵公司最近获准发行的600亿金融债会用到哪些领域？发行金融债券的目的是什么？谢谢",
        "questondate": "20210315",
        "answerer": "浦发银行",
        "answer": "本期债券募集资金在扣除发行费用后，将依据适用法律和主管部门的批准用于满足发行人资产负债配置需要，充实资金来源，优化负债期限结构，促进业务的稳健发展。感谢您的关注！",
        "answerdate": "20210330",
        "id": "728799"
    }, {
        "symbol": "600000.sh",
        "questioner": "人贵相知",
        "question": "2020的年报什么时候公布",
        "questondate": "20210322",
        "answerer": "浦发银行",
        "answer": "公司年报已于3月27日披露，谢谢您的关注！",
        "answerdate": "20210330",
        "id": "731631"
    }, {
        "symbol": "600000.sh",
        "questioner": "红与黑920174",
        "question": "公司何时发布年报！",
        "questondate": "20210312",
        "answerer": "浦发银行",
        "answer": "公司年报已于3月27日披露，谢谢您的关注！",
        "answerdate": "20210330",
        "id": "727427"
    }, {
        "symbol": "600000.sh",
        "questioner": "赵辉40012",
        "question": "请问年报的法定代表人，是以会计期末时的披露，还是按照年报公告日的披露？",
        "questondate": "20210304",
        "answerer": "浦发银行",
        "answer": "有关披露规则可参见中国证监会发布的《公开发行证券的公司信息披露内容与格式准则第2号——年度报告的内容与格式（2017年修订）》，谢谢您的关注！",
        "answerdate": "20210315",
        "id": "723645"
    }, {
        "symbol": "600000.sh",
        "questioner": "xn000",
        "question": "请问公司今年有何举措有效提升核心竞争力？股价长期严重低于公司净资产，不该警醒么？曾几何时，公司股价与招行不相伯仲，一年前有3倍的差距，截至目前已经5倍不止了。如果说客观原因，经济不好，行业不好，那为何市场能给招行2.23倍市净率？反观浦发才0.61倍市净率。该奋起直追了，不然就随波逐流了。痛心疾首。",
        "questondate": "20210208",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报；也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20210223",
        "id": "713670"
    }, {
        "symbol": "600000.sh",
        "questioner": "CYkhgf",
        "question": "董秘你好，请问贵公司2020年度的审计师是谁，审计费用是多少？",
        "questondate": "20210223",
        "answerer": "浦发银行",
        "answer": "2020年6月19日，公司召开的2019年年度股东大会审议通过了《关于2020年度续聘会计师事务所的议案》，续聘毕马威华振会计师事务所（特殊普通合伙）担任公司2020年度会计师事务所，审计费合计人民币 715 万元。感谢您的关注！",
        "answerdate": "20210223",
        "id": "718763"
    }, {
        "symbol": "600000.sh",
        "questioner": "xn000",
        "question": "请问公司业绩预报显示，资产质量持续向好，请问利润增速低于营收的原因是什么？",
        "questondate": "20210202",
        "answerer": "浦发银行",
        "answer": "公司继续强化风险管控，持续加大风险化解处置力度，加强风险成本精细化管理，通过现金清收、核销、不良资产证券化等方式，加快完成风险处置，多渠道提高不良处置效益。感谢您的关注！",
        "answerdate": "20210208",
        "id": "709474"
    }, {
        "symbol": "600000.sh",
        "questioner": "guest_c6xDl2HxO",
        "question": "强烈建议ETF和LOF基金实行集合兗价收盘，股票都集合兗价收盘了，留个尾巴不改不知道是什么意思",
        "questondate": "20210201",
        "answerer": "浦发银行",
        "answer": "有关证券交易规则，还请您向交易所等相关机构建议，感谢您的关注！",
        "answerdate": "20210208",
        "id": "709119"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "浦发银行董秘你好，有关公司2020年的业绩快报。希望提请董事会赶快出台。让市场消除对于浦发银行公司的担忧。同时，中小股东希望现金分红比例稳定提升，回报中小股东长期对于公司的支持信心",
        "questondate": "20210125",
        "answerer": "浦发银行",
        "answer": "公司已于1月28日公告了2020年度业绩快报。年度利润分配方案将结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，谢谢您的建议。",
        "answerdate": "20210202",
        "id": "703804"
    }, {
        "symbol": "600000.sh",
        "questioner": "川峰SCNFG",
        "question": "贵公司你好，我代表SING女团向贵公司提问一下： 2020年12月31日央行和银保监会联合发布《银行业金融机构房地产贷款集中度管理制度》，对贵公司的业绩有何影响?",
        "questondate": "20210126",
        "answerer": "浦发银行",
        "answer": "公司将按照监管机构有关房地产贷款集中度的监管要求予以落实。感谢您的关注！",
        "answerdate": "20210202",
        "id": "704947"
    }, {
        "symbol": "600000.sh",
        "questioner": "让哥哥",
        "question": "华泰证券沪A席位号是多少",
        "questondate": "20210126",
        "answerer": "浦发银行",
        "answer": "请联系开户券商，谢谢！",
        "answerdate": "20210202",
        "id": "704718"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "董秘你好！董事会有关浦发银行2020业绩快报是不是应该尽快发布！从而缓解市场对于浦发公司的担忧？希望大股东于中小股东共担责任，积极回报投资者",
        "questondate": "20210115",
        "answerer": "浦发银行",
        "answer": "公司已于1月28日公告了2020年度业绩快报。感谢您的关注！",
        "answerdate": "20210202",
        "id": "699089"
    }, {
        "symbol": "600000.sh",
        "questioner": "富仁坊",
        "question": "你们什么时候转型布置新零售业，平安银行业绩不如上海银行 ，但转型后股票价格已经翻倍上涨到达22.6元但是浦发银行股票价格越来越低，在10元徘徊",
        "questondate": "20210122",
        "answerer": "浦发银行",
        "answer": "公司近年来加大零售业务转型，坚持以客户为中心，通过数字化经营，提高客户体验；瞄准重点业务，持续深化客户服务、产品创新，有效实现数字化穿透管理，数字赋能成效显著，连续两年成为公司第一大收入来源。感谢您的关注！",
        "answerdate": "20210122",
        "id": "702303"
    }, {
        "symbol": "600000.sh",
        "questioner": "自由的股东",
        "question": "在分配股息时，为何公司不尝试“以股代息”？银行资本稀缺，而同时要保持现金分红回馈股东。如果分配时提供以股代息选项，有部分暂时没有现金需求的投资者可以选择拿股而不是现金。该政策的结果将会是银行减少了现金分红总额，从而降低资本压力，两全其美。证监会早前也提及允许以股代息。",
        "questondate": "20210113",
        "answerer": "浦发银行",
        "answer": "利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果。公司未来在制定年度利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的建议！",
        "answerdate": "20210118",
        "id": "697175"
    }, {
        "symbol": "600000.sh",
        "questioner": "monkar",
        "question": "今年的结构性存款产品多吗？还和去年一样压降吗？",
        "questondate": "20210111",
        "answerer": "浦发银行",
        "answer": "公司持续优化负债结构，进一步夯实存款基础，保持存款的稳定，同时合理运用同业负债、主动负债等手段，保持负债成本的相对可控。感谢您的关注！",
        "answerdate": "20210118",
        "id": "696125"
    }, {
        "symbol": "600000.sh",
        "questioner": "许士杰",
        "question": "公司个股盈利在银行业排名第四，而股价第八？难道公司没有什么措施维护公司股价吗？",
        "questondate": "20201229",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报，感谢您的关注！",
        "answerdate": "20201229",
        "id": "689189"
    }, {
        "symbol": "600000.sh",
        "questioner": "benxu",
        "question": "公司股价一直跌，在股民眼中成了三傻，为了维护公司形象，公司业绩一直也稳定，管理层有考虑回购股份注销并加大分红率吗？",
        "questondate": "20201229",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率，提升银行服务实体经济的能力。利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。公司在制定年度利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的关注！",
        "answerdate": "20201229",
        "id": "689085"
    }, {
        "symbol": "600000.sh",
        "questioner": "Helena_wc",
        "question": "请问公司四季度盈利情况如何？",
        "questondate": "20201224",
        "answerer": "浦发银行",
        "answer": "公司经营情况将在定期报告中披露。感谢您的关注！",
        "answerdate": "20201229",
        "id": "687285"
    }, {
        "symbol": "600000.sh",
        "questioner": "初见秋",
        "question": "请问公司四季度盈利情况如何？",
        "questondate": "20201224",
        "answerer": "浦发银行",
        "answer": "公司经营情况将在定期报告中披露。感谢您的关注！",
        "answerdate": "20201229",
        "id": "687297"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股最穷的小股民",
        "question": "董秘你好，贵公司分红派息为什么不稳定？有时多有时少？",
        "questondate": "20201229",
        "answerer": "浦发银行",
        "answer": "利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。公司在制定年度利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的关注！",
        "answerdate": "20201229",
        "id": "688101"
    }, {
        "symbol": "600000.sh",
        "questioner": "吴大锅",
        "question": "董秘你好，请问浦发硅谷银行目前服务的2000多家客户，有没有持有客户股权和期权？或者有没有持股持期权的试点？",
        "questondate": "20201208",
        "answerer": "浦发银行",
        "answer": "浦发硅谷银行是中国首家拥有独立法人地位、致力于服务科技创新型企业的银行，也是第一家中美合资银行。浦发硅谷银行现注册资本10亿元人民币，公司持有其50%的股份。浦发硅谷银行专注于为中国的科技和创新企业提供商业银行服务，并在中国打造“科技创新生态系统”，努力成为中国科技创新企业及其投资人的最优选银行。感谢您的关注！",
        "answerdate": "20201214",
        "id": "679704"
    }, {
        "symbol": "600000.sh",
        "questioner": "Alylau",
        "question": "请问公司最新的一致性盈利预期？",
        "questondate": "20201210",
        "answerer": "浦发银行",
        "answer": "公司将按照监管规定和上市规则，在定期报告中披露财务数据。感谢您的关注！",
        "answerdate": "20201214",
        "id": "680693"
    }, {
        "symbol": "600000.sh",
        "questioner": "chana1900",
        "question": "请问公司最新的一致性盈利预期是多少？",
        "questondate": "20201204",
        "answerer": "浦发银行",
        "answer": "公司将按照监管规定和上市规则，在定期报告中披露财务数据。感谢您的关注！",
        "answerdate": "20201207",
        "id": "678472"
    }, {
        "symbol": "600000.sh",
        "questioner": "zcxuser",
        "question": "请问蛋壳公寓暴雷，对贵公司有无影响。如果有的话，体量在什么量级，是否会对公司年利润构成影响。",
        "questondate": "20201201",
        "answerer": "浦发银行",
        "answer": "公司未开展相关业务。感谢您的关注！",
        "answerdate": "20201207",
        "id": "677036"
    }, {
        "symbol": "600000.sh",
        "questioner": "韩爱萍",
        "question": "董秘你好！贵司发行的可转债一直处于低位，是不是贵司不重视发行的可转债，也没有转股的意愿了，让持有可转债的心都凉了。所有发行可转债的银行都积极进行转股了，就贵公司没有一点动静，请问董秘有没有拉升可转债进行转股的安排呢？",
        "questondate": "20201130",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报；也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，促进公司的价值提升。感谢您的关注！",
        "answerdate": "20201207",
        "id": "676075"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "浦发银行董事长总经理你好，作为中小股东，希望你们好好学习上海市政府印发的推动上市公司质量的措施政策，建议你们考虑回购股票，开启全体员工持股和激励机制，把浦发银行员工和全体股东利益捆绑一起，有利于公司顺利发展，不吃回扣，现金分红和回购股票同样促进公司价值提升",
        "questondate": "20201123",
        "answerer": "浦发银行",
        "answer": "感谢您的建议，公司将全面贯彻落实有关提升上市公司质量的相关举措。商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率，提升银行服务实体经济的能力。目前公司高管层连续3年以自有资金购入公司股票，所购股票承诺自买入之日起锁定两年。感谢您的关注！",
        "answerdate": "20201126",
        "id": "673825"
    }, {
        "symbol": "600000.sh",
        "questioner": "h1977",
        "question": "林海上次因为重组而被监管机构处罚，现在承诺日期马上就到了，股吧里已经有90天重组倒计时。大家都知道要重组了，而公司不发布消息会不会被监管机构查呢？",
        "questondate": "20201110",
        "answerer": "浦发银行",
        "answer": "请您直接与相关公司联系。我公司无应披露而未披露的信息，感谢您的关注！",
        "answerdate": "20201119",
        "id": "669821"
    }, {
        "symbol": "600000.sh",
        "questioner": "李典",
        "question": "我想问下哪里可以查看每季度融资融券标的调入调出列表",
        "questondate": "20201109",
        "answerer": "浦发银行",
        "answer": "请您查阅证券监管机构的相关信息，感谢您的关注！",
        "answerdate": "20201119",
        "id": "669315"
    }, {
        "symbol": "600000.sh",
        "questioner": "CR7777",
        "question": "请问董秘，请分析一下这只股票最近一周走势",
        "questondate": "20201028",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报，感谢您的关注！",
        "answerdate": "20201103",
        "id": "665363"
    }, {
        "symbol": "600000.sh",
        "questioner": "嘿大兄弟",
        "question": "董秘好，我有两个问题： 一、浦发银行如何评价上海市政府与蚂蚁集团以及贵行与蚂蚁集团的战略合作关系？ 二、日前，央行与银保监会发布了全球系统重要性银行总损失吸收能力管理办法的征求意见稿。这份文件对于目前尚不是全球系统重要性银行的浦发银行的资本管理是否有指引作用和借鉴意义？ 谢谢！",
        "questondate": "20201015",
        "answerer": "浦发银行",
        "answer": "（1）公司与蚂蚁集团建立了良好的战略合作，双方发挥各自资源优势，聚焦数字化转型，以金融科技赋能产业生态，形成开放共赢、强强联合、优势互补的战略合作。（2）公司将积极研究监管机构发布的有关办法，完善和强化自身风险处置机制，继续提高风险抵御能力。感谢您的关注！",
        "answerdate": "20201019",
        "id": "661580"
    }, {
        "symbol": "600000.sh",
        "questioner": "平凡中签",
        "question": "贵司净资产17元多，可股价却表现得太差，公司有什么隐情风险吗？",
        "questondate": "20201013",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报，感谢您的关注！",
        "answerdate": "20201019",
        "id": "660991"
    }, {
        "symbol": "600000.sh",
        "questioner": "k1555",
        "question": "您好，董秘！请问现在数字货币在社会上如此流行，对银行造成了严重的冲击，贵银行对此有什么政策去应对呢？请尽快回复，谢谢。",
        "questondate": "20201013",
        "answerer": "浦发银行",
        "answer": "公司致力打造数字化服务的新特色，加快推进全栈数字化建设，深化科技与业务融合，通过构建开放银行平台、智能数据中枢，驱动业务模式创新，实现增长动能转换。继公司于2018年7月首家发布API Bank无界开放银行后，今年9月公司正式发布开放银行2.0——全景银行系列蓝皮书，并联合发起成立“开放金融联盟”；与华为公司联合发布《物的银行》白皮书，首次提出面向“智能物”的全新金融服务模式和设计体系。感谢您的关注！",
        "answerdate": "20201013",
        "id": "660862"
    }, {
        "symbol": "600000.sh",
        "questioner": "Wck5201314",
        "question": "尊敬的董秘你好，银行在面临数字货币的冲击，贵银行有什么对应政策吗，想咨询下，现在有具体的业务开展了吗? 望请尽快回复，谢谢",
        "questondate": "20201013",
        "answerer": "浦发银行",
        "answer": "公司致力打造数字化服务的新特色，加快推进全栈数字化建设，深化科技与业务融合，通过构建开放银行平台、智能数据中枢，驱动业务模式创新，实现增长动能转换。继公司于2018年7月首家发布API Bank无界开放银行后，今年9月公司正式发布开放银行2.0——全景银行系列蓝皮书，并联合发起成立“开放金融联盟”；与华为公司联合发布《物的银行》白皮书，首次提出面向“智能物”的全新金融服务模式和设计体系。感谢您的关注！",
        "answerdate": "20201013",
        "id": "660641"
    }, {
        "symbol": "600000.sh",
        "questioner": "irmo1908526",
        "question": "您好董秘！请问贵公司在二季度的资产负债比率高达104.82%的主要原因是什么？",
        "questondate": "20201012",
        "answerer": "浦发银行",
        "answer": "今年以来，公司持续推进业务结构转型和优化，加大支持实体经济力度，资产投放实现较快增长。感谢您的关注！",
        "answerdate": "20201012",
        "id": "660499"
    }, {
        "symbol": "600000.sh",
        "questioner": "DH2430",
        "question": "您好董秘！请问贵公司在二季度的资产负债比率高达104.82%的主要原因是什么？",
        "questondate": "20201009",
        "answerer": "浦发银行",
        "answer": "今年以来，公司持续推进业务结构转型和优化，加大支持实体经济力度，资产投放实现较快增长。感谢您的关注！",
        "answerdate": "20201012",
        "id": "659628"
    }, {
        "symbol": "600000.sh",
        "questioner": "han4827",
        "question": "请问公司A股股票价格在2020年7月6日强势上涨9.54%的主要因素是股市短期炒作还是公司业绩向好的必然趋势？",
        "questondate": "20200928",
        "answerer": "浦发银行",
        "answer": "当日公司股价表现与银行板块整体走势基本一致，感谢您的关注！",
        "answerdate": "20200928",
        "id": "658040"
    }, {
        "symbol": "600000.sh",
        "questioner": "笑对人生19",
        "question": "公司是不是出了问题，股价天天下跌，西部地区(地区）连年亏损。并越亏越大，难道公司没有处理办法吗？",
        "questondate": "20200923",
        "answerer": "浦发银行",
        "answer": "公司经营正常，公司将切实做好服务实体经济，加大风险成本计提，夯实稳健发展的基础。感谢您的关注！",
        "answerdate": "20200928",
        "id": "656845"
    }, {
        "symbol": "600000.sh",
        "questioner": "任朝峰",
        "question": "浦发半年报西部地区营业利润为负93.94亿，主要原因是成都分行事件造成的吗？如果不是，是什么原因造成的？",
        "questondate": "20200921",
        "answerer": "浦发银行",
        "answer": "公司将继续做好服务实体经济，加大风险成本计提，夯实稳健发展的基础。感谢您的关注！",
        "answerdate": "20200928",
        "id": "655895"
    }, {
        "symbol": "600000.sh",
        "questioner": "pbk",
        "question": "在股份行中，看一些报道贵司两年来房地产不良贷款激增十几倍，近期股价更是阴跌不止，频频遭监管部门处罚，市值更不及招行1/3，贵司有没有提振改善措施，增强投资者投资信心？",
        "questondate": "20200917",
        "answerer": "浦发银行",
        "answer": "公司将持续发挥“立足上海、辐射全国”，以服务国家战略和经济社会发展大局为己任，顺应经济发展方式转变和经济转型升级趋势，积极支持国家和区域重大基础设施建设和民生事业发展，不断强化信贷资源和综合金融服务支持，感谢您的关注！",
        "answerdate": "20200928",
        "id": "655004"
    }, {
        "symbol": "600000.sh",
        "questioner": "一直买买买",
        "question": "董秘你好。2020年3月1日，银保监会与人民银行等五部委联合出台了对中小微企业贷款实施临时性延期还本付息政策。请问这部分的延期还本付息，在报表上记不记入逾期贷款？",
        "questondate": "20200924",
        "answerer": "浦发银行",
        "answer": "公司将按照相关监管要求，针对疫情期间受影响的客户进行名单制管理、滚动评估，对符合条件的客户，提供临时性延期还本付息方案。对客户资产质量的变化将及时调整风险化解预案。感谢您的关注！",
        "answerdate": "20200928",
        "id": "657370"
    }, {
        "symbol": "600000.sh",
        "questioner": "听寂寞在唱歌",
        "question": "新债中签后怎么查询",
        "questondate": "20200827",
        "answerer": "浦发银行",
        "answer": "公司近期未发行有关债券。感谢您的关注！",
        "answerdate": "20200907",
        "id": "644911"
    }, {
        "symbol": "600000.sh",
        "questioner": "平头百姓123",
        "question": "疫情发生在一季度，二季度业绩怎么那么差？一股才4毛钱，什么情况造成的？后期能改善吗？",
        "questondate": "20200831",
        "answerer": "浦发银行",
        "answer": "公司服务实体经济，贷款利率较年初下降；公司加大风险成本计提，夯实稳健发展的基础。感谢您的关注！",
        "answerdate": "20200907",
        "id": "646274"
    }, {
        "symbol": "600000.sh",
        "questioner": "平头百姓123",
        "question": "截至2020年6月30日。贵司的不良贷款总额共多少？谢谢。",
        "questondate": "20200903",
        "answerer": "浦发银行",
        "answer": "截至2020年6月30日，按五级分类口径统计，本集团后三类不良贷款余额为802.04亿元，比上年末减少11.49亿元，不良贷款率1.92%，较上年末下降0.13个百分点。感谢您的关注！",
        "answerdate": "20200907",
        "id": "649331"
    }, {
        "symbol": "600000.sh",
        "questioner": "严肃性",
        "question": "你好，现在八月都快结束了，大部分上市公司财报都出来了，贵公司什么时候发布业绩？",
        "questondate": "20200825",
        "answerer": "浦发银行",
        "answer": "公司目前预约交易所的半年度报告披露时间为8月29日。感谢您的关注！",
        "answerdate": "20200826",
        "id": "643529"
    }, {
        "symbol": "600000.sh",
        "questioner": "苏为岁",
        "question": "7月23号除权，10派6的分红什么时候到账？",
        "questondate": "20200804",
        "answerer": "浦发银行",
        "answer": "公司2019年度普通股分红派息除权（息）日和现金红利发放日为7月23日，相关分红派息已实施完成。感谢您的关注！",
        "answerdate": "20200806",
        "id": "631411"
    }, {
        "symbol": "600000.sh",
        "questioner": "小小曹",
        "question": "董秘你好！康希诺生物 上市对公司有多大好处。请问贵公司通过 嘉兴慧光股权投资 持有康希诺生物多少股？",
        "questondate": "20200731",
        "answerer": "浦发银行",
        "answer": "公司主要投资企业经营情况可在年报等定期报告中查询，感谢您的关注！",
        "answerdate": "20200804",
        "id": "628767"
    }, {
        "symbol": "600000.sh",
        "questioner": "傲龙堡二堡主的小弟",
        "question": "请问贵司是否间接持股康希诺？具体持股比例是多少？",
        "questondate": "20200803",
        "answerer": "浦发银行",
        "answer": "公司主要投资企业经营情况可在年报等定期报告中查询，感谢您的关注！",
        "answerdate": "20200804",
        "id": "630405"
    }, {
        "symbol": "600000.sh",
        "questioner": "张成明",
        "question": "请问董秘，有四川程女士在公众平台反映其在浦发成都分行无辜被冒名1200万贷款，请问是否核查属实？如果情况属实，贵公司将采用什么手段杜绝类似造假行为，谢谢！",
        "questondate": "20200728",
        "answerer": "浦发银行",
        "answer": "目前相关调查工作还在进行。浦发银行坚持审慎、稳健的经营管理原则，将根据调查结果依法依规采取后续措施。感谢您的关注！",
        "answerdate": "20200730",
        "id": "626504"
    }, {
        "symbol": "600000.sh",
        "questioner": "陈123",
        "question": "公司持有重庆信托多少股份？什么时候开股东大会审议增发计划？针对公司亏损有什么计划？",
        "questondate": "20200727",
        "answerer": "浦发银行",
        "answer": "公司不持有重庆信托股份，无应披露而未披露的增发预案。公司相关经营信息可查看公司披露的定期报告，未出现亏损的情形。感谢您的关注！",
        "answerdate": "20200727",
        "id": "625488"
    }, {
        "symbol": "600000.sh",
        "questioner": "Xlc12345",
        "question": "浦发银行股票市盈率及市净率都这么低，大股东有无增持计划？",
        "questondate": "20200724",
        "answerer": "浦发银行",
        "answer": "公司无相关应披露而未披露事项。感谢您的关注！",
        "answerdate": "20200727",
        "id": "625008"
    }, {
        "symbol": "600000.sh",
        "questioner": "嘿大兄弟",
        "question": "我注意到银保监会今年上半年批准了浦发硅谷银行新一任董事长和行长的提名，均为中方人员。并且浦发硅谷银行的两位股东对其等额追加了投资。结合科创板成立一周年第一批上市公司中有不少浦发硅谷银行的客户，能否告知浦发银行对于浦发硅谷银行目前在集团里扮演的角色以及未来在集团里的定位是怎样的，新一任中方人员的任命会不会在今后给浦发硅谷银行的股权结构带来改变，除了浦发硅谷银行外浦发围绕科创板是如何布局的？ 谢谢！",
        "questondate": "20200723",
        "answerer": "浦发银行",
        "answer": "浦发硅谷银行有限公司成立于2012年8月，是中国首家拥有独立法人地位、致力于服务科技创新型企业的银行，公司持有其50%的股份。 浦发硅谷银行将一如既往致力于服务中国的科技创新企业，打造“科技创新生态系统”，努力成为中国科技创新企业及其投资人的最优选银行，目前服务有效覆盖京津冀周边、长三角地区和粤港澳大湾区，涵盖人工智能、大数据、企业服务、医疗健康、产业互联网及新消费等领域。截止到 2020 年第一季度，浦发硅谷银行已经为约2000家中国科技创新企业提供了全方位的金融服务。感谢您的关注！",
        "answerdate": "20200727",
        "id": "624338"
    }, {
        "symbol": "600000.sh",
        "questioner": "傲龙堡二堡主的小弟",
        "question": "公司立足金融中心上海，为啥各方面业务发展远远落后招商银行？甚至罚单不断",
        "questondate": "20200723",
        "answerer": "浦发银行",
        "answer": "公司将持续发挥“立足上海、辐射全国”，以服务国家战略和经济社会发展大局为己任，顺应经济发展方式转变和经济转型升级趋势，积极服务“一带一路”倡议，以及长三角一体化、京津冀协同发展、粤港澳大湾区建设等国家重大战略，积极支持国家和区域重大基础设施建设和民生事业发展，不断强化信贷资源和综合金融服务支持；充分发挥总部在上海的优势，通过加大公司银行业务、零售业务、金融市场业务领域的创新，积极支持上海“三大任务一个平台”、“五个中心”建设和“四大品牌”等重大任务。围绕“建设具有国际竞争力的一流股份制商业银行，推动浦发银行成为新时代金融业高质量发展的排头兵和先行者”战略目标，努力将浦发银行打造成为客户信赖的首选银行，资本市场的优质蓝筹。感谢您的关注！",
        "answerdate": "20200727",
        "id": "624419"
    }, {
        "symbol": "600000.sh",
        "questioner": "lishukan",
        "question": "请问贵公司有在考虑涉足证券业务吗",
        "questondate": "20200720",
        "answerer": "浦发银行",
        "answer": "公司在香港设有全资子公司浦银国际控股有限公司，拥有香港证监会颁发的第一类“证券交易”、第四类“就证券提供意见”、第六类“就机构融资提供意见”、第九类“资产管理”等受规管活动许可，以及香港上市保荐业务资格。公司将持续关注监管政策，拓展为客户提供多元化金融服务的能力。感谢您的关注！",
        "answerdate": "20200723",
        "id": "621919"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡尔one",
        "question": "你好，请问贵行2020年时什么时间分红？",
        "questondate": "20200715",
        "answerer": "浦发银行",
        "answer": "公司2019年度普通股分红派息股权登记日为7月22日，除权（息）日和现金红利发放日为7月23日。感谢您的关注！",
        "answerdate": "20200723",
        "id": "619225"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问贵行分红到底啥时候？人家银行直接公布，你倒好，搞个什么7月15至股权登记日，到底确定时间了么？为啥董事会效率这么低？",
        "questondate": "20200710",
        "answerer": "浦发银行",
        "answer": "因公司发行的可转换债券已经进入转股期，根据可转债相关规定，公司在发布2019年度普通股分红派息实施公告的前一日至分红派息股权登记日期间，“浦发转债”将停止转股，公司按照信息披露的相关要求发布了分红派息实施暨“浦发转债”转股连续停牌的提示性公告。公司将于2020年7月16日在《中国证券报》《上海证券报》《证券时报》以及上海证券交易所网站（http://www.sse.com.cn）刊登公司2019年度普通股分红派息实施公告，感谢您的关注！",
        "answerdate": "20200714",
        "id": "615951"
    }, {
        "symbol": "600000.sh",
        "questioner": "嘿大兄弟",
        "question": "你好，浦发银行在过去几年里通过定增，优先股，可转债，二级资本债等各种方式补充核心一级资本，其它一级资本与二级资本。 对比股份行中的招商银行在相同时间段里以内源性资本补充为主。如此频繁地通过外源性方式补充资本是否说明了浦发银行盈余留存补充资本能力不足，今年30%的现金股利支付比例在未来能否持续？浦发银行估值长期低于招商银行，管理层是否有对策提升估值，改善股东回报？ 谢谢。",
        "questondate": "20200707",
        "answerer": "浦发银行",
        "answer": "资本金充足是商业银行健康发展和服务实体经济的基础，监管机构亦对银行的资本有最低要求。公司在制定年度利润分配方案时，通过多种形式听取股东意见和诉求，使利润分配能够结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，并兼顾了投资者分享公司成长、发展成果，取得合理投资回报等要求。公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，完成各项经营目标和工作任务，为投资者创造回报；也将进一步与投资者充分沟通，加深投资者对公司的了解和认同。感谢您的关注！",
        "answerdate": "20200714",
        "id": "613416"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好！董秘，有关银行获得证券牌照的新闻，董事长总经理是否给予关注和有意愿申请证券牌照？？？浦发银行最近几年的管理能力确实有点惰性了，甚至跟不上工商建行这些大家伙的管理思维能力了，立足于上海国际金融中心地位，浦发银行作为上海国企，应该积极的争取新的发展空间利润增长点，",
        "questondate": "20200702",
        "answerer": "浦发银行",
        "answer": "公司将持续关注监管政策，拓展为客户提供多元化金融服务的能力。感谢您的关注！",
        "answerdate": "20200708",
        "id": "611112"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "董敏！你好！证监会有关试点银行获得证券牌照，董事长总经理有没有积极到证监会申请大陆牌照？浦银证券在香港有证券牌照。如果获得大陆证券牌照，直接打通香港市场，有助于提升浦发银行 世界影响力！浦发管理层有没有积极申请？",
        "questondate": "20200706",
        "answerer": "浦发银行",
        "answer": "公司将持续关注监管政策，拓展为客户提供多元化金融服务的能力。感谢您的关注！",
        "answerdate": "20200708",
        "id": "612612"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "董秘您好！金融行业给实体经济让利1.5万亿情况下，迫切希望了解今明两年经营业绩会怎样。1、目前浦发银行预测今年的经营业绩（净利润）能不能持平？或者会下滑多少？对明年的经营业绩（净利润）影响多大，会持平？还是下滑多少？2、如果业绩下滑较大，能否提高净利润的分配比率？保持分红绝对额水平？还是业绩下滑，又要补充资本金，就必然减少分红？长期投资者，目前是相当的困惑，银行股压制得不成样子。谢谢您！",
        "questondate": "20200702",
        "answerer": "浦发银行",
        "answer": "公司在2020年将保持适度合理、顺应市场的发展速度，均衡投放贷款；加大对实体经济和受疫情影响行业的支持，高度关注资产、负债的平衡发展，着力调整优化资产结构，提升收益水平。公司将进一步夯实存款基础，保持存款的稳定，同时合理运用同业负债、主动负债等手段，保持负债成本的相对可控。公司高度重视投资者利益，致力于为股东提供持续性回报。公司在制定利润分配方案前，将通过广泛调研，多渠道认真听取了投资者的意见和诉求，充分考虑了投资者分享公司成长、发展成果、取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20200706",
        "id": "605125"
    }, {
        "symbol": "600000.sh",
        "questioner": "梨梨",
        "question": "董秘你好，浦发转债的修正触发价是12.04元，标的价已经稳稳地低于12.04元150个自然日98个交易日，请告知对修正转股价以及对回售触发价的时间表以及相关的时间要求。谢谢。",
        "questondate": "20200622",
        "answerer": "浦发银行",
        "answer": "根据可转换债券的相关规定和募集说明书，可转债存续期间当出现向下修正条款对转股价格进行修正情形，转股价格的修正幅度也需遵循“修正后的转股价格不低于最近一期经审计的每股净资产和股票面值”的规定限制。目前公司可转换债券转股价格（15.05元）低于最近一期经审计的每股净资产（16.83元），无法实施向下修正的条款。感谢您的关注！",
        "answerdate": "20200702",
        "id": "606193"
    }, {
        "symbol": "600000.sh",
        "questioner": "梨梨",
        "question": "公司2019年度利润分配方案已经股东大会审议通过，什么时候分红？",
        "questondate": "20200630",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20200702",
        "id": "609446"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "董秘，你好！！代表中小股东，督促董事长总经理。现金分红时间赶快出来，",
        "questondate": "20200702",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20200702",
        "id": "610920"
    }, {
        "symbol": "600000.sh",
        "questioner": "lgs丑小鸭",
        "question": "请问董秘，股东大会已经通过了，分红除权日是届时，届时具体日期是几月几日，何年何月？这真是浦发独创！",
        "questondate": "20200629",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布，请关注公司公告。感谢您的关注！",
        "answerdate": "20200702",
        "id": "608684"
    }, {
        "symbol": "600000.sh",
        "questioner": "test01",
        "question": "您好，目前公司主要营收来源地为江苏和南京两地，请问近年公司有无向全国化经营计划?",
        "questondate": "20200603",
        "answerer": "浦发银行",
        "answer": "公司为全国性商业银行，总部位于上海。截至2019年末，已在31个省、直辖市、自治区以及香港特别行政区、新加坡、伦敦开设了41家一级分行，共1,606个分支机构。公司营收来源并非主要来自江苏地区。感谢您的关注！",
        "answerdate": "20200612",
        "id": "594744"
    }, {
        "symbol": "600000.sh",
        "questioner": "venus123",
        "question": "您好，目前公司主要营收来源地为江苏和南京两地，请问近年公司有无向全国化经营计划?",
        "questondate": "20200603",
        "answerer": "浦发银行",
        "answer": "公司为全国性商业银行，总部位于上海。截至2019年末，已在31个省、直辖市、自治区以及香港特别行政区、新加坡、伦敦开设了41家一级分行，共1,606个分支机构。公司营收来源并非主要来自江苏地区。感谢您的关注！",
        "answerdate": "20200612",
        "id": "594749"
    }, {
        "symbol": "600000.sh",
        "questioner": "沉默是金109",
        "question": "请问2019年度利润分配公布了，为啥还没有公布啥时候开股东大会审核？为啥还不公布分红登记日？",
        "questondate": "20200521",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，具体时间尚未确定。感谢您的关注！",
        "answerdate": "20200602",
        "id": "586317"
    }, {
        "symbol": "600000.sh",
        "questioner": "黄海之滨苏州",
        "question": "请问邹董：公司在原整理车间开始生产熔喷布项目，有无经过项目详细认证，可行性研究？别的地方都开始转产了，公司才开始着手生产，是否风险太大？公司折腾不起了呀！请务必转告董事会",
        "questondate": "20200520",
        "answerer": "浦发银行",
        "answer": "您好，请咨询相关企业，谢谢！",
        "answerdate": "20200602",
        "id": "584816"
    }, {
        "symbol": "600000.sh",
        "questioner": "崔赵雯",
        "question": "你好，请问贵公司对经理人是更注重学历还是工作能力呢？我注意到你们一直没有公布刘信义、王红兵的学历和毕业院校，只公布了黄建平的最后学历，能不能提供一下这方面更为详细的信息呢？谢谢。",
        "questondate": "20200526",
        "answerer": "浦发银行",
        "answer": "公司在年度报告中披露董事、监事和高级管理层的简历。感谢您的关注！",
        "answerdate": "20200602",
        "id": "589321"
    }, {
        "symbol": "600000.sh",
        "questioner": "测试主账号",
        "question": "这次分红的股权登记日是什么时间",
        "questondate": "20200602",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，具体时间尚未确定。感谢您的关注！",
        "answerdate": "20200602",
        "id": "593217"
    }, {
        "symbol": "600000.sh",
        "questioner": "your",
        "question": "想查询一下股东名册，该如何操作",
        "questondate": "20200526",
        "answerer": "浦发银行",
        "answer": "公司在定期报告中披露股东相关情况。感谢您的关注！",
        "answerdate": "20200602",
        "id": "589949"
    }, {
        "symbol": "600000.sh",
        "questioner": "丁三石",
        "question": "我们都在等分红，哪天股权登记日？",
        "questondate": "20200515",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，目前股权登记日未定。感谢您的关注！",
        "answerdate": "20200519",
        "id": "579427"
    }, {
        "symbol": "600000.sh",
        "questioner": "1861638zhang",
        "question": "分点红为何要拖多久，给股民一点信心",
        "questondate": "20200511",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，感谢您的关注！",
        "answerdate": "20200519",
        "id": "574663"
    }, {
        "symbol": "600000.sh",
        "questioner": "可爱的志龙",
        "question": "问董秘:分红除权除息日具体时间?",
        "questondate": "20200513",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，具体时间尚未确定。感谢您的关注！",
        "answerdate": "20200519",
        "id": "578035"
    }, {
        "symbol": "600000.sh",
        "questioner": "咕噜咕噜转转转",
        "question": "今年现金分红比例达到了利润的30%，请问能否在公司章程中明确今后几年现金分红比例不少于利润的30%？",
        "questondate": "20200519",
        "answerer": "浦发银行",
        "answer": "利润分配方案的制定需要考虑结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。公司未来在制定年度利润分配预案时，将通过多种形式听取股东意见和诉求。感谢您的关注！",
        "answerdate": "20200519",
        "id": "581230"
    }, {
        "symbol": "600000.sh",
        "questioner": "专业",
        "question": "你好，请问公司全面复工了吗？",
        "questondate": "20200508",
        "answerer": "浦发银行",
        "answer": "公司严格按照中央和各地党委政府关于疫情防控相关要求，在保护好客户和员工生命安全和身体健康的同时，保障公司运转正常有序。根据国务院关于春节假期延迟规定并结合金融监管机构的要求，公司已于2月3日起实行复工，以服务防控疫情企业资金需求、支持企业恢复生产。感谢您的关注！",
        "answerdate": "20200513",
        "id": "564227"
    }, {
        "symbol": "600000.sh",
        "questioner": "咕噜咕噜转转转",
        "question": "在目前疫情下，1、国家要求银行多支持企业困难等政策，浦发呆坏账问题在近年来还是比较高，请问浦发是否会放松了风险控制？2、请问浦发的各大股东们能否提议浦发2019年度不分红，把资金留在浦发中继续发展，与浦发共渡时艰？",
        "questondate": "20200508",
        "answerer": "浦发银行",
        "answer": "公司高度重视疫情防控和促进经济发展工作，及时推出了一系列有针对性举措，全力支持企业经营发展、做好个人金融服务。一是对企业客户，及时调整部分信贷政策，切实优化内部审批流程：对重点防疫物资保障企业，以白名单方式支持；对受疫情影响较大的行业，调整授信策略予以支持；二是对个人客户，为到期还款资金不足或还款不便的客户提供宽限期服务；三是发挥平台服务能力，履行企业社会责任。公司在支持实体经济的发展过程中，将持续加强风险管理，夯实资产质量。关于利润分配预案，公司通过多种形式听取股东意见和诉求，使利润分配既能结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，又能兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20200513",
        "id": "556724"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "建议浦发银行APP增加几项功能，可以扫微信，支付宝等付款，也可以直接收微信，支付宝的付款",
        "questondate": "20200424",
        "answerer": "浦发银行",
        "answer": "感谢您的建议，公司将持续推进业务创新。公司已推出手机智能APP10.0，以“开放、温暖、聪明、懂你”为理念，数字化改版升级手机银行APP四大频道及我的账户、理财等服务，推出开放式用户体系、互动式营销服务平台等，构建开放式零售APP体系。感谢您的关注！",
        "answerdate": "20200430",
        "id": "567093"
    }, {
        "symbol": "600000.sh",
        "questioner": "暴跌一毛钱",
        "question": "请问贵公司2020年股权登记日是多会？2021年多会分红派息？",
        "questondate": "20200421",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，目前股权登记日未定。感谢您的关注！",
        "answerdate": "20200430",
        "id": "564913"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "这次分红的股权登记日是几月几号",
        "questondate": "20200427",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配方案尚须股东大会审议通过后方可实施，目前股权登记日未定。感谢您的关注！",
        "answerdate": "20200430",
        "id": "568307"
    }, {
        "symbol": "600000.sh",
        "questioner": "Lily呀",
        "question": "最近疫情严重，虽然国内形式已经好转，但国外却在大量爆发。这种情况会影响国内股市吗？对贵公司影响大吗？",
        "questondate": "20200402",
        "answerer": "浦发银行",
        "answer": "疫情发生以来，公司高度重视疫情防控和促进经济发展工作。公司快速响应政府要求，及时推出了一系列有针对性举措。在此次疫情防控中，公司近年来数字化转型的一些成果得到充分展现，除监管部门规定必须面对面办理以外，其余所有个人业务均实现线上经营。公司作为全国首家实现智能语音服务电话全覆盖的银行，实现AI智能客服，有效规避了客服人员集中办公。与此同时，公司采取特殊信贷政策和服务方式，全力支持企业经营发展、做好个人金融服务，积极参与各类金融要素市场建设。感谢您的关注！",
        "answerdate": "20200407",
        "id": "549038"
    }, {
        "symbol": "600000.sh",
        "questioner": "12345677654321吖",
        "question": "请问董秘，截止2020年3月31日贵公司股东人数有多少？",
        "questondate": "20200402",
        "answerer": "浦发银行",
        "answer": "公司股东相关数据将在后续公告的2020年度第一季度报告中披露。感谢您的关注！",
        "answerdate": "20200402",
        "id": "552990"
    }, {
        "symbol": "600000.sh",
        "questioner": "tobelchl",
        "question": "请问上市公司年报哪里可以查询？",
        "questondate": "20200330",
        "answerer": "浦发银行",
        "answer": "您可以在交易所网站上市公司公告（http://www.sse.com.cn）或在公司官网（http://www.spdb.com.cn）中查找我公司定期报告。感谢您的关注！",
        "answerdate": "20200402",
        "id": "552053"
    }, {
        "symbol": "600000.sh",
        "questioner": "hello3505",
        "question": "2020一季度财报什么时候发布",
        "questondate": "20200330",
        "answerer": "浦发银行",
        "answer": "公司2020年第一季度报告预计将于4月25日对外披露。感谢您的关注！",
        "answerdate": "20200402",
        "id": "552028"
    }, {
        "symbol": "600000.sh",
        "questioner": "axt10",
        "question": "请问贵公司近期是否有收购计划",
        "questondate": "20200326",
        "answerer": "浦发银行",
        "answer": "公司无相关应披露而未披露事项。感谢您的关注！",
        "answerdate": "20200402",
        "id": "549567"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2019",
        "question": "你好董秘！浦发银行中小股东，提请建议董事会提高2019年现金分红比例每股分红0.50元以上！，虽然浦发银行近几年出现很多问题，但是回报股东也有利于大股东！同时，浦发银行应该尽快实现员工持股激励方案，按照政府国企国有金融企业改革要求.谢谢！",
        "questondate": "20200303",
        "answerer": "浦发银行",
        "answer": "公司将通过多种形式听取股东意见和诉求，使利润分配能够结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，并兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。同时，公司高管层于18年7月和19年6月以自有资金分别购入40万股和40.8万股公司股票，所购股票承诺自买入之日起锁定两年，高管买入股票是公司继续完善激励约束机制改革的举措。感谢您的建议！",
        "answerdate": "20200319",
        "id": "535821"
    }, {
        "symbol": "600000.sh",
        "questioner": "可心824",
        "question": "请问贵行大概何时公布2019年度分红派息方案？谢谢",
        "questondate": "20200312",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配预案尚需董事会审议，并由股东大会审议通过后实施，预计利润分配预案发布时间与年报公告时间一致。同时，公司将通过多种形式听取股东意见和诉求，使利润分配能够结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，并兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20200319",
        "id": "541855"
    }, {
        "symbol": "600000.sh",
        "questioner": "股票大作手1542",
        "question": "董秘你好，公司控股的浦银安盛基金管理有限公司，其控股的嘉兴慧光股权投资基金合伙企业（有限合伙），是否持有新冠疫苗生产企业康希诺股份？",
        "questondate": "20200319",
        "answerer": "浦发银行",
        "answer": "公司主要投资企业经营情况可在年报等定期报告中查询，感谢您的关注！",
        "answerdate": "20200319",
        "id": "544981"
    }, {
        "symbol": "600000.sh",
        "questioner": "夜雨暹罗",
        "question": "请问去哪里可以查到以前的上证50成分股名单，就比如想找08年的上证50构成的成分股是哪些？求求大神知道，谢谢。",
        "questondate": "20200311",
        "answerer": "浦发银行",
        "answer": "请至上交所官网（http://www.sse.com.cn/）查询有关信息。感谢您的关注！",
        "answerdate": "20200319",
        "id": "540907"
    }, {
        "symbol": "600000.sh",
        "questioner": "kancd",
        "question": "建议贵公司赶快发一份2019年业绩预报，以解大家的各种不必要的猜测，毕竟贵公司信誉不好尤其是信息披露方面是有前科的，可以吗？",
        "questondate": "20200227",
        "answerer": "浦发银行",
        "answer": "公司业绩快报已于1月22日披露。自上市以来，公司始终严格按照法律、法规和公司章程，以及公司信息披露制度的规定，真实、准确、完整、及时地披露有关信息，并确保所有股东有平等的机会获得信息，并无信息披露违规的情形。感谢您的关注！",
        "answerdate": "20200302",
        "id": "532532"
    }, {
        "symbol": "600000.sh",
        "questioner": "可心824",
        "question": "浦发银行2019年留存收益率多少",
        "questondate": "20200225",
        "answerer": "浦发银行",
        "answer": "公司业绩快报已于1月22日披露。其他详尽的财务数据将在2019年年度报告中披露。感谢您的关注！",
        "answerdate": "20200302",
        "id": "530140"
    }, {
        "symbol": "600000.sh",
        "questioner": "致富济贫",
        "question": "请问疫情对公司业务产生的影响是正面还是负面？具体有哪方面？会持续吗?",
        "questondate": "20200225",
        "answerer": "浦发银行",
        "answer": "公司认真贯彻落实党中央、国务院和监管机构、各级地方政府关于疫情防控的各项部署和要求，统一思想认识，积极主动履职，压实疫情防控责任。公司持续加大服务实体经济的力度，以专业、优质、高效的金融服务全力以赴助力打赢疫情防控阻击战。公司主动加强服务对接，积极满足卫生防疫、医药产品制造及采购、公共卫生基础设施建设、科研攻关等方面的合理融资需求；对于受疫情影响较大行业不盲目抽贷、断贷、压贷，积极完善续贷政策，支持相关企业战胜疫情。感谢您的关注！",
        "answerdate": "20200227",
        "id": "524280"
    }, {
        "symbol": "600000.sh",
        "questioner": "干锅醋鱼头",
        "question": "董秘，你好！请问公司四季度不良率提升，是否与主动加大不良资产处置力度有关。盼回复。",
        "questondate": "20200122",
        "answerer": "浦发银行",
        "answer": "为应对外部复杂环境，满足更为审慎的监管要求，公司进一步夯实资产质量，稳妥有序处置存量风险，年末不良贷款率有所上升，但总体风险可控，信贷业务运行平稳。感谢您的关注！",
        "answerdate": "20200212",
        "id": "517652"
    }, {
        "symbol": "600000.sh",
        "questioner": "樊凡",
        "question": "什么原因今年一致未出年报预报",
        "questondate": "20200110",
        "answerer": "浦发银行",
        "answer": "公司业绩快报已于1月22日披露。感谢您的关注！",
        "answerdate": "20200212",
        "id": "514131"
    }, {
        "symbol": "600000.sh",
        "questioner": "咕噜咕噜转转转",
        "question": "请问贵行今年的分红政策是怎样的？现金分红还是转赠股票？",
        "questondate": "20200110",
        "answerer": "浦发银行",
        "answer": "公司2019年度利润分配预案尚需董事会审议，并由股东大会审议通过后实施。同时，公司将通过多种形式听取股东意见和诉求，使利润分配能够结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，并兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20200212",
        "id": "513884"
    }, {
        "symbol": "600000.sh",
        "questioner": "松song",
        "question": "公司坚持十来年1月5日左右的年度业绩快报不出了？就是因为换了领导？不与时俱进，也不能倒退啊，希望公司坚持以往的信批风格，尽快公告业绩快报。不要让股东失望。",
        "questondate": "20200107",
        "answerer": "浦发银行",
        "answer": "公司业绩快报已于1月22日披露。感谢您的关注！",
        "answerdate": "20200212",
        "id": "512497"
    }, {
        "symbol": "600000.sh",
        "questioner": "任朝峰",
        "question": "贵司业绩快报以前新年第二个交易日必发，今年何时发？",
        "questondate": "20200107",
        "answerer": "浦发银行",
        "answer": "公司业绩快报已于1月22日披露。感谢您的关注！",
        "answerdate": "20200212",
        "id": "512501"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好！董秘！提个建议转给董事会总经理：有关信用卡，浦发的网上申请信用卡填写跟不上社会发展了，竟然还有公司固定电话这个必须写的东西，很多中小公司已经没有固定电话了！就因为这个必须填写公司固定电话的阻碍，浦发丧失了很多客户，浦发银行的服务真的无法和招商银行比较，建议浦发银行给所有持有浦发股票一年以上的股东发放信用卡，这是多好的广告扩大客户效应，希望赶快改革，",
        "questondate": "20200109",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！我行信用卡官方网站为https://ccc.spdb.com.cn/，网上申请信用卡无需填写固定电话。您可以致电我行客服热线95528，或信用卡24小时服务热线：4008208788、02138784988获取更多信息。感谢您的关注！",
        "answerdate": "20200116",
        "id": "513267"
    }, {
        "symbol": "600000.sh",
        "questioner": "矜筱诺",
        "question": "测试提问",
        "questondate": "20191220",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20191225",
        "id": "507684"
    }, {
        "symbol": "600000.sh",
        "questioner": "elistone",
        "question": "请问公司四季度原材料采购价格变动趋势如何？稳中有降还是基本不变。",
        "questondate": "20191218",
        "answerer": "浦发银行",
        "answer": "公司为金融服务业，不涉及原材料采购。感谢您的关注！",
        "answerdate": "20191225",
        "id": "506988"
    }, {
        "symbol": "600000.sh",
        "questioner": "可爱的志龙",
        "question": "请问今年什么时候出年报",
        "questondate": "20191220",
        "answerer": "浦发银行",
        "answer": "公司将根据法律法规、监管机构和股票上市规则的要求编制定期报告，并在交易所预约披露时间，您可通过交易系统查询相关信息。感谢您的关注！",
        "answerdate": "20191225",
        "id": "507612"
    }, {
        "symbol": "600000.sh",
        "questioner": "爱岗敬业是底线",
        "question": "公司股价大幅低于净资产，严重低估，建议公司推出回购方案，以回报公司股东，提升公司资本市场形象，谢谢。",
        "questondate": "20191129",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同，公司将按照行业监管机构的要求，加强和提高资本管理的能力与效率，提升银行服务实体经济的能力。感谢您的关注！",
        "answerdate": "20191217",
        "id": "503119"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_1264930",
        "question": "请问浦发相对于四大行的核心竞争力在哪些方面，谢谢",
        "questondate": "20191129",
        "answerer": "浦发银行",
        "answer": "近年来，公司围绕五年发展战略规划和“以客户为中心，科技引领，打造一流数字生态银行”战略目标，着力提升服务实体经济的质效。坚持“回归本源、突出主业、做精专业、协调发展”的经营理念，按照“调结构、稳增长；严合规、提质量；优管理、强能力”的经营主线，努力提升集团整体经营能力和竞争优势。 公司拥有银行、租赁、基金、信托、货币经纪、境外投行等多种金融牌照，具备了为客户提供综合化金融服务的能力。公司高度重视“数字化”战略推进，以数字化重点项目为抓手推进全行数字化转型，实现增长动力转换。公司持续提升集约化经营管理水平，可持续发展能力不断增强。优化资源配置规则，促进符合调结构导向的信贷投放，引导负债结构优化，资产负债管理能力进一步提升。公司稳步推进国际化经营，逐步完善涉外机构和业务功能布局，持续保持国际业务良好增长势头。感谢您的关注！",
        "answerdate": "20191217",
        "id": "503130"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "强烈建议公司马上回购自家股票，用回购代替分红。",
        "questondate": "20191203",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，在回购公司股票上与普通上市公司不同。公司也按照行业监管机构的要求，加强和提高资本管理的能力与效率，提升银行服务实体经济的能力。感谢您的关注！",
        "answerdate": "20191217",
        "id": "503723"
    }, {
        "symbol": "600000.sh",
        "questioner": "渔舟11",
        "question": "请问公司怎么看待后两年粮食价格走势？",
        "questondate": "20191126",
        "answerer": "浦发银行",
        "answer": "公司主营业务与粮食价格关联不大。感谢您的关注！",
        "answerdate": "20191126",
        "id": "501850"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好，浦发银行董事长总经理董秘：作为长期浦发银行股东，提个建议，有关于浦发硅谷银行作为升级转型投资银行模式改革试点的第一家，作为控股股东，面对中国政府的针对外资银行的限制取消的开放政策，应该作为引导中国金融业升级转型的旗帜排头兵大踏步前进了，尤其是科创板，浦发硅谷银行应该积极谋求科创板上市，谋求更大的市场引导榜样作用，",
        "questondate": "20191126",
        "answerer": "浦发银行",
        "answer": "从成立以来，浦发硅谷银行致力于服务中国的科技创新企业，并在中国打造“科技创新生态系统”，努力成为中国科技创新企业及其投资人的优选银行。感谢您的建议！",
        "answerdate": "20191126",
        "id": "501685"
    }, {
        "symbol": "600000.sh",
        "questioner": "傲龙堡二堡主夫人",
        "question": "请问正股配发的转债什么时候到账？",
        "questondate": "20191113",
        "answerer": "浦发银行",
        "answer": "公司发行的可转换公司债券已于2019年11月15日上市流通（可转债代码：110059，可转债简称：浦发转债）。感谢您的关注！",
        "answerdate": "20191118",
        "id": "498861"
    }, {
        "symbol": "600000.sh",
        "questioner": "有问题",
        "question": "你好，请问贵公司的债券什么时候上市呢？",
        "questondate": "20191031",
        "answerer": "浦发银行",
        "answer": "公司发行的可转换公司债券已于2019年11月15日上市流通（可转债代码：110059，可转债简称：浦发转债）。感谢您的关注！",
        "answerdate": "20191118",
        "id": "494778"
    }, {
        "symbol": "600000.sh",
        "questioner": "WWW601019",
        "question": "董秘你好，请问最近央行降息和降准对银行收益的综合影响如何？你行有什么措施来降低利率政策对公司的影响？谢谢你",
        "questondate": "20191106",
        "answerer": "浦发银行",
        "answer": "公司将继续保持对实体经济的支持力度，增加投放，加强合意资产储备，优化客户结构和资产结构，强化客户经营体系建设，提升综合收益；通过资产负债结构优化、控制负债水平等方面措施，保持净息差水平基本稳定，保持营收和利润的稳定。感谢您的关注！",
        "answerdate": "20191108",
        "id": "496824"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "什么时候发转债，谢谢",
        "questondate": "20191009",
        "answerer": "浦发银行",
        "answer": "公司于10月24日公告了《公开发行可转换公司债券发行公告》，本次发行的优先配售日和网上申购日为2019年10月28日（T日），网下申购日为2019年10月25日。发行结束后，公司将尽快申请本次发行的可转债在上交所上市，具体上市时间将另行公告。感谢您的关注！",
        "answerdate": "20191028",
        "id": "489092"
    }, {
        "symbol": "600000.sh",
        "questioner": "冰比冰水冰",
        "question": "我对公司有如下几个建议1结合大股东中国移动在全国布局的优势和在科技及内容方面成就更好服务客户2结合上汽集团的优势地位及公司金融方面优势近一步扩展高端客户3结合上海国际金融中心的优势加强和顶尖投行合作为客户提供更多优质产品",
        "questondate": "20191024",
        "answerer": "浦发银行",
        "answer": "非常感谢您的建议，公司将依托股东及地域优势，以支持国家建设发展为根本，立足服务实体经济，积极创新转型发展。感谢您的关注！",
        "answerdate": "20191028",
        "id": "492436"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_1294238",
        "question": "您好！请问贵行是否有将信用卡分期手续费收入计入利息收入？在计算净息差的时是否也有列入？",
        "questondate": "20190808",
        "answerer": "浦发银行",
        "answer": "公司按照有关财务会计准则核算相关业务。感谢您的关注！",
        "answerdate": "20191028",
        "id": "475144"
    }, {
        "symbol": "600000.sh",
        "questioner": "安娜rujg03",
        "question": "请问贵行信用卡分期收入是否计入利息收入？还是手续费佣金收入",
        "questondate": "20190925",
        "answerer": "浦发银行",
        "answer": "公司按照有关财务会计准则核算相关业务。感谢您的关注！",
        "answerdate": "20191028",
        "id": "487267"
    }, {
        "symbol": "600000.sh",
        "questioner": "LIGANG121",
        "question": "为什么上次募集的资金还没用完，买理财。又募集资金？钱多未必是好事。",
        "questondate": "20190930",
        "answerer": "浦发银行",
        "answer": "资本金是商业银行健康发展和服务实体经济的基础，监管机构亦对银行的资本有最低要求。感谢您的关注！",
        "answerdate": "20191008",
        "id": "488005"
    }, {
        "symbol": "600000.sh",
        "questioner": "派打新",
        "question": "贵公司赞助的休斯敦火箭队总经理莫雷公然支持港独，如果火箭队不解雇莫雷或者莫雷公开道歉，请正视网络舆情，妥善处理赞助休斯敦火箭队事宜。",
        "questondate": "20191008",
        "answerer": "浦发银行",
        "answer": "10月6日，我行信用卡中心公开发表声明，浦发银行信用卡中心已暂停相关市场活动和宣传，并继续敦促休斯顿火箭队对此事件展开彻查并给予合理回复。感谢您的关注！",
        "answerdate": "20191008",
        "id": "488622"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_iqgeuq",
        "question": "明年分红率能达30%吗",
        "questondate": "20190920",
        "answerer": "浦发银行",
        "answer": "在利润分配前，公司将通过多种形式听取股东意见和诉求，使利润分配能够结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，并兼顾了投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20190927",
        "id": "486003"
    }, {
        "symbol": "600000.sh",
        "questioner": "价值投资观察员",
        "question": "请问贵行截止2019年上半年的所有资产减值损失准备金额有多少？",
        "questondate": "20190926",
        "answerer": "浦发银行",
        "answer": "截至2019年半年末，集团合计的资产减值准备为1205.41亿元。感谢您的关注！",
        "answerdate": "20190927",
        "id": "487560"
    }, {
        "symbol": "600000.sh",
        "questioner": "通通顺",
        "question": "强烈建议改进中签扣款制度，修改为允许用户九点半至四点提前扣款！否则忙起来会忘记中签，或是购国债逆回购忘了留钱！！！因制度设计有瑕疵，导致用户半年沒法打新不合理！！！",
        "questondate": "20190925",
        "answerer": "浦发银行",
        "answer": "请您向有关证券监管机构建议，谢谢。",
        "answerdate": "20190927",
        "id": "487120"
    }, {
        "symbol": "600000.sh",
        "questioner": "xxxxxzzp28",
        "question": "您好 请问一下关于贵公司电算化运用程度达到多少?",
        "questondate": "20190903",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20190917",
        "id": "482102"
    }, {
        "symbol": "600000.sh",
        "questioner": "xxxxxzzp28",
        "question": "您好，请问贵公司电算化用的是什么软件，该相应人员是否能熟悉掌握该功能?",
        "questondate": "20190903",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20190917",
        "id": "482104"
    }, {
        "symbol": "600000.sh",
        "questioner": "上市调研联盟咨询集团",
        "question": "怎么查到财报的附注部分？和关联股东的关联交易，怎么查看？",
        "questondate": "20190911",
        "answerer": "浦发银行",
        "answer": "您可以登录交易所网站（www.sse.com.cn）上市公司公告，或至公司官网投资者关系栏目下（https://news.spdb.com.cn/investor_relation/company_report/）查询公司定期报告全文及财务报表附注。公司在年报和半年报的“重要事项”章节中有披露关联交易事项的相关情况。感谢您的关注！",
        "answerdate": "20190917",
        "id": "483950"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "按照《上海市开展区域性国资国企综合改革试验的实施方案》在上海地方国有金融上市公司探索股权激励试点。浦发银行董事会应该立即实施股权激励机制，促进调动管理人员积极性和认同感责权利意识觉醒，实现员工持股和股东权益最大化同步进行。结合发行可转债和股权激励方案，利润增长指标化，有效提升浦发银行市场价值，董事会必须积极提升股东意识，作为长期股东，希望浦发银行董事会赶快行动，",
        "questondate": "20190906",
        "answerer": "浦发银行",
        "answer": "感谢您的建议，目前公司尚未开展股权激励。公司高管层于去年7月和今年6月以自有资金分别购入40万股和40.8万股公司股票，所购股票承诺自买入之日起锁定两年。高管买入股票是公司继续完善激励约束机制改革的举措。感谢您的关注！",
        "answerdate": "20190917",
        "id": "482984"
    }, {
        "symbol": "600000.sh",
        "questioner": "大地黑白熊王",
        "question": "你好董秘，我也是公司老股东，已持股多年，今天才发现这里可以要纸质版年报。能给我一份吗？便于对公司进一步研究分析，需要 2017，2018年年报纸质版，可以寄一份给我吗？非常感谢 地址：河北省石家庄市新华区合作路203号 电话：17732303508 谢谢！",
        "questondate": "20190802",
        "answerer": "浦发银行",
        "answer": "没问题。感谢您的关注！",
        "answerdate": "20190903",
        "id": "473370"
    }, {
        "symbol": "600000.sh",
        "questioner": "lht15",
        "question": "请问贵公司子产品的费率是多少？",
        "questondate": "20190826",
        "answerer": "浦发银行",
        "answer": "请致电公司客服热线95528，或前往就近的公司网点咨询。感谢您的关注！",
        "answerdate": "20190903",
        "id": "479543"
    }, {
        "symbol": "600000.sh",
        "questioner": "bowiefan",
        "question": "请问，贵司何时分红？",
        "questondate": "20190812",
        "answerer": "浦发银行",
        "answer": "您好，公司2018年度利润分配已于2019年6月11日完成。感谢您的关注！",
        "answerdate": "20190903",
        "id": "476250"
    }, {
        "symbol": "600000.sh",
        "questioner": "826ywy",
        "question": "请问贵公司，从自己的角度怎么看会计学专业的就业前景，以及随着网络不断发展，贵公司对于财务人员的就业入职要求是否会更高呢？",
        "questondate": "20190826",
        "answerer": "浦发银行",
        "answer": "浦发银行始终把员工的成长和发展作为人力资源工作的出发点和落脚点。感谢您的关注！",
        "answerdate": "20190903",
        "id": "479682"
    }, {
        "symbol": "600000.sh",
        "questioner": "麟禾麒然",
        "question": "贵行有什么科技金融和数字金融发展吗？",
        "questondate": "20190826",
        "answerer": "浦发银行",
        "answer": "公司并制定了“打造一流数字生态银行”的战略目标，并加快“数字化”战略推进，以数字化重点项目为抓手推进全行数字化转型，实现增长动力转换。2019年，公司不断探索实践 API Bank 开放银行专营路径，打造新零售网聚生态圈；立足创新前沿，推出“智能语音银行”，率先提出实施虚拟“数字人”创新理念；打造数据即服务能力，以数据建模及服务驱动业务转型；新成立数据驱动等三个联合创新实验室，扩容“科技合作共同体”至22家。感谢您的关注！",
        "answerdate": "20190903",
        "id": "479699"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_r5f2ym",
        "question": "哪里找年报",
        "questondate": "20190827",
        "answerer": "浦发银行",
        "answer": "您可以登录交易所网站（www.sse.com.cn）查询，或至公司官网投资者关系栏目下查询（https://news.spdb.com.cn/investor_relation/company_report/）。感谢您的关注！",
        "answerdate": "20190903",
        "id": "480127"
    }, {
        "symbol": "600000.sh",
        "questioner": "mbb123",
        "question": "董秘你好 公司上市后，资本公积和未分配利润较多，公司半年利润也实现高速增长。下一步公司有无打算回馈股东，分现金红利或者转增资本，提高股票交易流动性。 很多公司半年报也分红，这次会分红吗？",
        "questondate": "20190902",
        "answerer": "浦发银行",
        "answer": "公司积极贯彻落实中国证监会、上海证券交易所等监管机构有关上市公司现金分红等新的要求，切实保护投资者的合法利益，《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。在利润分配前，公司将通过多种形式听取中小股东意见和诉求，使利润分配能够结合公司的行业特点、发展阶段和自身盈利水平、资本需求等因素，并兼顾了投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20190903",
        "id": "481933"
    }, {
        "symbol": "600000.sh",
        "questioner": "1861638zhang",
        "question": "请问什么时候披露业绩快报啊",
        "questondate": "20190725",
        "answerer": "浦发银行",
        "answer": "请以公司公告为准。感谢您的关注！",
        "answerdate": "20190812",
        "id": "471384"
    }, {
        "symbol": "600000.sh",
        "questioner": "niefeier",
        "question": "担保物数据可以从哪儿里找",
        "questondate": "20190731",
        "answerer": "浦发银行",
        "answer": "公司披露的2018年年度报告中有按担保方式分类的贷款情况。感谢您的关注！",
        "answerdate": "20190812",
        "id": "472594"
    }, {
        "symbol": "600000.sh",
        "questioner": "月光莫利亚",
        "question": "公司一直解释的宏观经济环境和产业波动等等只有公司受影响？其他同行业股也没公司那么跌的那么夸张，公司何时在自身找问题",
        "questondate": "20190801",
        "answerer": "浦发银行",
        "answer": "感谢您的关注，我们会公司将继续努力经营，持续为股东赢取回报，为社会创造价值。",
        "answerdate": "20190812",
        "id": "472913"
    }, {
        "symbol": "600000.sh",
        "questioner": "百炼",
        "question": "我是公司的老股东，现需要2018年年报纸质版，地址河南省汝州市美庐园小区1号楼19939030036。",
        "questondate": "20190729",
        "answerer": "浦发银行",
        "answer": "没问题。感谢您的关注！",
        "answerdate": "20190731",
        "id": "471973"
    }, {
        "symbol": "600000.sh",
        "questioner": "hmnsc",
        "question": "您好！浦发换帅，新官上任三把火。未来股价会不会恢复到与净资产持平呢？",
        "questondate": "20190715",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。感谢您的关注！",
        "answerdate": "20190731",
        "id": "468100"
    }, {
        "symbol": "600000.sh",
        "questioner": "富仁坊",
        "question": "请问: 公司股价长期低于净资产， 公司将采取什么措施稳定股价！",
        "questondate": "20190725",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同。感谢您的关注！",
        "answerdate": "20190731",
        "id": "471223"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "如果浦发追赶招行需要时间和不懈的努力，那么象招行一样在公司章程中规定每年净利润的30%拿出来分红这是完全可以做到的，这对公司的股东和股价都是非常有利的，这点你们为什么不去做？",
        "questondate": "20190610",
        "answerer": "浦发银行",
        "answer": "公司利润分配结合了行业特点、发展阶段和自身盈利水平、资本需求等因素，又兼顾了投资者分享公司成长、发展成果，取得合理投资回报等要求。感谢您的关注！",
        "answerdate": "20190708",
        "id": "458308"
    }, {
        "symbol": "600000.sh",
        "questioner": "岚色天空",
        "question": "董秘，我是公司老股东，已持股多年，对公司发展充满信心,便于对公司进一步研究分析，需要 2017，2018年年报纸质版，可以寄一份给我吗？ 地址：山东青岛李沧区黑龙江路中海御城，孙先生收 电话：15689997009 谢谢！",
        "questondate": "20190530",
        "answerer": "浦发银行",
        "answer": "不客气，我们尽快寄出。感谢您的关注！",
        "answerdate": "20190610",
        "id": "455135"
    }, {
        "symbol": "600000.sh",
        "questioner": "大周2230",
        "question": "请问，截至2019年5月24日，公司的股东总数是多少？谢谢",
        "questondate": "20190524",
        "answerer": "浦发银行",
        "answer": "公司在定期报告里披露股东总数。截至2019年3月31日，公司股东总户数为190,370户。感谢您的关注！",
        "answerdate": "20190529",
        "id": "453646"
    }, {
        "symbol": "600000.sh",
        "questioner": "Yemi1916",
        "question": "请问浦发银行的股票属于分为成长股、价值股、周期股三类中的哪一类？给股民带来的收益是持续的吗？",
        "questondate": "20190524",
        "answerer": "浦发银行",
        "answer": "我们认为公司难以以某一类股票类型来概括。浦发银行始终坚持以打造一流数字生态银行为目标，做精主业、行稳致远，为实现高质量发展而奋斗，为客户、员工、股东以及各利益相关方创造更多的价值，全力营造良好的市场环境，促进资本市场稳定运行。感谢您的关注！",
        "answerdate": "20190529",
        "id": "453657"
    }, {
        "symbol": "600000.sh",
        "questioner": "杨4446",
        "question": "你好，请问浦发银行的半年报什么时候公布",
        "questondate": "20190524",
        "answerer": "浦发银行",
        "answer": "目前2019年上半年度尚未结束，公司将按照上市规则和有关的监管规定按时披露定期报告。感谢您的关注！",
        "answerdate": "20190529",
        "id": "453665"
    }, {
        "symbol": "600000.sh",
        "questioner": "Cap_4821",
        "question": "你好，公司第一季度业绩怎样，对接下来有什么展望呢？",
        "questondate": "20190529",
        "answerer": "浦发银行",
        "answer": "2019年第一季度，公司面对经济、金融形势和市场状况的新变化，围绕“以客户为中心，科技引领,打造一流数字生态银行”战略目标和“调结构、稳增长；严合规、提质量；优管理、强能力”经营主线，着力推进高质量发展，实现了稳中有进的良好开局。经营效益方面实现集团税后归属于母公司股东的净利润164.59亿元，同比增加21.54亿元，增长15.06%；实现营业收入500.84亿元，同比增加106.53亿元，增长27.02%。公司资产规模稳步增长，存款增长表现亮眼。公司信贷业务运行平稳，继续保持不良贷款余额及不良率 “双降”、拨备覆盖率及拨贷比“双升”的趋势。 今年，公司将坚持稳中求进的工作总基调，积极服务实体经济，坚决防范金融风险，围绕经营主线，积极推进一流数字生态银行建设和五年规划实施，努力实现公司高质量可持续发展。感谢您的关注！",
        "answerdate": "20190529",
        "id": "454264"
    }, {
        "symbol": "600000.sh",
        "questioner": "Sibyl3086",
        "question": "请问今年的分红派息日大概是什么时候呢？",
        "questondate": "20190524",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布。感谢您的关注！",
        "answerdate": "20190529",
        "id": "453247"
    }, {
        "symbol": "600000.sh",
        "questioner": "大周2230",
        "question": "你好，贵公司如何看待市值低于净资产，是否存在较严重的资产高估情况？",
        "questondate": "20190527",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。感谢您的关注！",
        "answerdate": "20190529",
        "id": "453846"
    }, {
        "symbol": "600000.sh",
        "questioner": "农夫钓鱼",
        "question": "请问，截至2019年5月20日，公司的股东总数是多少？谢谢",
        "questondate": "20190521",
        "answerer": "浦发银行",
        "answer": "公司在定期报告里披露股东总数。截至2019年3月31日，公司股东总户数为190,370户。感谢您的关注！",
        "answerdate": "20190523",
        "id": "451860"
    }, {
        "symbol": "600000.sh",
        "questioner": "然然jp",
        "question": "尊敬的各位管理层好,请问贵公司今年预计什么时候分红派息",
        "questondate": "20190507",
        "answerer": "浦发银行",
        "answer": "公司利润分配实施公告尚未发布。感谢您的关注！",
        "answerdate": "20190523",
        "id": "446440"
    }, {
        "symbol": "600000.sh",
        "questioner": "mochakong",
        "question": "您好！请问贵公司截至到今日的股东数多少？谢谢",
        "questondate": "20190515",
        "answerer": "浦发银行",
        "answer": "公司在定期报告里披露股东总数。截至2019年3月31日，公司股东总户数为190,370户。感谢您的关注！",
        "answerdate": "20190523",
        "id": "450038"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_1264930",
        "question": "董秘您好，请问截至0519的股东人数是多少？",
        "questondate": "20190520",
        "answerer": "浦发银行",
        "answer": "公司在定期报告里披露股东总数。截至2019年3月31日，公司股东总户数为190,370户。感谢您的关注！",
        "answerdate": "20190523",
        "id": "451362"
    }, {
        "symbol": "600000.sh",
        "questioner": "kulryk",
        "question": "你好，董秘，请问18年报显示每股经营性现金流为-11.5277元，是什么原因造成的，是否影响到公司的正常经营？17年的年报也为负数-4.7926元，公司的管理是否出现了问题，公司又将如何应对？",
        "questondate": "20190408",
        "answerer": "浦发银行",
        "answer": "公司现金流量净额减少的原因主要是报告期内客户贷款及垫款支付的现金增加。感谢您的关注！",
        "answerdate": "20190430",
        "id": "437648"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_r5f2ym",
        "question": "请问哪里查看年报",
        "questondate": "20190424",
        "answerer": "浦发银行",
        "answer": "您可以登录上海证券交易所网站（http://www.sse.com.cn/）查看公司年度报告，亦可登录公司网站投资者关系栏目（https://news.spdb.com.cn/investor_relation/periodic_report/）查看公司年度报告。感谢您的关注！",
        "answerdate": "20190430",
        "id": "442568"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "你好，董秘，请问那个10派4.4元的分红多久能到账",
        "questondate": "20190401",
        "answerer": "浦发银行",
        "answer": "您提到的并非我公司的利润分配方案。浦发银行2018年度经董事会审议的报告期利润分配预案：以2018年末普通股总股本 29,352,080,397股为基数 ，向全体股东每10股派送现金股利3.5元人民币（含税），该利润分配方案尚须股东大会审议通过后方可实施。感谢您的关注！",
        "answerdate": "20190408",
        "id": "435735"
    }, {
        "symbol": "600000.sh",
        "questioner": "炒股有理",
        "question": "董秘好，万东百胜的合作目前进展如何，新公司有什么新的进展,彩超产品预计什么时候上市。万里云的人工智能是否拿到三类医械注册或者二类注册。下一步的规划是什么，谢谢",
        "questondate": "20190319",
        "answerer": "浦发银行",
        "answer": "您好，请咨询有关公司，谢谢！",
        "answerdate": "20190325",
        "id": "431643"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "你好！董秘！作为浦发银行股东！希望代为转告董事长总经理！2018年的现金分红比例要提高！别让长期持股的中小股东没有信心！以中国经济社会发展看！当前稳定基础具备！尤其对于银行业危机解除了！可以加大现金分红比例！引导中长期持股和信心增加！谢谢",
        "questondate": "20190318",
        "answerer": "浦发银行",
        "answer": "您的建议我们已经收到，非常感谢您的关注！",
        "answerdate": "20190325",
        "id": "431152"
    }, {
        "symbol": "600000.sh",
        "questioner": "维基百科",
        "question": "有媒体报道，孔祥杰博士发现世界汽车组织（OICA）噪声及轮胎专家工作组（GEBP）将中国和台湾并列为国家这种严重违反“一个中国”原则的常识性错误。孔博士向OICA提出严正交涉，促使OICA及时改正，并作出不再将台湾列为国家的承诺，维护了祖国核心利益。请问，此事是否属实？孔博士是否公司在职员工？",
        "questondate": "20190322",
        "answerer": "浦发银行",
        "answer": "您好，请咨询有关公司，谢谢！",
        "answerdate": "20190325",
        "id": "432704"
    }, {
        "symbol": "600000.sh",
        "questioner": "miamiadjqclm",
        "question": "未来走势如何？",
        "questondate": "20190304",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同。感谢您的关注！",
        "answerdate": "20190318",
        "id": "426578"
    }, {
        "symbol": "600000.sh",
        "questioner": "凯路行",
        "question": "请问公司未来的分红计划可以公布一下吗？",
        "questondate": "20190220",
        "answerer": "浦发银行",
        "answer": "公司2018年度利润分配预案尚需董事会审议，并由股东大会审议通过后实施，谢谢您的关注！",
        "answerdate": "20190318",
        "id": "424045"
    }, {
        "symbol": "600000.sh",
        "questioner": "magyw",
        "question": "如何查上海A股证券帐户对应的券商?",
        "questondate": "20190315",
        "answerer": "浦发银行",
        "answer": "请咨询开户券商。感谢您的关注！",
        "answerdate": "20190318",
        "id": "430713"
    }, {
        "symbol": "600000.sh",
        "questioner": "河河河",
        "question": "尊敬的董秘，您辛苦了。烦请告知截止到目前最新的贵公司股东人数和机构户数，在此深表感谢...",
        "questondate": "20190313",
        "answerer": "浦发银行",
        "answer": "公司股东相关数据将在定期报告中披露。截至2018年9月30日，公司普通股股东户数为197,612户。感谢您的关注！",
        "answerdate": "20190318",
        "id": "429714"
    }, {
        "symbol": "600000.sh",
        "questioner": "沧海-1208",
        "question": "浦发银行总资产与招商银行差不多，但营业收入和净利润，与招商银行相比少得可怜，净利润也比兴业银行少，同样是股份制银行为何差距会这么大？请问高管问题出在哪里，有何提升措施？",
        "questondate": "20190201",
        "answerer": "浦发银行",
        "answer": "公司将深入贯彻落实党的十九大和全国金融工作会议精神，以建设具有核心竞争优势的现代金融服务企业愿景为引领，围绕“以客户为中心，科技引领，打造一流数字生态银行”的战略目标，坚持“回归本源、突出主业、做精专业、协调发展”的经营理念，积极服务实体经济，防控金融风险，深化金融改革，努力实现高质量的发展。感谢您的关注！",
        "answerdate": "20190213",
        "id": "422216"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "上交所已经出台了有关上市公司回购股票的实施细则！浦发银行股票价格长期低于每股净资产！无论是大股东！还是上司公司本身！都需要维护上市公司价值！不能无动于衷的熟视无睹公司股票价格长期低于每股净资产太父母的价值损失！从尊重中小股东权益的出发点！维护公司股票价值！是上市公司必须考虑的社会责任！希望董事会秘书！提请董事会！拿出办法解决公司价值低估问题！业绩快报发布！最好也同时发布股票分红预案！",
        "questondate": "20190128",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司内部也在针对股票回购的政策做研究，同时按照行业监管机构的要求，公司加强和提高资本管理的能力与效率，提升上市银行服务实体经济、防范金融风险、深化金融改革的能力和实力。感谢您的关注！",
        "answerdate": "20190213",
        "id": "421038"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_1421227",
        "question": "东胜煤矿目前的月均产量是多少？",
        "questondate": "20190123",
        "answerer": "浦发银行",
        "answer": "公司不掌握东盛煤矿的经营情况。感谢您的关注！",
        "answerdate": "20190213",
        "id": "420308"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "对于将到期的149.99亿贷款中，对蓝润实际经营情况，请问贵司是否如实了解情况？",
        "questondate": "20190122",
        "answerer": "浦发银行",
        "answer": "浦发银行依照相关监管要求及上市公司信息披露相关规定进行对外信息发布。感谢您的关注！",
        "answerdate": "20190213",
        "id": "420060"
    }, {
        "symbol": "600000.sh",
        "questioner": "Zangwill",
        "question": "感觉快报好于预期啊",
        "questondate": "20190108",
        "answerer": "浦发银行",
        "answer": "感谢您的支持与关注！",
        "answerdate": "20190121",
        "id": "417621"
    }, {
        "symbol": "600000.sh",
        "questioner": "ruanbg",
        "question": "老版综合市盈率指标，新版哪里找？",
        "questondate": "20190103",
        "answerer": "浦发银行",
        "answer": "请咨询您的开户券商，或使用的证券软件。感谢您的关注！",
        "answerdate": "20190121",
        "id": "416645"
    }, {
        "symbol": "600000.sh",
        "questioner": "槑槑",
        "question": "你好，请问贵公司年报上是否披露了资本充足率和存贷比率？或者哪里可以查到？",
        "questondate": "20181224",
        "answerer": "浦发银行",
        "answer": "公司年度报告披露了各级资本充足率；存贷比率即是公司披露的贷款余额与存款余额之比。您可以在交易所网站上市公司公告（http://www.sse.com.cn）或在公司官网（http://www.spdb.com.cn）中查找我公司定期报告。感谢您的关注！",
        "answerdate": "20181227",
        "id": "414190"
    }, {
        "symbol": "600000.sh",
        "questioner": "可怜的栋先生",
        "question": "你好，请问，公司未来有什么发展战略",
        "questondate": "20181212",
        "answerer": "浦发银行",
        "answer": "公司将深入贯彻落实党的十九大和全国金融工作会议精神，以建设具有核心竞争优势的现代金融服务企业愿景为引领，围绕“以客户为中心，科技引领，打造一流数字生态银行”的战略目标，坚持“回归本源、突出主业、做精专业、协调发展”的经营理念，积极服务实体经济，防控金融风险，深化金融改革，努力实现高质量的发展。感谢您的关注！",
        "answerdate": "20181217",
        "id": "412277"
    }, {
        "symbol": "600000.sh",
        "questioner": "xxjk",
        "question": "尊敬的各位管理层好，央行近期公布了《中国金融稳定报告（2018）》对3969家银行机构进行了评级。请问贵行评级结果为几级？后期对此有何应对策略？谢谢",
        "questondate": "20181105",
        "answerer": "浦发银行",
        "answer": "浦发银行依照相关监管要求及上市公司信息披露相关规定进行对外信息发布。感谢您的关注！",
        "answerdate": "20181217",
        "id": "402487"
    }, {
        "symbol": "600000.sh",
        "questioner": "xxjk",
        "question": "尊敬的各位管理层好，央行近期公布了《中国金融稳定报告（2018）》，贵行参加了大中型商业银行压力测试。贵行压测情况如何？后期有何应对措施？谢谢",
        "questondate": "20181109",
        "answerer": "浦发银行",
        "answer": "浦发银行依照相关监管要求及上市公司信息披露相关规定进行对外信息发布。感谢您的关注！",
        "answerdate": "20181217",
        "id": "403664"
    }, {
        "symbol": "600000.sh",
        "questioner": "落落",
        "question": "请问，贵公司三季报的每股收益是怎么算的1.44？？不应该是净利润/总股本，根据你们披露值，我计算出来的是1.47。谢谢",
        "questondate": "20181105",
        "answerer": "浦发银行",
        "answer": "每股收益的计算是按照归属于母公司普通股股东的净利润来计算，在计算本报告期的每股收益时，还须扣除浦发第二期优先股在报告期内已发放的股息8.25亿元。谢谢！",
        "answerdate": "20181126",
        "id": "402482"
    }, {
        "symbol": "600000.sh",
        "questioner": "xiajun",
        "question": "年报在哪看？",
        "questondate": "20181122",
        "answerer": "浦发银行",
        "answer": "您可以登录上海证券交易所网站：www.sse.com.cn查询公司的定期报告或其他公告，亦可以登录公司官网投资者关系栏目http://news.spdb.com.cn/investor_relation/periodic_report查询。感谢您的关注！",
        "answerdate": "20181126",
        "id": "407367"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "你好，浦发银行股价长期低于净资产，现在国家鼓励上市公司回购，请问贵公司回购方面有什么安排！",
        "questondate": "20181112",
        "answerer": "浦发银行",
        "answer": "浦发银行将深入学习研究并积极贯彻相关规定，并按照行业监管机构的要求，加强和提高公司资本管理的能力与效率，提升上市银行服务实体经济、防范金融风险、深化金融改革的能力和实力。感谢您的关注！",
        "answerdate": "20181126",
        "id": "404154"
    }, {
        "symbol": "600000.sh",
        "questioner": "见雪恋",
        "question": "公司的不良率是多少？",
        "questondate": "20181015",
        "answerer": "浦发银行",
        "answer": "截至2018年9月30日，按五级分类口径统计，公司不良贷款率1.97%，较上年末下降0.17个百分点。感谢您的关注！",
        "answerdate": "20181031",
        "id": "397636"
    }, {
        "symbol": "600000.sh",
        "questioner": "frankx",
        "question": "我国公司法关于回购的部分已经作了更新. 股份回购已经成为国际市场上上市公司利润分配的最重要方式, 而且被证明效果较好.\n请问贵公司能否尝试股份回购作为一种利润分配方式, 并且逐步用股份回购替代现金分红这种比较古老的分配方式?",
        "questondate": "20181031",
        "answerer": "浦发银行",
        "answer": "浦发银行将深入学习研究并积极贯彻相关规定，并按照行业监管机构的要求，加强和提高公司资本管理的能力与效率，提升上市银行服务实体经济、防范金融风险、深化金融改革的能力和实力。浦发银行将持续提升服务实体经济高质量发展的能力，以客户为中心，围绕上市公司客户的需求，为其开展资本运作提供全面的金融服务，积极促进我国经济和资本市场健康发展。感谢您的关注！",
        "answerdate": "20181031",
        "id": "401576"
    }, {
        "symbol": "600000.sh",
        "questioner": "wxwD111555",
        "question": "股份回购不能替代现金分红，frankx提的问题是想让上市公司都变成铁公鸡他才高兴，上市公司回报投资者才是道。",
        "questondate": "20180910",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20180925",
        "id": "391842"
    }, {
        "symbol": "600000.sh",
        "questioner": "股市猪倌",
        "question": "贵司是否有为博雷顿科技有限公司合作代工生产纯电动重卡？目前代工生产规模是多少？莫雷顿代工费用支付方式是什么？",
        "questondate": "20180919",
        "answerer": "浦发银行",
        "answer": "公司无代工业务。感谢您的关注！",
        "answerdate": "20180925",
        "id": "393895"
    }, {
        "symbol": "600000.sh",
        "questioner": "wxwD111555",
        "question": "请问.公司有没有制定更好回报投资者的计划。",
        "questondate": "20180910",
        "answerer": "浦发银行",
        "answer": "2018年，公司认真贯彻落实十九大、全国金融工作会议精神，积极贯彻谋划新一轮发展会议与年度工作会议要求，围绕“回归本源、突出主业、做精专业、协调发展”和“调结构、保收入、强管理、降风险”经营主线，着力推进改革创新，公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！",
        "answerdate": "20180925",
        "id": "391874"
    }, {
        "symbol": "600000.sh",
        "questioner": "zhaocat",
        "question": "请问公司公告中上半年董事会决议的不良核销数据只有26亿元，中报中当期核销超过300亿元，中间差额接近300亿，是如何产生的？是否涉嫌信息披露违规？",
        "questondate": "20180830",
        "answerer": "浦发银行",
        "answer": "2017年10月，根据财政部《金融企业呆账核销管理办法（2017年版）》的相关规定，第六届董事会第二十四次会议审议通过了《关于修订＜资产损失核销管理办法（2017年）＞的议案》，为加快不良资产处置，以加强资产核销常态化管理，董事会授权高管层单笔在一定金额权限范围内可予以核销，并定期向董事会报告，相关核销总金额将在定期报告中予以披露。您所提的26亿元，是两笔超过高管层单笔核销权限分别提交由董事会审议核销的不良资产。感谢您对浦发银行的关注！",
        "answerdate": "20180925",
        "id": "389828"
    }, {
        "symbol": "600000.sh",
        "questioner": "海权",
        "question": "不良率多少？",
        "questondate": "20180827",
        "answerer": "浦发银行",
        "answer": "截至2018年6月30日，公司不良贷款率为2.06%，比上年末下降0.08个百分点。感谢您的关注！",
        "answerdate": "20180830",
        "id": "388895"
    }, {
        "symbol": "600000.sh",
        "questioner": "Zangwill",
        "question": "三季度业绩展望？",
        "questondate": "20180824",
        "answerer": "浦发银行",
        "answer": "2018年第三季度尚未结束，业绩情况将在定期报告中披露。当前，从经济金融形势、监管政策以及国际形势看，商业银行依旧面临一定的挑战。公司将按董事会的决策要求，保持战略定力，积极顺应国家政策导向，抓住结构性机遇，持续提升服务实体经济高质量发展的能力；密切关注市场变化，持续优化资产负债经营策略，做好流动性和市场风险等方面的管理；积极落实监管要求，持续夯实合规经营基础，切实守住底线。感谢您的关注！",
        "answerdate": "20180830",
        "id": "388743"
    }, {
        "symbol": "600000.sh",
        "questioner": "静松慧",
        "question": "您好，请问哪里可以查看上市公司电话会议资源",
        "questondate": "20180821",
        "answerer": "浦发银行",
        "answer": "目前尚无电话会议的安排。感谢您的关注！",
        "answerdate": "20180830",
        "id": "387770"
    }, {
        "symbol": "600000.sh",
        "questioner": "frankx",
        "question": "第一个问题, 请问现金分红对贵银行的核心资本充足率有没有影响? 第二个问题, 股份回购并注销也是上市公司回报投资者的重要方式, 并且在成熟市场如美国股市,\n股份回购并注销已经超过了现金分红成为公司利润分配的最重要方式. 请问股份回购并注销对银行核心资本充足率的影响是否和现金分红类似? 第三个问题,\n请问贵行是否会认真考虑股份回购作为可以替代现金分红的利润分配方式?",
        "questondate": "20180823",
        "answerer": "浦发银行",
        "answer": "未分配利润计入商业银行资本，现金分红会对商业银行的资本充足率直接影响。公司在制定2017年度利润分配方案时，综合考虑自身盈利水平和资本充足状况、以及转型发展的需要，适当提高了利润留存比例以补充资本，提升公司防范金融风险、服务实体经济、深化金融改革的能力。关于股份回购的问题，商业银行资本监管有特别的要求，所以在回购公司股票上公司与普通上市公司不同。感谢您的关注！",
        "answerdate": "20180830",
        "id": "388326"
    }, {
        "symbol": "600000.sh",
        "questioner": "鑫合汇P2P",
        "question": "贵公司重要参股公司P2P平台（公司出资7个多亿）鑫合汇已出现兑付危机，未见贵公司有任何信息披露。是否已构成信披违法违规？@董秘",
        "questondate": "20180816",
        "answerer": "浦发银行",
        "answer": "公司未出资参股该公司。公司参股控股公司均在定期报告中有所披露。感谢您的关注！",
        "answerdate": "20180822",
        "id": "386501"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "请问浦发银行和蚂蚁借呗怎么合作放款的？",
        "questondate": "20180725",
        "answerer": "浦发银行",
        "answer": "5月29日，浦发银行与浙江蚂蚁小微金融服务集团股份有限公司在总行举行了战略合作协议签约仪式。双方共同表达了进一步深化战略合作的愿望，将在金融科技、互联网信贷、线上线下全渠道支付业务、互联网渠道经营及市场营销等方面开展深入合作，通过优势互补和创新合作，实现互惠共赢。感谢您的关注！",
        "answerdate": "20180822",
        "id": "380890"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "浦发银行(600000)浦发银行的董事长总经理董秘！你们公司今年分红这么低价！还要拖延马月去吗？？？？赶快分红！别再拖延了！你们这么不考虑中小股东的中长期投资的权益和心情吗？？？赶快分红！赶快发布业绩快报！！！ \n    ",
        "questondate": "20180705",
        "answerer": "浦发银行",
        "answer": "公司2017年年度权益分派实施公告已于7月6日披露，2017年度现金红利将于2018年7月13日发放。感谢您的关注！ \n    ",
        "answerdate": "20180709",
        "id": "374995"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)如何看待市值低于净资产，是否存在严重的资产高估情况，未来是否会清盘？ \n    ",
        "questondate": "20180613",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司目前经营正常，我们将继续努力完成各项经营目标和工作任务，为投资者创造回报。感谢您的关注！ \n    ",
        "answerdate": "20180705",
        "id": "368425"
    }, {
        "symbol": "600000.sh",
        "questioner": "vampirekeal",
        "question": "浦发银行(600000)股价跌成这样，公司有没有稳定股价的具体措施？ \n    ",
        "questondate": "20180703",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！ \n    ",
        "answerdate": "20180705",
        "id": "374514"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000)看见其他银行每年都会发行几百亿金融债券，为什么贵银行没有进行过？ \n    ",
        "questondate": "20180611",
        "answerer": "浦发银行",
        "answer": "公司积极推进金融债券的发行。2017年度，公司发行了三期金融债券，合计发行规模500亿元。感谢您的关注！ \n    ",
        "answerdate": "20180611",
        "id": "367142"
    }, {
        "symbol": "600000.sh",
        "questioner": "1361的吖吖",
        "question": "为什么最近浦发银行的股市行情不太好呢？",
        "questondate": "20180531",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！",
        "answerdate": "20180611",
        "id": "362771"
    }, {
        "symbol": "600000.sh",
        "questioner": "WY6002734",
        "question": "5月29日，浦发银行与蚂蚁金服在上海签署了战略合作协议，最近会否公式具体项目计划？",
        "questondate": "20180531",
        "answerer": "浦发银行",
        "answer": "5月29日，浦发银行与浙江蚂蚁小微金融服务集团股份有限公司在总行举行了战略合作协议签约仪式。浦发银行董事长高国富、蚂蚁金服董事长兼首席执行官井贤栋出席签约仪式。双方共同表达了进一步深化战略合作的愿望，将在金融科技、互联网信贷、线上线下全渠道支付业务、互联网渠道经营及市场营销等方面开展深入合作，通过优势互补和创新合作，实现互惠共赢。感谢您的关注！",
        "answerdate": "20180611",
        "id": "362780"
    }, {
        "symbol": "600000.sh",
        "questioner": "沈玉玲1040",
        "question": "请问外资银行进入中国对贵银行有什么影响吗？",
        "questondate": "20180530",
        "answerer": "浦发银行",
        "answer": "公司将继续深入贯彻落实党的十九大和全国金融工作会议精神，以建设具有核心竞争优势的 现代金融服务企业愿景为引领，围绕“以客户为中心，科技引领，打造一流数字生态银行” 的战略目标，坚持“回归本源、突出主业、做精专业、协调发展”的经营理念，积极服务实 体经济，防控金融风险，深化金融改革，努力实现高质量的发展。感谢您的关注！",
        "answerdate": "20180611",
        "id": "362362"
    }, {
        "symbol": "600000.sh",
        "questioner": "青春碎碎念4486",
        "question": "请问贵公司被银监会罚款的事，会对公司有哪些影响？",
        "questondate": "20180528",
        "answerer": "浦发银行",
        "answer": "公司在全行范围内认真开展举一反三教育整改工作，深刻反思，统一思想，吸取教训；端正全行经营理念，更加关注安全性、流动性和效益性的平衡发展，强化统一法人管理；将防范和化解金融风险放在更加突出的位置，强化合规内控体制机制建设，着重提升内控执行力和有效性，确保全行依法合规、稳健发展。感谢您的关注！",
        "answerdate": "20180611",
        "id": "360963"
    }, {
        "symbol": "600000.sh",
        "questioner": "行走4439",
        "question": "请问浦发银行最近是否会一直处于下跌趋势，还是会出现转强迹象？",
        "questondate": "20180528",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！",
        "answerdate": "20180611",
        "id": "360820"
    }, {
        "symbol": "600000.sh",
        "questioner": "薛定谔的猫咪0442",
        "question": "浦发银行行业的市盈率，分红情况？",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "市盈率为上市公司股票市场成交价格与每股收益的比值，根据对于每股收益取值方式不同可细分为不同种类。股票行情交易软件中静态市盈率的计算方式通常为总市值与上年度净利润的比值。您可根据自身需要登陆有关软件查询相关市盈率信息，以及有关计算方法说明。 经公司2017年年度股东大会审议通过的利润分配方案为：以2017年末普通股总股本29,352,080,397股为基数，向全体股东每10股派送现金股利1元人民币（含税），合计分配现金股利人民币29.35亿元。上述方案执行后，结余的未分配利润按照监管机构对商业银行资本充足的有关要求，留做补充资本。 感谢您的关注！",
        "answerdate": "20180611",
        "id": "359823"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "您好，今年以来浦发银行股价表现不佳，与成都分行事件应该也有一些关系，市场更加关注公司的盈利能力、资产质量。所以，作为一名小股东，请求公司在7月初及时发布上半年度的关于盈利能力和资产质量的业绩预告或快报。虽然这不是必须的动作，公司没有义务必须发预告或快报，但是能够尽早让股东们和市场了解经营情况，麻烦转告至董事会和管理层，万分感谢。",
        "questondate": "20180529",
        "answerer": "浦发银行",
        "answer": "您的建议我们已经收到，感谢您的关注！",
        "answerdate": "20180611",
        "id": "361875"
    }, {
        "symbol": "600000.sh",
        "questioner": "wyu0376",
        "question": "浦发银行下一季度报告什么时候公布？",
        "questondate": "20180530",
        "answerer": "浦发银行",
        "answer": "公司的半年度报告披露时间尚未确定。感谢您的关注！",
        "answerdate": "20180611",
        "id": "362137"
    }, {
        "symbol": "600000.sh",
        "questioner": "yyp4424",
        "question": "请问浦发银行2018年的半年报什么时候公布？",
        "questondate": "20180529",
        "answerer": "浦发银行",
        "answer": "公司的半年度报告披露时间尚未确定。感谢您的关注！",
        "answerdate": "20180611",
        "id": "361929"
    }, {
        "symbol": "600000.sh",
        "questioner": "hhermione",
        "question": "您好，请问去年11.88元非公开发行股票募集的148亿资金到位了吗？",
        "questondate": "20180525",
        "answerer": "浦发银行",
        "answer": "非公开发行的资金已于2017年8月28日验资到账。感谢您的关注！",
        "answerdate": "20180611",
        "id": "360679"
    }, {
        "symbol": "600000.sh",
        "questioner": "叶慧诗3541",
        "question": "请问公司5月23日的融资融券信息在哪里可以查找？",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "每日的融资融券信息可以访问上交所网站（http://www.sse.com.cn）查询。感谢您的关注！",
        "answerdate": "20180611",
        "id": "359792"
    }, {
        "symbol": "600000.sh",
        "questioner": "summer3198",
        "question": "请问2019年的预期市盈率是多少？",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "市盈率为上市公司股票市场成交价格与每股收益的比值，感谢您的关注！",
        "answerdate": "20180611",
        "id": "359810"
    }, {
        "symbol": "600000.sh",
        "questioner": "杜晓碧2560",
        "question": "浦发银行(600000)浦发银行的年报什么时候发行 \n    ",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "公司2017年年度报告已于4月28日披露。感谢您的关注！ \n    ",
        "answerdate": "20180524",
        "id": "359808"
    }, {
        "symbol": "600000.sh",
        "questioner": "Veronica0831",
        "question": "浦发银行(600000)请问2018年下半年有什么重大规划吗？ \n    ",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "公司将认真贯彻落实十九大、全国金融工作会议精神，以建设具有核心竞争优势的现代金融服务企业愿景为引领，围绕“以客户为中心，科技引领，打造一流数字生态银行”的战略目标，坚持“回归本源、突出主业、做精专业、协调发展”的经营理念和“调结构、保收入、强管理、降风险”经营主线，着力推进改革创新，积极服务实体经济，防范金融风险，努力实现高质量的发展。感谢您的关注！ \n    ",
        "answerdate": "20180524",
        "id": "359595"
    }, {
        "symbol": "600000.sh",
        "questioner": "hayller1067",
        "question": "浦发银行(600000)浦发的资产质量下滑对浦发的业务经营将带来哪些方面的影响？ \n    ",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "近年以来公司更加注重风险管理，严格不良贷款分类管理，着力夯实资产质量基础。未来公司将加大不良处置力度，持续加强对风险的主动管理能力，争取资产质量保持在良好水平。感谢您的关注！ \n    ",
        "answerdate": "20180524",
        "id": "359617"
    }, {
        "symbol": "600000.sh",
        "questioner": "Jeany2426",
        "question": "浦发银行(600000)最近公司的股价都在下跌，有什么政策出来改善吗？ \n    ",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！ \n    ",
        "answerdate": "20180524",
        "id": "359621"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "浦发银行(600000)根据定期报告披露的数据，可以计算出2017全年新生成的不良贷款约为675亿元，其中2017年1—4单季度新生成的不良贷款分别约为124/165/316/70亿元，而2018年1季度新产生不良贷款很少，新产生的不良贷款趋势向好！在对不良贷款进行严格确认的情况下，新生成不良贷款趋势向好，值得肯定。希望浦发银行再接再厉，在上市银行中力争上游，谢谢。 \n    ",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "公司将继续努力经营，努力实现高质量的发展。感谢您的关注！ \n    ",
        "answerdate": "20180524",
        "id": "359428"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "浦发银行(600000)浦发银行1季度末的不良贷款率实际上只有1.65%左右。根据披露，不良率为2.13%、拨备覆盖率为152.17%、拨贷比为3.25%；贷款余额为32448.22亿元、不良贷款余额为691.96亿元、贷款减值准备为1052.98亿元。已经储备了充足的贷款减值准备，为什么不在1季度利用已有的贷款减值准备加大核销？如果再核掉150亿左右，那么不良率不就下降到1.65%左右了吗，同时拨备覆盖率也会大幅上升至167%左右。1季度是时间关系来不及核销吗？ \n    ",
        "questondate": "20180524",
        "answerer": "浦发银行",
        "answer": "公司严格按照监管规定和有关制度开展对不良贷款的认定和核销工作。感谢您的关注！ \n    ",
        "answerdate": "20180524",
        "id": "359365"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "浦发银行(600000)您好：财务报表附注中，按逾期期限列示了逾期贷款金额。请问： 1、逾期是如何定义的？贷款本金或者利息逾期超过1天就算逾期吗？还是只计算了本金逾期，而没有包括利息逾期？ 2、有否给刚逾期的贷款设置还款宽限期？如果有，在还款宽限期内的贷款有否统计进逾期贷款中？ 谢谢！ \n    ",
        "questondate": "20180507",
        "answerer": "浦发银行",
        "answer": "按照监管的相关规定，截至还息日未全额偿还利息的贷款本金余额为逾期贷款。相关认定公司遵照监管机构的相关规定。感谢您的关注！ \n    ",
        "answerdate": "20180517",
        "id": "351745"
    }, {
        "symbol": "600000.sh",
        "questioner": "1861638zhang",
        "question": "浦发银行(600000)最近公司股价大跌，公司大股东有没有增持计划，或者核心员工增持计划？ \n    ",
        "questondate": "20180508",
        "answerer": "浦发银行",
        "answer": "截至目前，公司未披露大股东增持股份的计划，当前国有商业银行实施股权激励在政策上尚需进一步明晰。感谢您的关注！ \n    ",
        "answerdate": "20180517",
        "id": "352641"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "浦发银行(600000)你好，通过上市银行间的横向比较，可以看出浦发银行对不良贷款进行重组的比例太低了。招行重组贷款率达到了0.51%，而且重组后经过一定的考察期，符合条件的不再认定为不良贷款，目前招行0.51%的所有重组贷款，都没有减值，都被踢出了不良贷款。请问：加强清收、加快核销当然是对的，但是为什么浦发银行的重组贷款率如此之低？后续会加强利用重组手段吗？谢谢。 \n    ",
        "questondate": "20180514",
        "answerer": "浦发银行",
        "answer": "公司在年报中披露的重组贷款口径是原已减值或发生减值但相关合同条款已重新商定过的贷款。感谢您的关注！ \n    ",
        "answerdate": "20180517",
        "id": "355231"
    }, {
        "symbol": "600000.sh",
        "questioner": "股票白丁",
        "question": "浦发银行(600000)贵行优先股个人是否可以参加交易，每年收到的优先股息是否有税收优惠 \n    ",
        "questondate": "20180507",
        "answerer": "浦发银行",
        "answer": "有关优先股的交易规则，请参阅交易所有关文件；公司实施有关优先股派息是含税，其现金股息所得税由优先股股东自行缴纳。感谢您的关注！ \n    ",
        "answerdate": "20180517",
        "id": "351919"
    }, {
        "symbol": "600000.sh",
        "questioner": "梨梨",
        "question": "浦发银行(600000)请问董秘，为什么最近几年浦发的分红都少于原来承诺的利润30% \n    ",
        "questondate": "20180517",
        "answerer": "浦发银行",
        "answer": "为进一步贯彻落实中国证监会、上海证券交易所等监管机构有关上市公司现金分红等新的要求，切实保护投资者的合法利益，《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。公司最近三年（2015-2017）由董事会拟定以及经股东大会审议通过的利润分配方案，现金分红累计分配的利润占最近三年实现的年均可分配利润的比例及决策程序符合公司章程相关要求。公司2017年度利润分配预案主要基于：一是在国家持续推进供给侧改革和去杠杆过程中，银行业风险管控压力持续上升，对银行抗风险能力提出更高的要求；二是2018年为资本达标过渡期最后一年，对商业银行资本充足水平提出了更高要求；三是随着公司集团化、国际化战略的不断推进，集团及各子公司健康快速发展，对于资本补充的需求也显著上升；四是公司加快结构转型，注重科技引领，加快建设数字生态银行，科研投入占比有所增加，需要充足的资本支撑。公司综合考虑监管机构的相关要求、自身盈利水平和资本充足状况、以及转型发展的需要，适当提高了利润留存比例以补充资本，提升公司防范金融风险、服务实体经济、深化金融改革的能力。感谢您的关注！ \n    ",
        "answerdate": "20180517",
        "id": "357041"
    }, {
        "symbol": "600000.sh",
        "questioner": "frankx",
        "question": "浦发银行(600000)作为A股蓝筹之一，为何不借鉴成熟市场上蓝筹公司用股份回购替代部分现金分红，从而达到节约中小投资者税务负担和稳定股价的双赢？ \n    ",
        "questondate": "20180510",
        "answerer": "浦发银行",
        "answer": "商业银行资本监管有特别的要求，所以在回购公司股票上公司与普通上市公司不同。谢谢您的关注！ \n    ",
        "answerdate": "20180517",
        "id": "354226"
    }, {
        "symbol": "600000.sh",
        "questioner": "蒙面歌王",
        "question": "浦发银行(600000)今年预期分红为什么相差这么大 \n    ",
        "questondate": "20180502",
        "answerer": "浦发银行",
        "answer": "有关利润分配的情况，详见前述回答。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "348678"
    }, {
        "symbol": "600000.sh",
        "questioner": "qwqer",
        "question": "浦发银行(600000)请问公司一季度净利润率负增长的主要原因是什么?未来有什么措施？ \n    ",
        "questondate": "20180502",
        "answerer": "浦发银行",
        "answer": "一是自去年以来市场端资金面趋紧，负债成本有所提升。二是中间业务收入受相关政策和市场的影响有所减少。三是资产管理业务受“营改增”影响。公司将认真贯彻落实十九大、全国金融工作会议精神，积极贯彻谋划新一轮发展会议与年度工作会议要求，围绕“回归本源、突出主业、做精专业、协调发展”和“调结构、保收入、强管理、降风险”经营主线，着力推进改革创新，确保年度各项重点工作有序推进。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "347714"
    }, {
        "symbol": "600000.sh",
        "questioner": "蒙面歌王",
        "question": "浦发银行(600000)西部地区:亏损-117.49亿，这些人都在干嘛按地区分类2017-12-31 主营收入(元) 收入比例 主营成本(元) 成本比例 主营利润(元) 利润比例 毛利率 (%)西部地区 144.24亿 8.55% 261.73亿 26.61% -117.49亿 -16.72% \n    ",
        "questondate": "20180502",
        "answerer": "浦发银行",
        "answer": "近年来，受实体经济下行影响，西部地区分行资产质量承受一定压力，对利润也造成一定影响。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "348776"
    }, {
        "symbol": "600000.sh",
        "questioner": "可爱的志龙",
        "question": "浦发银行(600000)2017年末每股净资产14.49元，2018年一季度每股收益0.46元，一季度末每股净资产13.57元，反而减少了0.92元。这是什么道理？？？ \n    ",
        "questondate": "20180502",
        "answerer": "浦发银行",
        "answer": "截至2017年末公司每股净资产应为13.47元，一季度末的每股净资产为13.57元。根据企业会计准则第22号《金融工具的确认与计量》的相关规定，虽无需追溯调整，但新旧准则转换影响调整2018年期初留存收益和其他综合收益，期初留存收益和其他综合收益是净资产的构成部分，公司在2018年一季报中披露了新金融工具准则的采用将减少2018年1月1日期初留存收益148亿元，其他综合收益27亿元，合计减少归属于母公司股东权益121亿元，相应对每股净资产也会受影响。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "349299"
    }, {
        "symbol": "600000.sh",
        "questioner": "傲龙堡二堡主夫人",
        "question": "浦发银行(600000)请问公司还要等多久才出年报。 \n    ",
        "questondate": "20180425",
        "answerer": "浦发银行",
        "answer": "公司2017年度报告与2018年第一季度报告已于4月28日披露。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "345793"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_9swpna",
        "question": "浦发银行(600000)请问有多少位股东 \n    ",
        "questondate": "20180424",
        "answerer": "浦发银行",
        "answer": "截至2018年3月31日，公司普通股股东户数为204,319户。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "345062"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)为什么公司今年业绩不错，分红却很低，达不到30%呢？ \n    ",
        "questondate": "20180502",
        "answerer": "浦发银行",
        "answer": "有关利润分配的情况，详见前述回答。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "349455"
    }, {
        "symbol": "600000.sh",
        "questioner": "天舞宝轮",
        "question": "浦发银行(600000)浦发银行目前是业绩增长最差，分红最差的银行。我想问三个问题， 一，你们心里是怎么想的，无动于衷？ 二，是否应该对管理层进行问责？ 三，如何以后回报补偿股东？谢谢 \n    ",
        "questondate": "20180503",
        "answerer": "浦发银行",
        "answer": "2018年，公司认真贯彻落实十九大、全国金融工作会议精神，积极贯彻谋划新一轮发展会议与年度工作会议要求，围绕“回归本源、突出主业、做精专业、协调发展”和“调结构、保收入、强管理、降风险”经营主线，着力推进改革创新，公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "349865"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "浦发银行(600000)您好，核销不良贷款、计提贷款（资产）减值准备需要股东大会授权吗？还是董事会或经营层就可以决定？谢谢！ \n    ",
        "questondate": "20180504",
        "answerer": "浦发银行",
        "answer": "根据财监管机构的相关规定，公司制定了资产损失核销管理办法，同时在《公司章程》中亦明确规定，董事会负责审定公司资产损失核销政策，决定公司不良信贷资产处置。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "351490"
    }, {
        "symbol": "600000.sh",
        "questioner": "matixljt",
        "question": "浦发银行(600000)请问2018年1季度收入下降的原因?另外成都分行坏帐倒底有多少坏帐,已经处理完毕了吗? \n    ",
        "questondate": "20180503",
        "answerer": "浦发银行",
        "answer": "一是自去年以来市场端资金面趋紧，负债成本有所提升。二是中间业务收入受相关政策和市场的影响有所减少。三是资产管理业务受“营改增”影响。公司将认真贯彻落实十九大、全国金融工作会议精神，积极贯彻谋划新一轮发展会议与年度工作会议要求，围绕“回归本源、突出主业、做精专业、协调发展”和“调结构、保收入、强管理、降风险”经营主线，着力推进改革创新，确保年度各项重点工作有序推进。 截至目前，成都分行已按监管要求完成了整改，总体风险可控，客户权益未受影响，分行在新经营班子的带领下已转入经营管理常态化。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "350288"
    }, {
        "symbol": "600000.sh",
        "questioner": "wwmmhh",
        "question": "浦发银行(600000)按地区分，哪些地区的业绩无望，不值得驻守，贵公司有撤并的打算吗？ \n    ",
        "questondate": "20180504",
        "answerer": "浦发银行",
        "answer": "公司在资源配置、考核导向等方面，持续提升穿透管理和精准施策水平，加强集约化管理。2017年，公司网点总数压减至1,799家，完成零售转型和轻型化改造90家，关停低效机构84家。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "351348"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "浦发银行(600000)浦发管理层曾经说过！要保持对于股东回报的连续性稳定性！为何发布的现金分红太低了！没有超过30%的比例？作为上市公司的董事会管理层不能言而无信！不要打着为了什么为了公司长远的冠冕堂皇的口号！实际是占用了本该是中小股东利润财富！中国股市倒闭破产退市的公司都是大股东占用中小股东的利润财富！坑害中小股东！浦发银行董事长总经理必须充分考虑长期持股的中小股东的对于现金分配的需求！你得到的高工资福利待遇要感恩股民 \n    ",
        "questondate": "20180503",
        "answerer": "浦发银行",
        "answer": "为进一步贯彻落实中国证监会、上海证券交易所等监管机构有关上市公司现金分红等新的要求，切实保护投资者的合法利益，《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。公司最近三年（2015-2017）由董事会拟定以及经股东大会审议通过的利润分配方案，现金分红累计分配的利润占最近三年实现的年均可分配利润的比例及决策程序符合公司章程相关要求。公司2017年度利润分配预案主要基于：一是在国家持续推进供给侧改革和去杠杆过程中，银行业风险管控压力持续上升，对银行抗风险能力提出更高的要求；二是2018年为资本达标过渡期最后一年，对商业银行资本充足水平提出了更高要求；三是随着公司集团化、国际化战略的不断推进，集团及各子公司健康快速发展，对于资本补充的需求也显著上升；四是公司加快结构转型，注重科技引领，加快建设数字生态银行，科研投入占比有所增加，需要充足的资本支撑。公司综合考虑监管机构的相关要求、自身盈利水平和资本充足状况、以及转型发展的需要，适当提高了利润留存比例以补充资本，提升公司防范金融风险、服务实体经济、深化金融改革的能力。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "349868"
    }, {
        "symbol": "600000.sh",
        "questioner": "傲龙堡二堡主夫人",
        "question": "浦发银行(600000)为何2017年的现金分红对比2016年大幅缩减？导致5月2号股票价格大跌。 \n    ",
        "questondate": "20180503",
        "answerer": "浦发银行",
        "answer": "公司2017年度利润分配预案主要基于：一是在国家持续推进供给侧改革和去杠杆过程中，银行业风险管控压力持续上升，对银行抗风险能力提出更高的要求；二是2018年为资本达标过渡期最后一年，对商业银行资本充足水平提出了更高要求；三是随着公司集团化、国际化战略的不断推进，集团及各子公司健康快速发展，对于资本补充的需求也显著上升；四是公司加快结构转型，注重科技引领，加快建设数字生态银行，科研投入占比有所增加，需要充足的资本支撑。公司综合考虑监管机构的相关要求、自身盈利水平和资本充足状况、以及转型发展的需要，适当提高了利润留存比例以补充资本，提升公司防范金融风险、服务实体经济、深化金融改革的能力。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "350138"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)5月4日银保监会对浦发进行罚款的原因“(九)贷款管理严重缺失，导致大额不良贷款”是因为成都分行的事吗？ \n    ",
        "questondate": "20180507",
        "answerer": "浦发银行",
        "answer": "该处罚是2016年银监会对公司2015年度相关情况现场检查的后续行政管理措施，检查涉及总行及部分分行。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "351622"
    }, {
        "symbol": "600000.sh",
        "questioner": "天天pay",
        "question": "浦发银行(600000)为什么会屡屡冒出对浦发银行以及各分行的处罚通知，贵行的管理真的到了如此放任自流的地步了吗？公司管理层是否有针对性的行动？ \n    ",
        "questondate": "20180507",
        "answerer": "浦发银行",
        "answer": "公司认真开展举一反三教育整改工作，将防范和化解金融风险放在更加突出的位置，强化合规内控体制机制建设，着重提升内控执行力和有效性，确保全行依法合规、稳健发展。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "351651"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)为什么浦发银行2017年的分配利润如此之低。 \n    ",
        "questondate": "20180507",
        "answerer": "浦发银行",
        "answer": "公司2017年度利润分配预案主要基于：一是在国家持续推进供给侧改革和去杠杆过程中，银行业风险管控压力持续上升，对银行抗风险能力提出更高的要求；二是2018年为资本达标过渡期最后一年，对商业银行资本充足水平提出了更高要求；三是随着公司集团化、国际化战略的不断推进，集团及各子公司健康快速发展，对于资本补充的需求也显著上升；四是公司加快结构转型，注重科技引领，加快建设数字生态银行，科研投入占比有所增加，需要充足的资本支撑。公司综合考虑监管机构的相关要求、自身盈利水平和资本充足状况、以及转型发展的需要，适当提高了利润留存比例以补充资本，提升公司防范金融风险、服务实体经济、深化金融改革的能力。感谢您的关注！ \n    ",
        "answerdate": "20180507",
        "id": "351639"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_r5f2ym",
        "question": "浦发银行(600000)请问在哪查看贵公司一季度财报 \n    ",
        "questondate": "20180419",
        "answerer": "浦发银行",
        "answer": "公司2018年第一季度报告预计将于4月28日公告，届时您可以在交易所网站、公司官网和其他指定披露媒体查阅。感谢您的关注！ \n    ",
        "answerdate": "20180423",
        "id": "343126"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请问公司的管理层是否以股东（即公司所有者）的利益为第一考虑因素？ \n    ",
        "questondate": "20180419",
        "answerer": "浦发银行",
        "answer": "公司高度重视股东利益，通过多种形式建立与股东沟通的有效渠道，采取积极举措保障股东的参与权、知情权和表决权，兼顾股东分享公司成长、发展成果，取得合理投资回报等要求。公司将通过良好、有效的投资者关系管理切实保障股东权益。感谢您的关注！ \n    ",
        "answerdate": "20180423",
        "id": "343038"
    }, {
        "symbol": "600000.sh",
        "questioner": "aka99q96n",
        "question": "浦发银行(600000)请问公司负责市场营销管理的高层人员是？负责销售的呢？ \n    ",
        "questondate": "20180418",
        "answerer": "浦发银行",
        "answer": "有关公司业务咨询请拨打24小时客服热线：95528。感谢您的关注！ \n    ",
        "answerdate": "20180423",
        "id": "342079"
    }, {
        "symbol": "600000.sh",
        "questioner": "傲龙堡二堡主夫人",
        "question": "浦发银行(600000)尊敬的董秘：您好！谢谢年报和季报都已经完成。最近银行股下跌比较厉害，非常想知道，为何公司就不能及早给市场一个稳定的预期，包括简单醒目的主要财务数据和分红预案？上市公司有责任和义务维护公司股价稳定。现在交易软件非常方便，给出几个数据也非常简单。财报可以依旧可以在交易所排队发布。 \n    ",
        "questondate": "20180417",
        "answerer": "浦发银行",
        "answer": "公司2017年度报告和2018年第一季度报告预计将于4月28日公告。1月6日公司已经披露了2017年度业绩快报，感谢您的关注！ \n    ",
        "answerdate": "20180423",
        "id": "341606"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)如果一个企业只将盈利的小部分用于支付股息，数年后股票价值将会有所增加，但是我们无法确信这种增加能否弥补企业留存盈利给股东带来的股息损失。公司怎么看待这个问题？ \n    ",
        "questondate": "20180411",
        "answerer": "浦发银行",
        "answer": "公司的利润分配方案在符合法律法规和监管机构要求的前提下，充分考虑集团自身盈利水平和资本补充并提高抗风险的能力、投资者分享公司成长和取得合理投资回报的期望；方案要平衡长期利益和即期利益，并且有着完善的决策流程、需要经过股东大会审议通过方能实施。感谢您的关注！ \n    ",
        "answerdate": "20180423",
        "id": "338676"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000)富德生会人寿持百贵公司股票合规吗，为什么股票长期低于净资产。 \n    ",
        "questondate": "20180403",
        "answerer": "浦发银行",
        "answer": "公司将持续关注主要股东持股情况的变化，做好主要股东的沟通，加强股权管理，规范股东行为。感谢您的关注！ \n    ",
        "answerdate": "20180411",
        "id": "335415"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000)公司股票长时间低干净资产，贵公司有什么看法 \n    ",
        "questondate": "20180409",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！ \n    ",
        "answerdate": "20180411",
        "id": "336842"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请公司解释为何股价常年低于净资产？我们首先假设管理层是没有问题的，然后所有的问题都在市场，市场到底有什么问题？答案是市场没有问题，问题完全在管理层！招行就没这个问题，如果公司每一元的留存利润都发挥了应有的效用，那不可能股价会低于净资产，之所以低于净资产，就是因为管理层对留存利润的低效使用！ \n    ",
        "questondate": "20180305",
        "answerer": "浦发银行",
        "answer": "公司的股价除了基本面以外，也受到宏观经济、行业发展、证券市场等多方面的影响。感谢您的关注！ \n    ",
        "answerdate": "20180308",
        "id": "322397"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000)优先股分红怎么那么多呢，对普通股股东公平吗 \n    ",
        "questondate": "20180306",
        "answerer": "浦发银行",
        "answer": "优先股是公司依照相关法律法规并经监管机构核准发行的其他种类股份。与普通股不同，优先股面值为100元，且其参与公司的决策管理等权利受到限制；优先股的票面股息率是与发行时的国家政策、市场状况、以及投资者要求等因素相关，公司是通过询价方式来确定，且不高于公司发行前最近两个会计年度的年均加权平均净资产收益率，实践中募集资金所产生的盈利增长超过需支付的优先股股息。感谢您的关注！ \n    ",
        "answerdate": "20180308",
        "id": "323185"
    }, {
        "symbol": "600000.sh",
        "questioner": "觉觉神",
        "question": "浦发银行(600000)近两年公司存贷比百分之九十以上，乃上市很行之最，是否违背银行业相关规定，经营不再稳健 \n    ",
        "questondate": "20180213",
        "answerer": "浦发银行",
        "answer": "存贷比自2015年由法定监管指标转为流动性监测指标。公司将继续优化资产负债结构，拓宽负债渠道，确保流动性处于合理安全水平。感谢您的关注！ \n    ",
        "answerdate": "20180228",
        "id": "318478"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)浦发银行千亿的关注类贷款迁徙率多年在50%以上,说明过去关注类贷款分类不准有过半属于不良贷款，根据历史事实千亿关注类贷款若准确的计提减值损失应大于150亿，实际按原规定只计提2%，应该补提减值损失130亿以上，请问董秘会计政策变更季报能公允地反映公司的18年1月1日财务状况？ \n    ",
        "questondate": "20180226",
        "answerer": "浦发银行",
        "answer": "新的会计准则自2018年1月1日起施行。会计政策变更是根据财政部相关文件规定进行的合理变更，能够更加客观、公允地反映公司的财务状况和经营成果，符合公司和股东的利益。感谢您的关注！ \n    ",
        "answerdate": "20180228",
        "id": "320027"
    }, {
        "symbol": "600000.sh",
        "questioner": "打一个板",
        "question": "浦发银行(600000)董秘您好，首先向公司全体管理层及全体员工一年的辛劳付出表示感谢，但是近期公司被批露出来的诸多违规问题，给公司造成如此多的损失，请问公司的管理制度是否有不健全的地方？同时管理层是否也有责任给全体股东一个合理的解释？造成的损失是否有具体的高层负责人承担责任？造成的损失如何挽回？ \n    ",
        "questondate": "20180226",
        "answerer": "浦发银行",
        "answer": "公司坚决支持和接受监管机构对公司成都分行作出的行政处罚决定，并深表歉意。公司将认真贯彻落实党的十九大精神和全国金融工作会议、中央经济工作会议要求，积极服务实体经济，有效防控经营风险；坚持“回归本源、突出主业、做精专业、协调发展”，努力为股东创造更大的价值，以良好的经营成果回报社会各界的关心和支持。感谢您的关注！ \n    ",
        "answerdate": "20180228",
        "id": "319799"
    }, {
        "symbol": "600000.sh",
        "questioner": "打一个板",
        "question": "浦发银行(600000)浦发银行千亿的关注类贷款若实事求是准确核算补提减值损失130亿以上，增厚拨备，那18年资产质量将接近于招商银行，仅减少这项包袱就会使浦发银行18年净利润大幅增长、估值也将大幅提升，希望浦发银行借助会计政策变更、季报能公允地反映公司的18年1月1日财务状况。 . \n    ",
        "questondate": "20180226",
        "answerer": "浦发银行",
        "answer": "新的会计准则自2018年1月1日起施行。会计政策变更是根据财政部相关文件规定进行的合理变更，能够更加客观、公允地反映公司的财务状况和经营成果，符合公司和股东的利益。感谢您的关注！ \n    ",
        "answerdate": "20180228",
        "id": "319976"
    }, {
        "symbol": "600000.sh",
        "questioner": "打一个板",
        "question": "浦发银行(600000)尊敬的浦发银行董秘：您好！今天看到保监会依法对安邦保险集团实施接管，接管期限一年。安邦保险是民生银行现在的主要股东，这个消息对民生银行产生了影响。询问一下：保监会对生命人寿进入浦发银行成为重要的大股东有怎样的结论性意见？这个事件将近三年了，后面的影响如何？谢谢您！ \n    ",
        "questondate": "20180223",
        "answerer": "浦发银行",
        "answer": "公司将严格遵守监管规定，持续关注主要股东持股情况的变化，做好主要股东的沟通，加强股权管理，规范股东行为，依法合规地披露有关信息。感谢您的关注！ \n    ",
        "answerdate": "20180228",
        "id": "319565"
    }, {
        "symbol": "600000.sh",
        "questioner": "寻我行",
        "question": "公司违规被监管抓住，请问公司是否存在其他违规问题，请自查！",
        "questondate": "20180123",
        "answerer": "浦发银行",
        "answer": "公司高度重视成都分行违规经营事项，公司在全行范围内认真开展举一反三教育整改工作，深刻反思，统一思想，吸取教训；端正全行经营理念，更加关注安全性、流动性和效益性的平衡发展，强化统一法人管理；将防范和化解金融风险放在更加突出的位置，强化合规内控体制机制建设，着重提升内控执行力和有效性，确保全行依法合规、稳健发展。感谢您的关注！",
        "answerdate": "20180209",
        "id": "309896"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "成都事件让投资者担心浦发银行其他地方的资产质量。我们盼望浦发银行高层严格执行国际财务报告准则第9号，顶住压力，充分、准确计提各类资产减值准备和信用风险，特别是能挖出各支行隐瞒的不良贷款，正确分类，重视关注类贷款金额大和准确性问题，一次性冲减期初净资产。望董秘传递投资者心声。",
        "questondate": "20180129",
        "answerer": "浦发银行",
        "answer": "截至目前，成都分行已按监管要求完成了整改，总体风险可控，客户权益未受影响，分行在新经营班子的带领下已转入经营管理常态化。该事件未涉及我行辖属其他地区分行和境外分行。会计政策变更是根据财政部相关文件规定进行的合理变更，能够更加客观、公允地反映公司的财务状况和经营成果，符合公司和股东的利益，我们会严格遵守、认真执行。感谢您的关注！",
        "answerdate": "20180209",
        "id": "311945"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "董秘你好：因公司管理问题，致使成都分行出现问题，使60000，公司股价处于净资产状态，持有该股的投资者损失较大！请问公司有无增持或大比例分红等挽回投资者投资信心的计划或举动？？",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "公司将认真贯彻落实党的十九大精神和全国金融工作会议、中央经济工作会议要求，积极服务实体经济，有效防控经营风险；坚持“回归本源、突出主业、做精专业、协调发展”，努力为股东创造更大的价值，以良好的经营成果回报社会各界的关心和支持。感谢您的关注！",
        "answerdate": "20180209",
        "id": "309720"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "浦发银行15年、16年关注类贷款迁徙率49.4%和50.17%，上半年关注类贷款余额1159亿元，迁徙率28.42%，三年来迁徙率都在50%以上说明关注类贷款有过半属于不良贷款。公司公告自18年初执行准则第9号,请问董秘:是否准确核算关注类贷款可能产生的损失并冲减18年初净资产?",
        "questondate": "20180131",
        "answerer": "浦发银行",
        "answer": "新准则实施预计将影响公司2018年1月1日的资产总额、净资产等数据，公司将在2018年一季报中披露上述准则转换的影响。感谢您的关注！",
        "answerdate": "20180209",
        "id": "313152"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "请上市公司在善后处理成都分行时，积极应向投资者公示以下内容：浦发银行成都分行涉案775亿，其中有多少亿已经追回来了，有多少亿多长时间能追回来，有多少亿需作坏账处理。",
        "questondate": "20180123",
        "answerer": "浦发银行",
        "answer": "感谢您的关心和建议！",
        "answerdate": "20180209",
        "id": "310082"
    }, {
        "symbol": "600000.sh",
        "questioner": "罗杰爱投资",
        "question": "浦发银行拨倍已经低于150%监管红线，这一指标显著其他股份制商业银行，同时不良率高于2%为股份制商业银行前列。另整个西南地区经营的代价需要全体投资者买单吗？",
        "questondate": "20180205",
        "answerer": "浦发银行",
        "answer": "2017年以来我行执行风险“早暴露、早处置”的策略，风险主动暴露，不良余额增加较快；同时，我行处置决心坚决、力度加大，消耗一定数量的财务资源用于核销，导致拨备覆盖率有所下降。未来我行将加大不良处置力度，持续加强对风险的主动管理能力，争取资产质量保持在良好水平。感谢您的关注！",
        "answerdate": "20180209",
        "id": "314710"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_212658",
        "question": "被罚的钱怎么办？",
        "questondate": "20180123",
        "answerer": "浦发银行",
        "answer": "处罚金额已全额计入2017年度公司损益，对公司的业务开展及持续经营无重大不利影响。公司将努力为股东创造更大的价值，以良好的经营成果回报社会各界的关心和支持。感谢您的关注！",
        "answerdate": "20180209",
        "id": "310131"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "七百亿违规授信，贷出多少？全面评估后，修正后的授信是多少？损失多少？",
        "questondate": "20180123",
        "answerer": "浦发银行",
        "answer": "目前，成都分行已按监管要求完成了整改，总体风险可控，客户权益未受影响，经营管理迈入正轨。感谢您的关注！",
        "answerdate": "20180209",
        "id": "310197"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "开出4.6亿的天价罚单的法律法规依据是什么，可以告诉全体股东吗？根据四川银监局的处罚决定书，行政处罚的依据是《中华人民共和国银行业监督管理法》第四十六条，但第四十六条规定的罚款最高限额为50万元，开出4.6亿的天价罚单有没有法律法规依据？",
        "questondate": "20180123",
        "answerer": "浦发银行",
        "answer": "公司坚决支持和接受监管机构对公司成都分行作出的行政处罚决定，并深表歉意。",
        "answerdate": "20180209",
        "id": "310220"
    }, {
        "symbol": "600000.sh",
        "questioner": "韭菜一号",
        "question": "浦发银行(600000)为什么你们三季度的经营现金流是负的？你们去年还是正的。 \n    ",
        "questondate": "20180108",
        "answerer": "浦发银行",
        "answer": "现金流量净额减少的原因主要是报告期内客户贷款及垫款支付的现金增加。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "303361"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)尊敬的浦发董秘先生，您好看了贵公司2017年报的快报，我们想是不是公司应该已到了刘行长曾说过的天快亮了或是已经亮了的状况？因为刘行长是最了解公司的实际状况的，舍他其谁。我们希望听到的不是外交辞令.盼复，谢谢。 \n    ",
        "questondate": "20180109",
        "answerer": "浦发银行",
        "answer": "公司认真贯彻落实党的十九大和全国金融工作会议精神，坚持“回归本源、突出主业、做精专业、协调发展”经营理念，积极服务实体经济，加大风险防范化解力度，围绕“保收入、调结构、重管理、控风险”经营主线和“数字化、集约化”战略任务，齐心协力、强化应对，保持了稳中有进、稳中向好的发展格局。2017年度更详细的经营情况将后续在年报中披露。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "304259"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司回答：公司留存利润进入资本金支持公司各项业务发展。但我们股东要求的是：留存利润的单独收益率计算，与上年度的股东权益分开解释，而不是统帐，总账即使是增长的，但只有分开后，才可以看出公司留存利润的投资效益。 \n    ",
        "questondate": "20171228",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "300699"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "浦发银行(600000)浦发银行董事长总经理以及董事会秘书，作为长期持有浦发银行的股东，提请你们尊重股东权力的知情权，2017年9月发生的违规事件，到现在才公布，股东有权利质疑董事会的管理能力，++事件已经发生，为了维护股东的权益，董事会应该立即制定公共事件处理机制，做好公共关系的社会工作，树立信心和信任，——最好董事会立即发布2017年现金分红预案，不要低于2015年现金分红比例，保护中小股东权益， \n    ",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "感谢您的关注，您的意见和建议我们会认真听取。 \n    ",
        "answerdate": "20180122",
        "id": "309082"
    }, {
        "symbol": "600000.sh",
        "questioner": "李佛摩尔12",
        "question": "浦发银行(600000)根据最新公告，四川分行被罚款四亿多元，违规贷款700多亿。 董事会第一次有什么样措施？对于本次行政处罚，是否应当提起行政诉讼，以减少处罚？ \n    ",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "针对成都分行违规经营事项，公司高度重视，在监管机构和地方政府的指导和帮助下，及时调整了成都分行经营班子，并对资产状况进行了全面评估，分类施策、强化管理，按照审慎原则计提风险拨备，稳妥有序化解风险。目前，成都分行已按监管要求完成了整改，总体风险可控，客户权益未受影响，经营管理迈入正轨。在此基础上，公司在全行范围内认真开展举一反三教育整改工作，深刻反思，统一思想，吸取教训；端正全行经营理念，更加关注安全性、流动性和效益性的平衡发展，强化统一法人管理；将防范和化解金融风险放在更加突出的位置，强化合规内控体制机制建设，着重提升内控执行力和有效性，确保全行依法合规、稳健发展。公司将认真贯彻落实党的十九大精神和全国金融工作会议、中央经济工作会议要求，积极服务实体经济，有效防控经营风险；坚持“回归本源、突出主业、做精专业、协调发展”，为供给侧结构性改革和广大客户提供更加优质的服务，努力为股东创造更大的价值，以良好的经营成果回报社会各界的关心和支持。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "309234"
    }, {
        "symbol": "600000.sh",
        "questioner": "打一个板",
        "question": "浦发银行(600000)775億融资的资产品质是否应说明一下 \n    ",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "银监会四川监管局对公司成都分行违规办理信贷业务，违反审慎经营规则的行为作出的行政处罚决定，公司坚决支持和接受并深表歉意。在监管机构和地方政府的指导和帮助下，公司及时调整了成都分行经营班子，并对资产状况进行了全面评估，分类施策、强化管理，按照审慎原则计提风险拨备，稳妥有序化解风险。目前，成都分行已按监管要求完成了整改，总体风险可控，经营管理迈入正轨。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "309584"
    }, {
        "symbol": "600000.sh",
        "questioner": "觉觉神",
        "question": "浦发银行(600000)请问，成都分行的775亿能收回多少 \n    ",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "截至2017年9月末，浦发银行成都分行已基本完成违规业务的整改，资产状况进行了全面评估，分类施策，按照审慎原则计提风险拨备，稳妥有序化解风险。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "309386"
    }, {
        "symbol": "600000.sh",
        "questioner": "杨丽娟ylj",
        "question": "浦发银行(600000)浦发银行是否存在违规办理信贷问题？ \n    ",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "针对成都分行的违规经营事项，公司高度重视，在监管机构和地方政府的指导和帮助下，已按监管要求完成了整改。同时公司以此为鞭策强化自身管理,坚持从严治行,在经营发展中始终将依法合规经营作为立行之本。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "309145"
    }, {
        "symbol": "600000.sh",
        "questioner": "欧阳XIAOJUN",
        "question": "浦发银行(600000)请问为何2015年后经营现金流一直为负数？17年报会有所改善吗？ \n    ",
        "questondate": "20180122",
        "answerer": "浦发银行",
        "answer": "现金流量净额减少的原因主要是报告期内客户贷款及垫款支付的现金增加。感谢您的关注！ \n    ",
        "answerdate": "20180122",
        "id": "309432"
    }, {
        "symbol": "600000.sh",
        "questioner": "zxk",
        "question": "浦发银行(600000)请问贵公司12月31日股东人数，谢谢！ \n    ",
        "questondate": "20180102",
        "answerer": "浦发银行",
        "answer": "2017年末股东人数将在公司年度报告中披露。感谢您的关注！ \n    ",
        "answerdate": "20180105",
        "id": "301664"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "浦发银行(600000)董秘您好！浦发近两年实际现金分红比例仅10%附近，低于原来承诺的30%。转股实际不是分红。提高净利润的现金分红比例，有利于提高上市公司地位，吸引投资者，提升股价。公司信贷扩张和补充资本金，可以向所有股东公开配股。投资者不希望低价定增，既不公平，也影响上市公司信誉。 \n    ",
        "questondate": "20180103",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！ \n    ",
        "answerdate": "20180105",
        "id": "302372"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)代理业务手续费收入消耗资本吗？ \n    ",
        "questondate": "20171221",
        "answerer": "浦发银行",
        "answer": "此类手续费收入不消耗资本。感谢您的关注！ \n    ",
        "answerdate": "20171227",
        "id": "297320"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)我们作为股东，要求公司年报中单独解释上年度留存利润的用途及投资收益情况，公司是否可以做到？ \n    ",
        "questondate": "20171214",
        "answerer": "浦发银行",
        "answer": "公司留存利润进入资本金支持公司各项业务发展。感谢您的关注！ \n    ",
        "answerdate": "20171227",
        "id": "295138"
    }, {
        "symbol": "600000.sh",
        "questioner": "化为pay",
        "question": "浦发银行(600000)开放跨行 ATM 手机 二维码取款或者 NFC 手机取款存在什么困难，以后可能实现吗 \n    ",
        "questondate": "20171211",
        "answerer": "浦发银行",
        "answer": "公司将持续推进数字化经营管理，构建全方位数字化渠道，技术的创新与运用需监管批准方可实施。感谢您的关注！ \n    ",
        "answerdate": "20171218",
        "id": "293409"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请问 1.重组贷款的认定标准是什么？ 2.重组贷款如果再次逾期怎么处理？ \n    ",
        "questondate": "20171121",
        "answerer": "浦发银行",
        "answer": "公司重组贷款的认定标准主要是参照监管标准，感谢您的关注！ \n    ",
        "answerdate": "20171218",
        "id": "285051"
    }, {
        "symbol": "600000.sh",
        "questioner": "沪市小股民",
        "question": "浦发银行(600000)您好，二维码取款可能实现吗 \n    ",
        "questondate": "20171212",
        "answerer": "浦发银行",
        "answer": "公司将持续推进数字化经营管理，构建全方位数字化渠道，建设新一代信息系统，不断创新产品、服务、渠道与业务模式，提高服务效率、降低运营成本、提升用户体验。感谢您的关注！ \n    ",
        "answerdate": "20171218",
        "id": "294079"
    }, {
        "symbol": "600000.sh",
        "questioner": "化为pay",
        "question": "浦发银行(600000)富德 股东的股票 怎么处理？ 股东 移动和上海国资委接盘？ \n    ",
        "questondate": "20171211",
        "answerer": "浦发银行",
        "answer": "公司将持续关注主要股东持股情况的变化，做好主要股东的沟通，加强股权管理，规范股东行为。感谢您的关注！ \n    ",
        "answerdate": "20171218",
        "id": "293577"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司有没有提高派息比率的计划？ \n    ",
        "questondate": "20171123",
        "answerer": "浦发银行",
        "answer": "公司的利润分配需要综合考虑监管机构的相关要求、集团自身盈利水平和资本补充并提高抗风险的能力、投资者分享公司成长和取得合理投资回报的期望，要平衡长期利益和即期利益，并且利润分配方案要经过股东大会审议通过方能实施。感谢您的关注！ \n    ",
        "answerdate": "20171206",
        "id": "286433"
    }, {
        "symbol": "600000.sh",
        "questioner": "割肉好痛苦啊",
        "question": "浦发银行(600000)请问1、浦发的四季度经营情况和不良资产的产生是否会有所转好。2、请问浦发二级市场股价长期低于净资产，公司的市值管理方面做了什么工作？3、浦发吧里的一些不实传闻或网络的一些不实传闻，作为董秘是否可发帖言明或解析以正视听？ \n    ",
        "questondate": "20171124",
        "answerer": "浦发银行",
        "answer": "公司目前经营正常，资产质量风险可控，我们将继续努力服务实体经济，努力完成各项经营目标和工作任务，为投资者创造回报。公司将遵循上市公司的监管规定履行信息披露义务，相关信息以定期报告、临时公告为准。感谢您的关注！ \n    ",
        "answerdate": "20171206",
        "id": "287515"
    }, {
        "symbol": "600000.sh",
        "questioner": "圳哥哥",
        "question": "浦发银行(600000)想问下公司，最近三年分红计划 \n    ",
        "questondate": "20171117",
        "answerer": "浦发银行",
        "answer": "《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。 感谢您的关注！ \n    ",
        "answerdate": "20171120",
        "id": "283959"
    }, {
        "symbol": "600000.sh",
        "questioner": "谋杀寂寞",
        "question": "浦发银行(600000)指定交易怎么查询？忘记在哪里指定交易了 \n    ",
        "questondate": "20171113",
        "answerer": "浦发银行",
        "answer": "请咨询您的开户券商。感谢您的关注！ \n    ",
        "answerdate": "20171120",
        "id": "281738"
    }, {
        "symbol": "600000.sh",
        "questioner": "布股鸟",
        "question": "浦发银行(600000)公司今年是否亏损.又是50指数.怎这么弱.有大利空现任高管沒捅破吗 \n    ",
        "questondate": "20171107",
        "answerer": "浦发银行",
        "answer": "2017年前三季度，公司利润总额547.43亿元，同比增加10.54亿元，增长1.96%；税后归属于母公司股东的净利润418.92亿元，同比增加12.10亿元，增长2.97%，不存在您所说的亏损情况。公司经营正常，保持了稳中有进、稳中向好的发展格局。感谢您的关注！ \n    ",
        "answerdate": "20171107",
        "id": "278792"
    }, {
        "symbol": "600000.sh",
        "questioner": "破产版巴菲特",
        "question": "浦发银行(600000)1.浦发银行今年两次公布的报表令人失望之余更加惊讶：浦发银行到底发生什么事情了、今年互联网爆料浦发银行成都分行坏账1600亿到底是怎么回事？目前看和现在公布的财务报表有着惊人的关联，但是浦发银行董事会矢口否认，发生这么大规模的坏账，却没有人担责，这是对股东们的不负责任，也是严重违 \n    ",
        "questondate": "20171031",
        "answerer": "浦发银行",
        "answer": "今年以来，受外部环境影响，社会整体信用风险仍继续上升，公司不良贷款呈上升态势；同时，公司主动加大风险处置力度，拨备覆盖率有所下降。后续公司将持续加强对风险的主动管理能力，相信2017年末资产质量将得到有效控制。近年来，受区域经济影响，公司成都分行资产质量承受一定压力，公司对成都分行的风险资产进行了全面评估，分类施策，强化管理，相关贷款风险总体可控。感谢您的关注！ \n    ",
        "answerdate": "20171107",
        "id": "276767"
    }, {
        "symbol": "600000.sh",
        "questioner": "破产版巴菲特",
        "question": "浦发银行(600000)2、根据浦发银行2016-2018年股东回报计划，多次明确指出现金回报不少于当年可分配利润的30%，可是2016年立即就违反了承诺，请问一个堂堂的上市公司，诚信何在？浦发银行副行长辩解说是要留在银行里面，帮股东创造出更高的利润，可是董事会一年可以亏掉500多亿的贷款，没玩没了融资 \n    ",
        "questondate": "20171031",
        "answerer": "浦发银行",
        "answer": "《2016-2018年股东回报计划》明确除特殊情况外，未来三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十， 公司最近三年（2014年度-2016年度）由董事会拟定以及经股东大会审议通过的利润分配方案，现金分红累计分配的利润占最近三年实现的年均可分配利润的56.86%。公司2016年度的利润分配履行了相关承诺。请各位股东放心，我们将继续履行这一承诺，未来三年现金分红累计分配的利润不少于最近三年实现的年均可分配利润的百分之三十。感谢您的关注！ \n    ",
        "answerdate": "20171107",
        "id": "276768"
    }, {
        "symbol": "600000.sh",
        "questioner": "homesleeping",
        "question": "浦发银行(600000)为何27号晚上没有公布季报 \n    ",
        "questondate": "20171030",
        "answerer": "浦发银行",
        "answer": "公司2017年度第三季度报告的披露日期为10月28日，三季度报告已于10月27日晚在上交所网站、指定媒体及我行官网进行了披露。感谢您的关注！ \n    ",
        "answerdate": "20171030",
        "id": "275882"
    }, {
        "symbol": "600000.sh",
        "questioner": "按时开工",
        "question": "浦发银行(600000)请问公司2017年扣除非经常性损益后的净利润增长百分比大约是多少？ \n    ",
        "questondate": "20171025",
        "answerer": "浦发银行",
        "answer": "截至2017年三季度末，公司归属于上市公司股东的扣除非经常性损益的净利润为413.05亿元，比上年同期增长4.01%。感谢您的关注！ \n    ",
        "answerdate": "20171030",
        "id": "274538"
    }, {
        "symbol": "600000.sh",
        "questioner": "amay1106",
        "question": "浦发银行(600000)您好！请问第三季度报是什么时候出来？ \n    ",
        "questondate": "20170929",
        "answerer": "浦发银行",
        "answer": "公司目前预约的三季报披露时间是10月28日。感谢您的关注！ \n    ",
        "answerdate": "20170929",
        "id": "267446"
    }, {
        "symbol": "600000.sh",
        "questioner": "新元220kv",
        "question": "浦发银行(600000)上海地区的网点太多，需要精简，现在都是 手机银行和ATM取款了，没有必要需要那么多的 网点 \n    ",
        "questondate": "20170922",
        "answerer": "浦发银行",
        "answer": "公司持续提升管理能效，提升资源配置集约化水平，优化网点人员配置，压缩劳动密集型作业事项，深入推进网点结构调整。感谢您的关注！ \n    ",
        "answerdate": "20170925",
        "id": "264900"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)浦发是否有计划在香港上市？或海外上市？我希望浦发可做大做强，更好地回报投资者。 \n    ",
        "questondate": "20170925",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！ \n    ",
        "answerdate": "20170925",
        "id": "265770"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000)为什么浦发对于市场价长期低于净资产没有采取措施，请问贵公司在市值管理方面做了什么工作？ \n    ",
        "questondate": "20170925",
        "answerer": "浦发银行",
        "answer": "公司股价尚保持在净资产之上。公司将继续努力经营，持续为股东赢取回报，为社会创造价值。公司也将进一步与投资者充分沟通，加深投资者对公司的了解和认同，树立良好的资本市场形象。感谢您的关注！ \n    ",
        "answerdate": "20170925",
        "id": "265778"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "浦发银行(600000)问一下 ， 到 2017年6月底的净资产是多少 ？ 为什么不审计 ？ 这样可以提高增发价 ， 也更公平点 。 \n    ",
        "questondate": "20170907",
        "answerer": "浦发银行",
        "answer": "截至2017年6月末公司每股净资产为12.70元。根据交易所股票上市规则，中期报告中的财务会计报告可以不经审计。感谢您的关注！ \n    ",
        "answerdate": "20170911",
        "id": "258327"
    }, {
        "symbol": "600000.sh",
        "questioner": "小巽巽",
        "question": "浦发银行(600000)公司有投资柔宇科技吗？如果有持有其多少股权? \n    ",
        "questondate": "20170906",
        "answerer": "浦发银行",
        "answer": "公司不持有柔宇科技股份，公司对外股权投资可以从公司披露的定期报告中查阅。感谢您的关注！ \n    ",
        "answerdate": "20170911",
        "id": "257875"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "浦发银行(600000)截至目前8家股份制银行中报都公布了，浦发上半年营业净收入同比增加，其他7家全部同比下降，行业标杆银行招商银行营业净收入也是微幅下降，与浦发情况类似的民生、兴业营业净收入同比均大幅超过10%以上，浦发不良贷款率处于最高，为何能做到营收增加？贵行是否遵循上市公司会计核算基本准则要求？ \n    ",
        "questondate": "20170831",
        "answerer": "浦发银行",
        "answer": "公司上半年不断优化资产结构，收入结构调整成效显著，非息收入多点发力，实现较快增长，从而使得营业收入保持了较好的水平。得益于收入的增长，公司针对不良贷款进行了充分的拨备计提。公司披露的财务报告严格遵循各项会计准则，2017年半年度报告已经普华永道中天会计师事务所（特殊普通合伙）分别根据中国注册会计师审阅准则和国际审阅准则审阅，并出具了无保留结论的审阅报告。感谢您的关注！ \n    ",
        "answerdate": "20170911",
        "id": "255894"
    }, {
        "symbol": "600000.sh",
        "questioner": "长期投资者2",
        "question": "浦发银行(600000)2017年一季报每股利润0.63元，之后转增摊薄为0.51元，二季报每股利润0.97元，即二季度摊薄后每股0.46元。净资产一季报16.2元，之后转增摊薄为13.52元，二季报每股净资产，按理应该是13.98元，为何实际上只有12.7元？整整少了1.28元 \n    ",
        "questondate": "20170830",
        "answerer": "浦发银行",
        "answer": "您采用的摊薄算法和实际有出入，公司报告披露普通股每股净资产及每股收益时需考虑优先股的影响。公司每股净资产 =（归属母公司股东的净资产 – 其他权益工具）/总股本，优先股即使其他权益工具，共计299.20亿元。（3869.79亿元-299.20亿元）/208.14亿股=12.70元/股。 \n    ",
        "answerdate": "20170830",
        "id": "255742"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "浦发银行(600000)请问，增发价是多少？ \n    ",
        "questondate": "20170830",
        "answerer": "浦发银行",
        "answer": "本次发行的定价基准日为本次非公开发行普通股股票发行期首日。 本次发行的发行价格为定价基准日前20个交易日（不含定价基准日）公司普通股股票交易均价的90%（向上取2位小数）与发行前最近一期末经审计的归属于母公司普通股股东的每股净资产（除权除息调整后为11.88元）孰高。 感谢您的关注！ \n    ",
        "answerdate": "20170830",
        "id": "255743"
    }, {
        "symbol": "600000.sh",
        "questioner": "戏中你我",
        "question": "浦发银行(600000)哪里能找到最新股东的进入与退出情况？是不是只能关注年报季报？比如明天有大机构买入大量的股票，我是不是只能等到公司新一期的报表才能看到？或者还有更快捷的途径让我第一时间得到消息嘛 \n    ",
        "questondate": "20170814",
        "answerer": "浦发银行",
        "answer": "公司将在定期报告中披露前十大股东持股情况。感谢您的关注！ \n    ",
        "answerdate": "20170830",
        "id": "250117"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000)希望浦发董事会管理层宣布在8月30日后增发。股本结构确实已经管理的很好了，公司经营的确实有美好的明天。只差两周，请增加长期投资散户们更坚决的信心。 謝谢 \n    ",
        "questondate": "20170821",
        "answerer": "浦发银行",
        "answer": "公司将根据批复要求认真做好发行工作，并履行信息披露义务。感谢您的关注！ \n    ",
        "answerdate": "20170830",
        "id": "252498"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "浦发银行(600000)西部亏了23个亿，为什么？公司有处理对策没有。另外个人存款占比只有招商银行的10%，公司跟移动和富得生命人寿三大股东不能合作资源共享，为公司发展壮大不要窝里斗行吗？我们小股东也可以一起参与。 \n    ",
        "questondate": "20170830",
        "answerer": "浦发银行",
        "answer": "非常感谢您的建议。近年来，受实体经济下行影响，煤炭等产能过剩行业的贷款逾期欠息情况上升，西部地区分行资产质量承受一定压力，对利润也造成一定影响。公司将按照监管机构要求，深化改革、积极创新、回归本源、专注主业，积极推进各项措施，开展多渠道盘活信贷资源，加大结构调整力度，加快处置不良资产，努力提升集团整体经营能力和竞争优势，为股东创造利益。公司积极与各方股东开展多类型合作，与中国移动基于新五年战略合作协议，确定将紧密结合用户需求和金融科技发展变化，在利用互联网平台强化客户服务、促进“金融+通信”数字化技术融合和创新应用、提升服务价值等方面深化战略合作。感谢您的关注！ \n    ",
        "answerdate": "20170830",
        "id": "255628"
    }, {
        "symbol": "600000.sh",
        "questioner": "wyj7225",
        "question": "[浦发银行(600000)]公司所持江苏银行的股份流通了吗？计划什么时候坚持？\r\n    ",
        "questondate": "20170811",
        "answerer": "浦发银行",
        "answer": "公司不持有江苏银行股份。感谢您的关注！\r\n    ",
        "answerdate": "20170811",
        "id": "249479"
    }, {
        "symbol": "600000.sh",
        "questioner": "很舒畅",
        "question": "[浦发银行(600000)]6月28日的2017年第一届股东大会已过去40多天，增发的时间为何还未定？\r\n    ",
        "questondate": "20170807",
        "answerer": "浦发银行",
        "answer": "公司定向增发事宜尚需收到监管部门核准发行文件后方可执行。感谢您的关注！\r\n    ",
        "answerdate": "20170811",
        "id": "248713"
    }, {
        "symbol": "600000.sh",
        "questioner": "周斌AAA",
        "question": "[浦发银行(600000)]建议取消增发，改为全体股份配股，增发这种融资形式侵害现有股东利益。\r\n    ",
        "questondate": "20170807",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！\r\n    ",
        "answerdate": "20170807",
        "id": "248111"
    }, {
        "symbol": "600000.sh",
        "questioner": "周斌AAA",
        "question": "[浦发银行(600000)]放弃增发，改为配股。公司发展很重要，配股也可以达到融资目的。\r\n    ",
        "questondate": "20170807",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！\r\n    ",
        "answerdate": "20170807",
        "id": "248114"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "[浦发银行(600000)]请问日照精品钢基地哪天投产？己经八月了应该有个准确时间了吧\r\n    ",
        "questondate": "20170807",
        "answerer": "浦发银行",
        "answer": "请向日照精品钢基地咨询有关情况。感谢您的关注！\r\n    ",
        "answerdate": "20170807",
        "id": "248374"
    }, {
        "symbol": "600000.sh",
        "questioner": "海鲜",
        "question": "[浦发银行(600000)]公司现金流为何这么差呀？\r\n    ",
        "questondate": "20170807",
        "answerer": "浦发银行",
        "answer": "现金流量净额减少的原因主要是报告期内客户贷款及垫款支付的现金增加。感谢您的关注！\r\n    ",
        "answerdate": "20170807",
        "id": "248177"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "[浦发银行(600000)]浦发卡`在全国使用办理功能都是同样吗\r\n    ",
        "questondate": "20170804",
        "answerer": "浦发银行",
        "answer": "具体业务请咨询我行客服电话95528。感谢您的关注！\r\n    ",
        "answerdate": "20170807",
        "id": "247934"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "[浦发银行(600000)]公司说：投资者分享公司成长和取得合理投资回报的期望，要平衡长期利益和即期利益。凯恩斯说：长期是对当前事情的误导。长期来看浦发很有可能将未分配利润浪费在低效甚至亏损的项目上，这是每一个机构壮大后的官僚体系引起的附加效应。请问公司怎么看？\r\n    ",
        "questondate": "20170801",
        "answerer": "浦发银行",
        "answer": "您的意见我们已经收到。感谢您的关注！\r\n    ",
        "answerdate": "20170803",
        "id": "246711"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "[浦发银行(600000)]我们认为的分红水平至少要达到50%，才叫做平衡短期和长期利益。因为长期看只要失败一次，所有的留存利润就会化为梦幻泡影。而且长期看，我们都会死，人都不在了，谁还指望着你那虚无缥缈的未来分红？\r\n    ",
        "questondate": "20170801",
        "answerer": "浦发银行",
        "answer": "您的意见我们已经收到。感谢您的关注！\r\n    ",
        "answerdate": "20170803",
        "id": "246713"
    }, {
        "symbol": "600000.sh",
        "questioner": "很舒畅",
        "question": "浦发银行(600000) 汇丰银行的个人信用卡业务办得很火热，面对竞争对手你们有应对措施么？",
        "questondate": "20170727",
        "answerer": "浦发银行",
        "answer": "近年来，公司信用卡业务呈高速发展态势，各项指标增长显著，风险控制能力不断提升。截至2016年末，信用卡累计发卡 2,758.31 万张，流通卡数 1,687.59 万张，流通户数 1,510.77 万户，信用卡透支余额 2,667.76 亿元。感谢您的关注！",
        "answerdate": "20170731",
        "id": "245570"
    }, {
        "symbol": "600000.sh",
        "questioner": "xq慶",
        "question": "浦发银行(600000) 请问怎么绑定股东账号",
        "questondate": "20170731",
        "answerer": "浦发银行",
        "answer": "请咨询您的开户券商。谢谢！",
        "answerdate": "20170731",
        "id": "246342"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000) 如果盈利不以红利的方式支付给股东，而是成功地再投资，以期为股东创造更高的复利,那这些盈利应当在未来转化为红利；否则，它们就算作流失的资金,盈利仅仅是达到目的的手段，而手段不能误认为目的。所以可以说，股票的价值体现在红利上，不是其盈利上。请问你怎么看？",
        "questondate": "20170727",
        "answerer": "浦发银行",
        "answer": "公司的利润分配需要综合考虑监管机构的相关要求、集团自身盈利水平和资本补充并提高抗风险的能力、投资者分享公司成长和取得合理投资回报的期望，要平衡长期利益和即期利益，并且利润分配方案要经过股东大会由全体审议通过方能实施。感谢您的关注！",
        "answerdate": "20170731",
        "id": "245581"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "浦发银行(600000) 请问上半年业绩快报何时出来啊，都快半年报了，业绩快报怎么没有啊",
        "questondate": "20170728",
        "answerer": "浦发银行",
        "answer": "公司半年报预计将于2017年8月30日披露。感谢您的关注！",
        "answerdate": "20170731",
        "id": "245696"
    }, {
        "symbol": "600000.sh",
        "questioner": "双核涨涨",
        "question": "浦发银行(600000) 怎样绑定股东卡号，股东卡号是什么？",
        "questondate": "20170718",
        "answerer": "浦发银行",
        "answer": "请咨询您的开户券商。谢谢！",
        "answerdate": "20170718",
        "id": "241847"
    }, {
        "symbol": "600000.sh",
        "questioner": "割肉好痛苦啊",
        "question": "浦发银行(600000) 为什么不能全体持股者按比例发行？",
        "questondate": "20170630",
        "answerer": "浦发银行",
        "answer": "非公开发行方案尚待监管部门核准，感谢您的关注！",
        "answerdate": "20170718",
        "id": "237625"
    }, {
        "symbol": "600000.sh",
        "questioner": "觉觉神",
        "question": "浦发银行(600000) 其他银行增发走监管程序效率要浦发高的多，大家都有对比，不要已走程序为借口，会影响浦发形象信誉，请问何时完成增发？",
        "questondate": "20170713",
        "answerer": "浦发银行",
        "answer": "本次非公开发行自2016年3月启动以来历时一年多，鉴于银行业是特殊行业需履行监管机构的审批程序，公司将积极推进非公开发行的相关工作，争取早日实施完毕。谢谢您的关注！",
        "answerdate": "20170718",
        "id": "240967"
    }, {
        "symbol": "600000.sh",
        "questioner": "特高压-",
        "question": "浦发银行(600000) 中西部省份应该 每个地级市都有网点， 北上广网点太多",
        "questondate": "20170713",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！",
        "answerdate": "20170718",
        "id": "241087"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "浦发银行(600000) 定增时间拖的太长了，从计划定增到现在如此长时间未能完成，工作效率让人不敢恭维，请问何时才能完成增发？",
        "questondate": "20170623",
        "answerer": "浦发银行",
        "answer": "本次非公开发行自2016年3月启动以来历时一年多，鉴于银行业是特殊行业需履行监管机构的审批程序，公司将积极推进非公开发行的相关工作，争取早日实施完毕。谢谢您的关注！",
        "answerdate": "20170703",
        "id": "236163"
    }, {
        "symbol": "600000.sh",
        "questioner": "君君君",
        "question": "浦发银行(600000) 上海市场权证交易的佣金是多少",
        "questondate": "20170620",
        "answerer": "浦发银行",
        "answer": "请咨询交易所部门。谢谢您！",
        "answerdate": "20170703",
        "id": "235266"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000) 希望作为成功发展的国内股份制商业银业对以上个人提问作出回复。个人对浦发银行的净资产准备定价在不同的证券软件上看到不同的数字。所以向董秘请教。谢谢。",
        "questondate": "20170619",
        "answerer": "浦发银行",
        "answer": "公司最近一期经审计的财务报告（2016年度）归属于母公司普通股股东的每股净资产为15.64元，结合公司2016年度利润分配情况，除权除息后每股净资产为相应调整为11.88元,谢谢您的关注！",
        "answerdate": "20170703",
        "id": "235075"
    }, {
        "symbol": "600000.sh",
        "questioner": "昭和罗曼史",
        "question": "浦发银行(600000) 希望作为成功发展的国内股份制商业银业对以上提问作出回复。个人对浦发银行的净资产准备定价在不同的证券软件上看到不同的数字。所以向董秘请教。谢谢。",
        "questondate": "20170619",
        "answerer": "浦发银行",
        "answer": "公司最近一期经审计的财务报告（2016年度）归属于母公司普通股股东的每股净资产为15.64元，结合公司2016年度利润分配情况，除权除息后每股净资产为相应调整为11.88元,谢谢您的关注！",
        "answerdate": "20170703",
        "id": "235081"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000) 请问：转增股本后增发价调整吗？",
        "questondate": "20170612",
        "answerer": "浦发银行",
        "answer": "2017年6月12日，公司董事会审议通过了《关于调整非公开发行普通股股票方案的议案》，同意对本次非公开发行普通股股票方案中的“发行价格及定价方式”及“发行数量”进行调整，股东大会决议有效期相应重新确定，发行方案其他内容保持不变，调整后方案内容：\n“本次发行的定价基准日为本次非公开发行普通股股票发行期首日。\n本次发行的发行价格为定价基准日前20个交易日（不含定价基准日）公司普通股股票交易均价的90%（向上取2位小数）与发行前最近一期末经审计的归属于母公司普通股股东的每股净资产孰高。\n感谢您的关注！",
        "answerdate": "20170614",
        "id": "233111"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "浦发银行(600000) 请问浦发银行今年还按14.16元（不除权）增发吗？",
        "questondate": "20170525",
        "answerer": "浦发银行",
        "answer": "2017年6月12日，公司董事会审议通过了《关于调整非公开发行普通股股票方案的议案》，同意对本次非公开发行普通股股票方案中的“发行价格及定价方式”及“发行数量”进行调整，股东大会决议有效期相应重新确定，发行方案其他内容保持不变，具体情况详见公司同日披露的《关于调整非公开发行普通股股票方案的公告》。调整后方案内容：\n“本次发行的定价基准日为本次非公开发行普通股股票发行期首日。\n本次发行的发行价格为定价基准日前20个交易日（不含定价基准日）公司普通股股票交易均价的90%（向上取2位小数）与发行前最近一期末经审计的归属于母公司普通股股东的每股净资产孰高。\n感谢您的关注！",
        "answerdate": "20170614",
        "id": "229390"
    }, {
        "symbol": "600000.sh",
        "questioner": "Naruto",
        "question": "浦发银行(600000) 为什么别人给我转账 提示失败 请问是怎么回事",
        "questondate": "20170531",
        "answerer": "浦发银行",
        "answer": "请咨询客服热线95528，谢谢！",
        "answerdate": "20170614",
        "id": "230045"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)银行业处于成熟阶段，照理应该是加大派息回报股东的阶段，而目前公司却面临减少股息、坏账爆发、资本充足率不足的困境，我们判断是盲目扩张造成的，请问公司是否认同。",
        "questondate": "20170524",
        "answerer": "浦发银行",
        "answer": "2016年度利润分配方案是综合考虑国家经济的新常态、银行监管机构的相关要求，又结合了公司的行业特点、发展阶段，以及自身盈利水平和资本补充等因素，感谢您的关注！",
        "answerdate": "20170526",
        "id": "228895"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)股价长期低于净资产，有没有什么措施吗？",
        "questondate": "20170517",
        "answerer": "浦发银行",
        "answer": "公司密切关注股价动态，公司目前经营正常，我们将继续努力服务实体经济，稳步推进战略转型和集团化经营，努力完成各项经营目标和工作任务，为投资者创造回报。感谢您的关注！",
        "answerdate": "20170526",
        "id": "226697"
    }, {
        "symbol": "600000.sh",
        "questioner": "twh0357",
        "question": "浦发银行(600000)请问浦发银行的2017上半年的前十大股东变化？",
        "questondate": "20170522",
        "answerer": "浦发银行",
        "answer": "公司半年度报告将披露2017上半年十大股东持股情况，谢谢您的关注!",
        "answerdate": "20170526",
        "id": "227810"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司认为公司的股价长期来看（10年以上）由什么决定？你错了，长期的股价完全由预期的股息来支撑，请牢记，基本面再好，不分红就和资本市场毫无关系，股票就是一个代码而已。",
        "questondate": "20170516",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！",
        "answerdate": "20170526",
        "id": "226246"
    }, {
        "symbol": "600000.sh",
        "questioner": "sin3872",
        "question": "浦发银行(600000)浦发银行融资融券信息",
        "questondate": "20170519",
        "answerer": "浦发银行",
        "answer": "您好，每日的融资融券信息可以访问上交所网站（http://www.sse.com.cn）查询。感谢您的关注！",
        "answerdate": "20170519",
        "id": "227441"
    }, {
        "symbol": "600000.sh",
        "questioner": "YY1459",
        "question": "浦发银行(600000)你好，请问浦发银行投资金条价格今天多少一克？",
        "questondate": "20170518",
        "answerer": "浦发银行",
        "answer": "请拨打我行24小时热线（95528）进行询问。感谢您的关注！",
        "answerdate": "20170519",
        "id": "227070"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n秸4001",
        "question": "浦发银行(600000)请问发行的虚拟信用卡，背后的场景选择、风控逻辑、目标客群和实体信用卡有没有本质区别 ",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "我行E-GO卡独立虚拟信用卡归属于客户的浦发银行个人信用卡账户下，客户可在可用信用额度内自由设置E-GO卡消费额度和使用期限，也可随时暂停或开启卡片的使用，最大限度避免信用卡盗刷风险。虚拟信用卡与实体信用卡产品基本无差别，仅虚拟卡不会发放实体卡片，不支持线下接触式交易及取现交易。虚拟信用卡支持即申即用，可有效提升持卡人用卡体验，促动激活及动卡率的提高。感谢您的关注！ ",
        "answerdate": "20170517",
        "id": "225463"
    }, {
        "symbol": "600000.sh",
        "questioner": "ABC0584",
        "question": "浦发银行(600000)请问你们股票波动的主要原因是什么",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "公司密切关注股价动态，公司的股价除了基本面以外，也受到市场环境、行情走势、宏观政策等多方面的影响。感谢您的关注！",
        "answerdate": "20170516",
        "id": "225387"
    }, {
        "symbol": "600000.sh",
        "questioner": "慕容寒寒",
        "question": "浦发银行(600000)请问对于不良贷款的增加有做出什么相应的处理吗？",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "我行将持续加强对风险的主动管理能力，持续优化风险管理架构与运营机制；同时加大对风险贷款的处置和化解力度，控制不良贷款反弹，争取资产质量保持在良好水平。感谢您的关注！",
        "answerdate": "20170516",
        "id": "225373"
    }, {
        "symbol": "600000.sh",
        "questioner": "秋秋妮",
        "question": "浦发银行(600000)浦发银行明年的预计分红是多少？",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。公司最近三年（2014年度-2016年度）由董事会拟定以及经股东大会审议通过的利润分配方案，现金分红累计分配的利润占最近三年实现的年均可分配利润的56.86%。感谢您的关注！",
        "answerdate": "20170516",
        "id": "225454"
    }, {
        "symbol": "600000.sh",
        "questioner": "天舞宝轮",
        "question": "浦发银行(600000)浦发银行这几个月的股价严重下挫，麻烦你们高度重视这个问题并采取措施，股价比招商银行每股低四块，也不知道你们怎么想的？你们让股民这些年省过心吗？网上的回答都是套话官话 一点实质性内容没有！",
        "questondate": "20170508",
        "answerer": "浦发银行",
        "answer": "公司密切关注股价动态，公司的股价除了基本面以外，也受到市场环境、行情走势、宏观政策等多方面的影响。公司目前经营正常，我们将继续努力服务实体经济，稳步推进战略转型和集团化经营，努力完成各项经营目标和工作任务，为投资者创造回报。感谢您的关注！",
        "answerdate": "20170516",
        "id": "223254"
    }, {
        "symbol": "600000.sh",
        "questioner": "xyh0240",
        "question": "浦发银行(600000)请问浦发银行今年什么时候发分红？",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "目前实施的时间尚未最终确定，谢谢您的关注！",
        "answerdate": "20170516",
        "id": "225348"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请问银行业未来还有增长前景吗，还是说变成了夕阳产业。很怀念之前10年的高速增长期啊。",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "目前，商业银行面临的外部环境更为复杂，经营管理方面的挑战压力更大。浦发银行将继续以新五年发展规划为统领，克服多重压力，加大创新转型，强化战略引领，优化经营策略，努力完成各项经营目标和工作任务，为投资者创造回报。感谢您的关注！",
        "answerdate": "20170516",
        "id": "225349"
    }, {
        "symbol": "600000.sh",
        "questioner": "彭俊豪0526",
        "question": "浦发银行(600000)请问浦发银行本年第一季度现金流量具体是多少？",
        "questondate": "20170515",
        "answerer": "浦发银行",
        "answer": "截至一季度末，公司经营活动产生的现金流量净额 -2009.70亿元，每股经营活动产生的现金流量净额-9.30元，详情请参见公司第一季度报告中的“合并及公司现金流量表”，感谢您的关注！",
        "answerdate": "20170516",
        "id": "225483"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)今年的分红政策太有失水准，太令人失望。这就是为什么股价大幅落后招商银行，大幅落后兴业银行。浦发管理层真的要反思了，刘信义同志上台以来，连续两年降低分红，最后竟然沦落到用转股来忽悠股民的地步，真的太不把股东放在眼里了。",
        "questondate": "20170509",
        "answerer": "浦发银行",
        "answer": "公司2017年4月11日通过网络方式召开2016年度网上业绩说明会已就2016年度的分红方案考虑的因素予以了详细解答，一是国际、国内外部资本监管要求都更趋严格，特别是央行的宏观审慎监管体系，对商业银行资本充足水平提出了更高的要求；二是随着公司集团化、国际化战略的不断推进，集团及各子公司的发展日益健康快速，对于资本补充的需求也显著上升；三是受外部经济环境影响，国家持续推进去产能、去库存、去杠杆的改革，国内银行业风险管控压力持续上升有所加大。我行资本充足率水平与同业相比较低，同时各家银行发展的战略、经验的特点和面临的挑战也各有不同。感谢您的关注！",
        "answerdate": "20170511",
        "id": "223646"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)我知道你接下来要说一通什么资本不够啦，综合考虑风险因素，存款人利益和股东利益平衡之类的废话。但我就一句话：招商银行没有这个问题，兴业银行没有这个问题，民生银行没有这个问题，就你有这个问题，还占了上海这么个好地方，真的很浪费，这不仅让人联想到美国的一句名言：没有回报的天赋。",
        "questondate": "20170509",
        "answerer": "浦发银行",
        "answer": "2016年度利润分配方案既考虑了国家经济的新常态、银行监管机构的相关要求，又结合了公司的行业特点、发展阶段，以及自身盈利水平和资本补充等因素，目前获得了股东大会的通过。感谢您的关注！",
        "answerdate": "20170511",
        "id": "223656"
    }, {
        "symbol": "600000.sh",
        "questioner": "蓄意",
        "question": "浦发银行(600000)看到公司董秘如此尽职尽责，深深感到欣慰，相比红阳能源，提问数月信息持续堆积不答，实在天壤之别，给你点个赞",
        "questondate": "20170508",
        "answerer": "浦发银行",
        "answer": "感谢您的关注！",
        "answerdate": "20170511",
        "id": "223403"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的小散户ixv2n8",
        "question": "浦发银行(600000)如果股价跌破定向增发价，大股东是否会放弃增发？如放弃，大股东将负什么样的违约责任？",
        "questondate": "20170509",
        "answerer": "浦发银行",
        "answer": "根据非公开发行普通股股票预案，“认购方同意不可撤销地按照本协议确定的认购价款以人民币现金方式认购浦发银行本次非公开发行的标的股份”。感谢您的关注！",
        "answerdate": "20170511",
        "id": "223476"
    }, {
        "symbol": "600000.sh",
        "questioner": "奔跑中的蜗牛",
        "question": "浦发银行(600000)600000 2017.03.30 净资产是多少？",
        "questondate": "20170505",
        "answerer": "浦发银行",
        "answer": "截至2017年3月31日，公司归属于母公司普通股股东的每股净资产为16.20元。感谢您的关注！",
        "answerdate": "20170508",
        "id": "222488"
    }, {
        "symbol": "600000.sh",
        "questioner": "景钊胜",
        "question": "浦发银行(600000)很多所谓的中介说给你们有合作关系，影响贵公司商誉。帮助客户填写虚假资料骗贷，阻碍实体经济增长,污蔑银行信贷员工受贿。请问如果本人提供相关线索，贵公司是否要追究相关法律责任？",
        "questondate": "20170505",
        "answerer": "浦发银行",
        "answer": "公司严格遵守法律法规和监管机构的规范指引，不断完善合规经营。您可以拨打我行24小时热线（95528）就相关情况进行反映。感谢您的关注！",
        "answerdate": "20170508",
        "id": "222434"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n套与被套",
        "question": "浦发银行(600000)董秘您好：请问民生银行现在股东人数是多少，谢谢！ ",
        "questondate": "20170425",
        "answerer": "浦发银行",
        "answer": "民生银行的相关情况请咨询民生银行。我行截至2017年一季度末的股东人数为173,130人。感谢您的关注！ ",
        "answerdate": "20170428",
        "id": "219068"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nNoenemy股神",
        "question": "浦发银行(600000)在香港市场削减股息被视为重大利空，因为香港公司的发展非常依靠公众股东。而在内地则无所谓，根本原因在于内地公司主要依靠大股东融资，而大股东多为公有制企业而非私企，大股东对分不分红无所谓，反正不会进自己的口袋，因此公司通常只要和大股东的管理层搞好关系就可以了，请问是否认同上述逻辑？ ",
        "questondate": "20170424",
        "answerer": "浦发银行",
        "answer": "浦发银行多年来一直积极组织落实投资者关系管理相关制度要求，构建公司服务投资者、尊重投资者的企业文化。公司持续完善重大信息报告制度，确保所有投资者能够及时、准确、平等地获得公司的公开信息；积极主动进行信息披露，不断提高信息披露的标准和质量；充分运用多种形式、多种渠道，依法、合规地公开银行信息，不断增强银行经营管理的透明度，改善投资者体验，提高投资者信息满意度。浦发银行不存在只与部分投资者搞好关系的情况，感谢您的关注！ ",
        "answerdate": "20170426",
        "id": "218178"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nNoenemy股神",
        "question": "浦发银行(600000)“根据公司经营计划，2017年资产规模只增长6%左右，那么为什么还要减少分红，还要增发，净资产的增加在15%以上，早就够了”，我认为这个问题的回答没有诚意，没有任何数据佐证，请重新回答。资本充足水平不够吗，我看够；资本补充的需求需要多少；风险管控压力持续上升，需要多少资本冲销？ ",
        "questondate": "20170420",
        "answerer": "浦发银行",
        "answer": "有关2016年的利润分配，公司已在年报以及网上业绩说明会上予以了详细的阐述，并经2016年度股东大会审议通过。截至2016年末，公司资本充足率为11.37%，较2015年末下降0.86个百分点；在上市银行中公司资本充足率相比较低，其中核心一级资本充足率在上市银行中排名后位。公司将进一步加强资本管理，确保资本充足率满足内外部监管要求。感谢您的关注！ ",
        "answerdate": "20170426",
        "id": "217759"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n天舞宝轮",
        "question": "浦发银行(600000)浦发银行您好，浦发银行的股价以前长期横盘，萎靡不振，这也就算了。但是从二月下旬开始阴跌不止，并且最近出现大幅度下挫，难道你们就不觉得这反映了你们有什么事做的不对吗？你们对这种股价明显长期下挫现象无动于衷吗？跌倒何时你们才满意？谢谢 请正面回答 ",
        "questondate": "20170420",
        "answerer": "浦发银行",
        "answer": "公司十分关注股价的走势，公司股价受到市场环境、宏观政策等多方面的影响。公司将围绕“保收入、控风险、调结构”经营主线，实现各利益相关者的利益均衡化和最大化，保护存款人的利益，为股东赢取回报，为社会创造价值。感谢您的关注！ ",
        "answerdate": "20170426",
        "id": "217599"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n觉觉神",
        "question": "浦发银行(600000)今年浦发银行的年报经营现金流居然出现了负1920亿之多，这是2010年负55亿以来第一次出现，我们知道经营现金流是一家公司很重要的部分，是研判公司运作和经营的重要指标，当然银行并不适合看现金流量表，但是我想了解是什么情况造成这个问题，请解释。 ",
        "questondate": "20170419",
        "answerer": "浦发银行",
        "answer": "经营活动（支付）/产生的现金流量净额减少的原因主要是报告期内客户贷款及垫款支付的现金增加。感谢您的关注！ ",
        "answerdate": "20170420",
        "id": "217207"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nNoenemy股神",
        "question": "浦发银行(600000)根据公司经营计划，2017年资产规模只增长6%左右，那么为什么还要减少分红，还要增发，净资产的增加在15%以上，早就够了。请解释一下 ",
        "questondate": "20170419",
        "answerer": "浦发银行",
        "answer": "一是国际、国内外部资本监管要求都更趋严格，特别是央行的宏观审慎监管体系，对商业银行资本充足水平提出了更高的要求；二是随着公司集团化、国际化战略的不断推进，集团及各子公司的发展日益健康快速，对于资本补充的需求也显著上升；三是受外部经济环境影响，国家持续推进去产能、去库存、去杠杆的改革，国内银行业风险管控压力持续上升有所加大。感谢您的关注！ ",
        "answerdate": "20170420",
        "id": "217299"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nWL2500014",
        "question": "浦发银行(600000)看了贵公司对本次非公开发行证监会审核意见的回复，承认发行价低于2016年未每股净资产。只谈当时定价的合法规性，未谈定价日与实际发行日已远，资产增值发行的改进措施，对此深感失望。如按原方案发行，则是大股东在侵蚀原股东的财富。再授权延长董事会全权处理本次非公开发行事宜，妥与否值得深思！ ",
        "questondate": "20170410",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行的定价基准日为公司第五届董事会第五十三次会议决议公告日，即2016年3月11日；公司在定价基准日的时候，参考了当时最近一期末经审计的每股净资产值。近感谢您的建议！ ",
        "answerdate": "20170411",
        "id": "214048"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)既然定价基谁日可以是：董事会决议公告日、股东会议案公告日、也可以是发行期首日。选择董事会决议公告日作基准导致发行价低于发行前一年度已经审计的每股净资产，损害了其他股东利益。基于公平原则，从法律角度看，那就应当将定价基准日选为发行期首日。 ",
        "questondate": "20170410",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行的定价基准日为公司第五届董事会第五十三次会议决议公告日，即2016年3月11日；公司在定价基准日的时候，参考了当时最近一期末经审计的每股净资产值。在彼时，公司无法预知未来公司股票在二级市场的走势，亦无法确定最终取得批准或核准的时间。近感谢您的建议！ ",
        "answerdate": "20170411",
        "id": "213904"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nfjfqyjx",
        "question": "浦发银行(600000)贷款损失准备计提情况中“因折现价值上升转回”是什么意思，能举例说明吗？谢谢 ",
        "questondate": "20170405",
        "answerer": "浦发银行",
        "answer": "“因折现价值上升转回”是指已减值贷款的价值等于未来预期收到的现金流按照特定的折现率进行折现后的价值。假设一笔贷款的原值为a, 当这笔贷款被识别为减值贷款后，预计3年后客户获得的现金流量为b，折现率为c，则该笔贷款的现值为b/(1+c)^3，减值准备的金额为a-b/(1+c)^3。一年后，原来的假设都不变的情况下，该笔贷款只要折两年就够了，所以减值准备就变成a-b/(1+c)^2，减值准备需要转回的金额为b/(1+c)^2-b/(1+c)^3。 谢谢您的关注！ ",
        "answerdate": "20170411",
        "id": "212660"
    }, {
        "symbol": "600000.sh",
        "questioner": "最稳健的投资者",
        "question": "浦发银行(600000)浦发此次分红每股0.2元，不到利润2.4元的十分之一，虽然同时送0.3股，但作为非专业人士，我不懂送股可以折算成分红吗？如不能，那么分红太少了，如能，那该怎么算，请教。",
        "questondate": "20170405",
        "answerer": "浦发银行",
        "answer": "转增股本是指公司将资本公积转化为股本，并未改变股东的权益，增加了股本规模。公司本年度综合考虑监管机构的相关要求、集团自身盈利水平和资本补充并提高抗风险的能力、投资者分享公司成长和取得合理投资回报的期望，适当提高了利润留存比例，确定了利润分配方案。感谢您的关注！",
        "answerdate": "20170407",
        "id": "212612"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)转增股票的原因一般而言是因为预期来年可以实现大幅增长，不至于降低每股收益，从而保持股价稳定。请问公司是基于什么原因考虑转增股票的",
        "questondate": "20170405",
        "answerer": "浦发银行",
        "answer": "公司2016年度利润分配预案主要是考虑：一是国际、国内外部资本监管要求都更趋严格，特别是央行的宏观审慎监管体系，对商业银行资本充足水平提出了更高的要求；二是随着公司集团化、国际化战略的不断推进，集团及各子公司的发展日益健康快速，对于资本补充的需求也显著上升；三是受外部经济环境影响，国家持续推进去产能、去库存、去杠杆的改革，国内银行业风险管控压力持续上升有所加大。感谢您的关注！",
        "answerdate": "20170407",
        "id": "212890"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司现金分红已经连续两年减少10%以上，虽然符合公司章程。但是请问难道招商银行不存在浦发银行现阶段面临的问题，但招商银行始终保持了现金分红率30%，而且浦发银行也刚刚增发过了，难道浦发近期的状况真的差到这种地步？",
        "questondate": "20170405",
        "answerer": "浦发银行",
        "answer": "公司2016年度利润分配预案主要是考虑：一是国际、国内外部资本监管要求都更趋严格，特别是央行的宏观审慎监管体系，对商业银行资本充足水平提出了更高的要求；二是随着公司集团化、国际化战略的不断推进，集团及各子公司的发展日益健康快速，对于资本补充的需求也显著上升；三是受外部经济环境影响，国家持续推进去产能、去库存、去杠杆的改革，国内银行业风险管控压力持续上升有所加大。感谢您的关注！",
        "answerdate": "20170407",
        "id": "212891"
    }, {
        "symbol": "600000.sh",
        "questioner": "钝刀割肉",
        "question": "浦发银行(600000)董秘好，网络媒体报道“浦发银行成都分行成“壳”公司温床，违规资金超1000亿元”，浦发成都分行向2010个壳公司授信1600亿元，实际被7大集团使用，目前已显现风险865亿元，银监会已介入调查。请问是否真实，7大集团是否存在债务违约，对浦发银行业绩影响如何",
        "questondate": "20170405",
        "answerer": "浦发银行",
        "answer": "我们关注到有关网传信息，相关信息与事实不符。受四川地区传统实体经济下行影响，公司成都分行资产质量承受了一定压力，总行和分行均已采取必要措施加强管理，积极处置化解，截至目前，成都分行经营正常，风险整体可控。感谢您的关注！",
        "answerdate": "20170407",
        "id": "212930"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_421244",
        "question": "浦发银行(600000)今日有媒体报道浦发银行成都分行通过向多家非正常经营或虚假注册的2010个“壳”公司投放授信1655笔，合计1600亿元。请问是否属实？",
        "questondate": "20170405",
        "answerer": "浦发银行",
        "answer": "我们关注到有关网传信息，相关信息与事实不符。受四川地区传统实体经济下行影响，公司成都分行资产质量承受了一定压力，总行和分行均已采取必要措施加强管理，积极处置化解，截至目前，成都分行经营正常，风险整体可控。感谢您的关注！",
        "answerdate": "20170407",
        "id": "212963"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n割肉好痛苦啊",
        "question": "浦发银行(600000)公司最近负面新闻不断，是否公司管理存在一定问题？ ",
        "questondate": "20170328",
        "answerer": "浦发银行",
        "answer": "公司经营正常，且一直依法合规开展各项工作，我们会继续把各项经营管理工作做好，回报投资者对我们的信任与支持。感谢您的关注！ ",
        "answerdate": "20170405",
        "id": "211231"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)重新细读增发方案及去年4月28日股东会资料，发现增发方案及股东会授权均于今年4月29日到期。此前有误读之处在此致歉！假如期限之前未能获批，董事会将重新召开股东会就原方案再次寻求授权？还是会顺应中小股东诉求调高增发价再寻授权？或按证监会市价增发的新规要求重新制定增发方案？谢谢回复！ ",
        "questondate": "20170327",
        "answerer": "浦发银行",
        "answer": "如在股东大会授权的有效期内非公开发行未能完成，公司需根据相关法律法规，完成董事会和股东大会的决策程序。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210988"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)浦发银行于2016年3月18日向上海国际集团有限公司等11名特定对象发行股份 999,510,332股，2016年4月28日又召开股东大会审议通过《公司关于非公开发行普通股股票方案的议案》，请问两次发行相隔月余，是否符合我国有关法规关于发行间隔规定？公司是否考虑连续增发对公司每股收益的影响及股东的承受能力？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "证监会今年2月17日对《上市公司非公开发行股票实施细则》的部分条文进行了修改并发布了《发行监管问答-关于引导规范上市公司融资行为的监管要求》。根据证监会相关信息，为实现平稳过渡，在适用时效上，《实施细则》和《监管问答》自发布或修订之日起实施，已经受理的再融资项目不受影响。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210605"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)公司已于2016年3月11日公布非公开发行方案，2016年4月28日又召开股东大会审议通过，为什么直至2016年12月20日才获证监会核准通过？这期间董事会是否存在故意拖延发行时间的问题？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "本次非公开发行工作启动以来，公司按照监管要求履行了相应的法定程序，并规范、持续地进行了信息披露，不存在您所说的董事会故意拖延发行时间的问题。本次非公开发行有利于促进公司满足银行业的资本监管要求，有利于促进公司业务发展、增强风险抵御能力，公司亦希望本次发行尽早完成。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210606"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)公司于2016年12月20日获证监会核准通过发公开发行股票，1月10日获行政许可受理，至今已2月有余，非公开发行工作推进程度如何?预计何时完成发行？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "本次非公开发行目前尚需证监会核准。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210607"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)公司于2017年3月22日发布公告称，非公开发行定价高于2015年12月31日审计的每股净资产。但公司发行公告已经公布一年有余，公司净资产已经发生大幅变化，预计2016年12月31日每股净资产将达15.58元，是否将发行价提高至实际发行完成前一个季度审计时的每股净资产之上？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "定价基准日前公司最近一期经审计的每股净资产是截止2015年12月31日的15.29元。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210608"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)公司于2017年3月22日发布公告称，每股发行价格14.16元符合有关规定，没有侵害中小股东权益。事实上2017年3月21日，公司A股收盘价16元，并且此前6个月收盘价均在16元以上，最高收盘价17.49元，相当于最低收盘价的88.5%，相当于最高收盘价的80.96%。小股东反映强烈，为什么公司却认为没有侵害呢？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "公司就本次非公开发行的定价原则、决策程序、审批流程等相关情形规范、持续地进行了信息披露；近期，公司亦于3月22日发布了澄清公告，就相关情况进行了说明。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210610"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)公司增发的基准价已经过去了一年，显然已经严重脱离公司公告自称的发行价与二级市场股价基本相近的描述。为了实践与“发行价与二级市场股价基本相近”这一描述，公司是否考虑调整发行价格，以与实际完成发行时二级市场股价基本相近？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "公司的定价基准日是2016年3月11日，在彼时，公司无法预知未来公司股票在二级市场的走势，亦无法确定最终取得批准或核准的时间。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210611"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000) 董事会作为公司的管理层，折价93%定向发行是为公司考虑还是为大股东考虑？如果是为公司考虑，为什么不提出溢价发行的议案供股东大会审议？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行的定价原则依法合规，并符合彼时市场普遍采用的方式。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210612"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n投资者_huc84k",
        "question": "浦发银行(600000)公司为什么不选择能够保护中小投资者权益的配股募集资金？如果14.16的价格向全体股东配股，没有认购的由大股东认购，相信募集资金一样能预期达到目标，却更能体现全体股东的同等权益受到保护。 ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议，感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210614"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nYYKK",
        "question": "浦发银行(600000)我们一直质疑增发损害小股东利益，可从没说过它不合法，为什么你们总是强调合法来回避问题呢？合法是否就没有利益输送？浦发给董事长和行长每月发2190的工资也是合法的，你们领工资的时候为什么不强调我只领合法的最低工资标准就够了？你们领着全体股东的薪水为什么只为大股东服务呢？ ",
        "questondate": "20170324",
        "answerer": "浦发银行",
        "answer": "公司非公开发行的目的是为了持续满足监管机构对资本充足的监管要求，同时也是为了支持公司业务发展，增强风险抵御能力，更好地为全体股东创造价值。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210746"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nWL2500014",
        "question": "浦发银行(600000)2016年公司向大股东定增收购上海信托，评估的收购价高于上海信托资净资产账面值168%，定增价只高于公司每股净资产2.5%，这是收购大股东的资产；如今向大股东现金增发股份，实际增发价却低于公司每股净资产，这是大股东现金认购公司股份。买大股东资产价高而买公司股份价低，请问这是否体现全体股东公平 ",
        "questondate": "20170327",
        "answerer": "浦发银行",
        "answer": "公司发行股份收购资产与定向增发再融资是不同的概念，两次定价分别参考的法律依据、发行目的以及新增股份的限售期均存在较大差异。感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "211054"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n凯路行",
        "question": "浦发银行(600000)公司能否顺应民意，在实际增发时对原增发价格进行调整，调整到不低于增发实际节点公司的净资产价格，若如此则不仅是众多股东之幸，亦是公司及大股东挽回公众形象的一个绝佳机会，我相信大股东绝不差这几个钱。 ",
        "questondate": "20170324",
        "answerer": "浦发银行",
        "answer": "本次非公开发行目前尚在证监会核准之中，感谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210667"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n凯路行",
        "question": "浦发银行(600000)兴业银行已在我县开立第二家营业网点了，招商、华夏、哈尔滨、天津等都有了，浦发啥时候来？（我县去年已升级为天津市蓟州区了，投资机遇也比以前大了，连碧桂园、万科这些大企业都到本地开发项目了）浦发要抓紧啊 ",
        "questondate": "20170324",
        "answerer": "浦发银行",
        "answer": "感谢您的建议！ ",
        "answerdate": "20170327",
        "id": "210670"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nfanxunlian",
        "question": "浦发银行(600000)请问公司什么时候分红 ",
        "questondate": "20170324",
        "answerer": "浦发银行",
        "answer": "公司2016年度利润分配预案尚需董事会审议，并由股东大会审议通过后实施，谢谢您的关注！ ",
        "answerdate": "20170327",
        "id": "210681"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)看了今晚的澄清公告，觉得荒唐！说增发方案合规可能难以反驳，因为规定本身有漏洞。但要说合法，不一定。你们能肯定方案未违反三公及诚实信用原则？说未侵害其他股东利益就更是瞎说？14元多的增发价是高于15年底的每股净资产，但能高于16年底的？还是认购资金早已到位或者增发不导致每股净资产下降？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行，本次发行的定价基准日为公司第五届董事会第五十三次会议决议公告日，即2016年3月11日；公司在定价基准日的时候，只能参考当时最近一期末经审计的每股净资产值，即2015年12月31日，经审计的归属于母公司普通股股东的每股净资产为15.29元。近感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "210307"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)希望浦发的管理层特别是董秘，要为全体股东利益服务，为全体股东发声，而不仅仅对大股东唯命是从！ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "我们会继续把各项经营管理工作做好，进一步加大银行的透明度，回报投资者对我们管理层的信任与支持。感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "210308"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)对增发完成的假设时间不当且目的不纯。记得在定向增发推介会上，浦发管理层以2016年第三季度完成增发为假设条件，这骗到了不少赞成票。另外投票时浦发所控制的上投摩根、浦银安盛等基金公司所持的股份（也属于持股5%以下的小股东）是否也应回避投票？ ",
        "questondate": "20170322",
        "answerer": "浦发银行",
        "answer": "鉴于发行股份属于监管机构审批核准事项，能否获得批准或核准的时间存在不确定性。感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "209972"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)浦发回复小股东质疑增发价过低时反复强调大股东三年的锁定期，难道这就能说明低价增发不会损害其他股东利益？按此逻辑难道浦发净资产在三年内肯定下降？此次增发虽符合证监会增发价的相关规定，但别忘了证券市场还有“诚实信用、公平公正”等原则！希望上海国际集团能闻过则改、别再继续损人利已！ ",
        "questondate": "20170322",
        "answerer": "浦发银行",
        "answer": "有关非公开发行的方案可详见公司此前公告，感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "209973"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)大股东去年只是承诺按约定价格认购一定数量股份，资金并未进入上市公司，那增发价格为何要按每年分红除权？做个极端假设：如果浦发每年分红率述60%，十年后那实际执行增发价不是几近于零？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "根据本次非公开发行方案，若公司普通股股票在定价基准日至发行日期间发生派息、送股、资本公积金转增股本等除权、除息事项，本次发行价格将进行相应调整。感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "210254"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)浦发此次增发方案不妥的实质在于约定一个增发期权价，资金未实缴到位，甚至未约定违约责任，增发价却随每年分红除权而逐年降低。审批时间越长，大股东获利越多，其他股东受侵越重！为何不放弃定增，另发可转债等？ ",
        "questondate": "20170323",
        "answerer": "浦发银行",
        "answer": "公司采用定向增发的方式来补充资本是经过综合考虑和反复论证的，本次非公开发行相关议案已经公司董事会与股东大会审议通过，关联董事或股东均回避表决，决策程序合规。感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "210290"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)如果说上次的定向增发收购上海国际依托仅仅是收购价格太高、收购标的盈利不及预期的话，这次的定向增发方案则是缺陷太多。因为只要浦发经营正常，净资产肯定每年增加而不是减少！ ",
        "questondate": "20170322",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行相关议案已经公司董事会与股东大会审议通过，关联董事或股东均回避表决，决策程序合规。本次非公开发行定价符合中国证监会相关法规及国有资产管理相关要求，发行价格的确定公允合理，不存在低价发行损害中小股东利益的情形。公司上市18年来均保持净利润的增长（净资产总额没有出现减少），感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "209970"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)人持有浦发银行已逾十年，浦发稳健的经营风格、每年初的快报、几乎每年都能完成的年度经营目标，让本人相信浦发确实在践行“笃守诚信、创造卓越”。但近两次的定向增发让本人产生的怀疑（本人对这两次的增发方案均投出反对票）。 ",
        "questondate": "20170322",
        "answerer": "浦发银行",
        "answer": "感谢您对浦发银行的支持，您提出的一系列问题我们一一进行回答。 ",
        "answerdate": "20170323",
        "id": "209969"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n认真的小散户ixv2n8",
        "question": "浦发银行(600000)只约定的增发价格，未约定有限期限。完成增发时间越迟对大股东越有利，对其他股东侵害越多！为何浦发公布增发方案比兴业银行早4个月，报证监会却迟2个月？如果证监会在下半年甚至一年后再核准（按浦发现在的再融资排位这种可能性很大），是否仍按约定的价格增发？且继续减去16年度的分红？ ",
        "questondate": "20170322",
        "answerer": "浦发银行",
        "answer": "本次非公开发行方案的制定符合法律法规的相关要求并履行了必要且完整的审批程序。目前，本次非公开发行方案尚在监管机构的审核过程中，公司将严格依据监管法规、规章、政策要求，依法合规开展本次非公开发行工作。感谢您的关注！ ",
        "answerdate": "20170323",
        "id": "209971"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的小散户ixv2n8",
        "question": "浦发银行(600000)贵行以低于2016年底每股净资产的价格向大股东定向增发，是否侵害了其他股东的权益？如果证监会到下半年甚至2、3年后才核准此次定向增发，大股东是否仍以原定价格认购（应该称为期权增发）？",
        "questondate": "20170321",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行方案启动于2016年3月，根据公司第五届董事会第五十三次会议和2015年年度股东大会审议通过的本次非公开发行方案的议案，本次非公开发行价格为16.09元/股，相当于本次非公开发行定价基准日（2016年3月11日）前20个交易日股票交易均价的93%，且高于经审计的2015年末归属于母公司普通股股东的每股净资产值15.29元/股。鉴于公司本次非公开发行的发行价格与市价较为接近，且考虑到本次非公开发行认购对象拟认购股份的锁定期为三年，发行价格定价公允合理，不存在低价增发损害中小股东利益的情形。本次非公开发行方案的制定符合法律法规的相关要求并履行了必要且完整的审批程序。 目前，本次非公开发行方案尚在监管机构的审核过程中，公司将严格依据监管法规、规章、政策要求，持续依法合规开展本次非公开发行工作。 自本次非公开发行工作启动以来，公司按照监管要求，规范、持续进行了信息披露；如有进一步的进展，公司将继续及时履行信息披露义务。 谢谢您的关注！",
        "answerdate": "20170321",
        "id": "209824"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "浦发银行(600000)我是贷款买的房，房产证下来了，但是压银行了，我现在办居住证需要房产证原件，我该怎么办？",
        "questondate": "20170320",
        "answerer": "浦发银行",
        "answer": "您好，有关个人按揭贷款相关业务请咨询您当时办理的网点机构或致电95528，感谢您的关注！",
        "answerdate": "20170321",
        "id": "209462"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "浦发银行(600000)以前关注过浦发的财务报表，记得未分配利润与招商、兴业大体相当，但现在看差了不少，请问是什么原因使得浦发的未分配利润减少？",
        "questondate": "20170320",
        "answerer": "浦发银行",
        "answer": "一般而言，在一个财务年内，因实施利润分配可能会导致当期未分配利润较年初下降。按照同比来看，浦发银行的未分配利润是随着公司每年净利润增长而逐年上升的。感谢您的关注！",
        "answerdate": "20170321",
        "id": "209478"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "浦发银行(600000)再问一个问题，不单单针对浦发。上市公司取得的每股收益，如果部分分了红，那么分红的部分归股东，",
        "questondate": "20170320",
        "answerer": "浦发银行",
        "answer": "一般而言上市公司实施利润分配（现金分红）是通过证券登记结算公司系统划转到股东账户，其余的属于未分配利润，由股东共享。感谢您的关注！",
        "answerdate": "20170321",
        "id": "209479"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nfocuson",
        "question": "浦发银行(600000)请问公司何时披露年报？ ",
        "questondate": "20170315",
        "answerer": "浦发银行",
        "answer": "公司年报目前在上海证券交易所预约披露时间是4月29日，我们将根据内部编制及外部审计师审计工作的进展情况予以调整，如调整披露时间我们将提前在交易所年报披露预约系统中予以变更，请予以关注！ ",
        "answerdate": "20170316",
        "id": "208926"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\nNaruto",
        "question": "浦发银行(600000)浦发银行2012年第一期金融债券期限5年 2017年2月28日到期 没有兑付公告中国货币网 也没相关公告 问问怎么回事 ",
        "questondate": "20170310",
        "answerer": "浦发银行",
        "answer": "关于我公司2012年第一期金融债券2017年付息及兑付公告，已经在银行间市场进行了公告（中债登和货币网），相关链接如下，公告文件 http://www.chinabond.com.cn/cb/cn/ywcz/fxyfxdf/zqzl/syyhz/ptz/fxdfyxqgg/20170220/146365638.shtml ",
        "answerdate": "20170313",
        "id": "208191"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n三省abc",
        "question": "浦发银行(600000)什么时候分红？ ",
        "questondate": "20170313",
        "answerer": "浦发银行",
        "answer": "公司2016年度利润分配预案尚需董事会审议，并由股东大会审议通过后实施，谢谢您的关注！ ",
        "answerdate": "20170313",
        "id": "208499"
    }, {
        "symbol": "600000.sh",
        "questioner": " \r\n杨晟民",
        "question": "浦发银行(600000)你好！定向增发价格是多少？是不是已经确定了？ ",
        "questondate": "20170213",
        "answerer": "浦发银行",
        "answer": "2016年4月28日，公司2015年年度股东大会审议通过了《上海浦东发展银行股份有限公司关于非公开发行普通股股票方案的议案》等议案，公司本次非公开发行普通股股票发行价格为16.09元/股；之后，因公司实施2015年度利润分配方案，向全体普通股股东每10股派送现金股利人民币5.15元并以资本公积按普通股每10股转增1股，故本次发行价格相应调整为14.16元/股。详情请参阅公司2016年6月29日发布的公告：《关于实施2015年度利润分配方案后调整非公开发行股票发行价格和发行数量的公告》。感谢您的关注！ ",
        "answerdate": "20170215",
        "id": "204322"
    }, {
        "symbol": "600000.sh",
        "questioner": "家国情怀",
        "question": "浦发银行(600000)我们是小股东，请问公司经营业绩如何？",
        "questondate": "20170207",
        "answerer": "浦发银行",
        "answer": "公司2016年围绕“保收入、控风险”经营主线，加大创新转型力度，实现了“十三五”良好开局。根据公司2017年1月3日披露的业绩快报，2016年末，公司总资产5.86万亿元，较年初增长16.12%；营业收入1607.92亿元，同比增长9.72%；归属于母公司股东的净利润530.99亿元，同比增长4.93%。感谢您的关注！",
        "answerdate": "20170207",
        "id": "203702"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司对高管的考核有哪些指标？",
        "questondate": "20170116",
        "answerer": "浦发银行",
        "answer": "公司制定了高级管理人员履职评价考核办法，公司董事会下设薪酬与考核委员会，定期对高级管理人员进行履职评价考核。考核指标包括盈利能力、经营成长、质量指标等方面，也综合考虑公司发展战略、业务和管理特点、外部经营环境和同业情况等因素。感谢您的关注！",
        "answerdate": "20170119",
        "id": "201893"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司认为公司的股价长期来看（10年以上）由什么决定？",
        "questondate": "20170111",
        "answerer": "浦发银行",
        "answer": "公司的股价受到市场环境、经营情况、宏观政策等多方面的影响。浦发银行一直致力于完善公司治理结构，借鉴国际上成熟的公司治理经验，努力构建和形成合理的股权结构，通过明晰公司治理各主体的职责边界，实现各利益相关者的利益均衡化和最大化，保护存款人的利益，为股东赢取回报，为社会创造价值，努力建设资本充足、内控严密、运营安全、效益良好的具有核心竞争优势的现代金融服务企业。感谢您的关注！",
        "answerdate": "20170112",
        "id": "201266"
    }, {
        "symbol": "600000.sh",
        "questioner": "oranger",
        "question": "浦发银行(600000)请问贵行有类似余额宝的产品吗?",
        "questondate": "20170112",
        "answerer": "浦发银行",
        "answer": "浦发银行针对不同的客户需求，推出了多种不同期限、起购金额等类型的理财产品。详情请浏览公司官网“个人金融”板块下的“投资理财”栏目，或咨询我行客服电话95528。感谢您的关注！",
        "answerdate": "20170112",
        "id": "201404"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请问今年业绩增长5%不到，增发摊薄后每股收益负增长，去年分红率仅为20%远远低于其他可比银行。请问今年的分红政策怎样？一个公司的股价主要由每股利润增速和分红率决定其净资产收益率，请问公司管理层将采取怎样的措施来维持股价的基本面？",
        "questondate": "20170104",
        "answerer": "浦发银行",
        "answer": "《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。 公司2016年度的利润分配预案将由年度董事会议来确定，公司在拟定利润分配方案时将通过多种形式听取投资者的意见和建议，利润分配将结合公司的行业特定、发展阶段和资本需求等因素，将兼顾投资者分享公司成长、发展成果，取得合理投资回报等要求。 我们将会更加努力和进取，把银行的各项经营管理工作做好，进一步加大银行的透明度，努力减少市场失真，以敬业的态度和专业的精神，做好上市公司的价值创造工作，以回报投资者对我们的信任与支持。谢谢您的关注！",
        "answerdate": "20170105",
        "id": "200238"
    }, {
        "symbol": "600000.sh",
        "questioner": "Echizen Roy",
        "question": "浦发银行(600000)请问贵公司有董秘办吗？大概几个人？上市就成立了吗，还是？",
        "questondate": "20161216",
        "answerer": "浦发银行",
        "answer": "公司根据相关法律法规和公司章程，从上市开始即设有负责公司治理及证券事务的机构部门。感谢您的关注！",
        "answerdate": "20161219",
        "id": "197150"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "浦发银行(600000)对于证监会的一次反馈意见，公司是否有充足准备？最快能多久回复？",
        "questondate": "20161205",
        "answerer": "浦发银行",
        "answer": "公司始终坚持依法合规经营，主动积极向监管机构报送有关情况，第一时间对于监管机构的问询反馈等作出回复，具体回复时间视具体事项而定。感谢您的关注！",
        "answerdate": "20161209",
        "id": "194921"
    }, {
        "symbol": "600000.sh",
        "questioner": "新天地孤星",
        "question": "浦发银行(600000)贵司资产负债表中有多少意大利国债？如意大利公投结果不理想而使得最后意大利脱欧，造成欧元区和意大利金融动荡，继而造成世界级的金融动荡，会对贵司今明两年的经营和业绩产生多大影响？贵司有对此在内部进行过类似的抗压测试吗？或有什么应对的措施以减少或降低对公司不利影响保护股东和投资者利益？",
        "questondate": "20161201",
        "answerer": "浦发银行",
        "answer": "公司所持有的债券主要是以境内主体发行的债券（占比绝大多数），截至目前不持有意大利国债，谢谢您的关注！",
        "answerdate": "20161202",
        "id": "194105"
    }, {
        "symbol": "600000.sh",
        "questioner": "只赚确定",
        "question": "浦发银行(600000)请问11月30日收盘后股东户数？",
        "questondate": "20161130",
        "answerer": "浦发银行",
        "answer": "截止2016年9月30日，公司股东总数为162,071户。感谢您的关注！",
        "answerdate": "20161202",
        "id": "193997"
    }, {
        "symbol": "600000.sh",
        "questioner": "kinglxl",
        "question": "浦发银行(600000)我参加了广发与贵所联合举办的期权培训并通过考试。本人两融账户在银河证券，银河看不到我考试成绩无法开户。我怎么提供考试通过证明或银河怎么查到成绩。期权测试证书编号16038552",
        "questondate": "20161108",
        "answerer": "浦发银行",
        "answer": "请您直接咨询交易所。感谢您的关注！",
        "answerdate": "20161109",
        "id": "190240"
    }, {
        "symbol": "600000.sh",
        "questioner": "落草火子",
        "question": "浦发银行(600000)请问关于上海新股申购的代码和配资代码不一样有什么文件说明吗",
        "questondate": "20161107",
        "answerer": "浦发银行",
        "answer": "请咨询您开户的券商或交易所。感谢您的关注！",
        "answerdate": "20161108",
        "id": "190002"
    }, {
        "symbol": "600000.sh",
        "questioner": "缘来如北",
        "question": "浦发银行(600000)请问一下网下申购新股可以选择股东账户么？例如我在A券商申请的合格投资者，想在B券商申购新股。这样是否可以。",
        "questondate": "20161013",
        "answerer": "浦发银行",
        "answer": "请咨询您开户的券商或交易所。感谢您的关注！",
        "answerdate": "20161028",
        "id": "186617"
    }, {
        "symbol": "600000.sh",
        "questioner": "卡面控爱羊毛",
        "question": "浦发银行(600000)2016年4月21日公告说， 本次非公开发行普通股股票方案尚需公司【股东大会】审议通过，并需获得【银监会】、【证监会】等监管机构的核准后方可实施。___________________________________请问：本次非公开发行普通股股票，到了哪一步？",
        "questondate": "20161014",
        "answerer": "浦发银行",
        "answer": "根据公司2015年度股东大会决议，公司已向监管机构提出申请。截至目前，该等事项尚待获得监管机构的核准。感谢您的关注！",
        "answerdate": "20161028",
        "id": "186627"
    }, {
        "symbol": "600000.sh",
        "questioner": "cake2222",
        "question": "浦发银行(600000)请问公司截止10月10日的投资者数量为多少？",
        "questondate": "20161013",
        "answerer": "浦发银行",
        "answer": "截止2016年6月30日，公司股东总数为173,951户。三季度末的股东数据请关注公司即将披露的第三季度报告。感谢您的关注！",
        "answerdate": "20161028",
        "id": "186480"
    }, {
        "symbol": "600000.sh",
        "questioner": "割肉好痛苦啊",
        "question": "浦发银行(600000)贵公司的信用卡额度如何升级？还有公司员工人数多少？\\r\\n\\r\\t",
        "questondate": "20160930",
        "answerer": "浦发银行",
        "answer": "信用卡业务相关请联系：客服电话 95528 信用卡客服热线 400-820-8788 信用卡客服热线 021-38784988。 截止2016年6月30日，母公司在职员工的数量为48,003人。 感谢您的关注！",
        "answerdate": "20160930",
        "id": "185076"
    }, {
        "symbol": "600000.sh",
        "questioner": "割肉好痛苦啊",
        "question": "浦发银行(600000)申购新股时，ETF算不算市值？还有就是何时公布年报？",
        "questondate": "20160930",
        "answerer": "浦发银行",
        "answer": "新股申购规则请向交易所咨询。公司2015年年报已于今年四月披露。感谢您的关注！",
        "answerdate": "20160930",
        "id": "185075"
    }, {
        "symbol": "600000.sh",
        "questioner": "a1112345",
        "question": "浦发银行(600000)1、谢谢穆矢先生的回复。2、关于回复内容“2016年上半年，公司共收回以前年度核销贷款的收益约7亿元。”中，“以前年度”为何年度？该年度核销贷款共多少？",
        "questondate": "20160929",
        "answerer": "浦发银行",
        "answer": "该项披露数据是指在2016年上半年度中，公司共收回了历年来的核销贷款约7亿元。感谢您的关注！",
        "answerdate": "20160930",
        "id": "185045"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "浦发银行(600000)1、2016年1月1日至今（9月28日），资产损失核销合计多少？2、上述核销资产中有追索权的债权占比多少？3、截止2016年中报公布，有追索权的债权已追回多少？期待贵董秘回复！",
        "questondate": "20160929",
        "answerer": "浦发银行",
        "answer": "2016年初至今，公司董事会共审议并表决通过了三次关于资产损失核销的议案，共批准公司核销约215亿元人民币。公司将根据董事会的决议和有关法律法规的规定，在批准核销上述损失类资产后，除已无追索权的债权外，对尚有追索权的其他所有债权，将坚持以“账销案存权在”为原则继续追索。2016年上半年，公司共收回以前年度核销贷款的收益约7亿元。",
        "answerdate": "20160929",
        "id": "184847"
    }, {
        "symbol": "600000.sh",
        "questioner": "凯路行",
        "question": "浦发银行(600000)请问公司已核销的损失类资产，最终能够追索回来的占比有多少？",
        "questondate": "20160929",
        "answerer": "浦发银行",
        "answer": "公司将根据董事会的决议和有关法律法规的规定，在批准核销上述损失类资产后，对尚有追索权的其他所有债权坚持以“账销案存权在”为原则继续追索。2016年上半年，公司共收回以前年度核销贷款的收益约7亿元。",
        "answerdate": "20160929",
        "id": "184868"
    }, {
        "symbol": "600000.sh",
        "questioner": "A股小不懂",
        "question": "浦发银行(600000)浦发银行是否有在港股或其它市场上市的计划？",
        "questondate": "20160824",
        "answerer": "浦发银行",
        "answer": "截至目前，公司董事会尚未审议有关港股及其他市场上市融资的计划，谢谢您的关注！",
        "answerdate": "20160825",
        "id": "178577"
    }, {
        "symbol": "600000.sh",
        "questioner": "宁静致远168",
        "question": "浦发银行(600000)您好，劳烦查一下公司截至最新的股东人数，谢谢！",
        "questondate": "20160819",
        "answerer": "浦发银行",
        "answer": "截至6月30日，公司股东人数为173,951户；公司在定期报告中将予披露截至报告期末的股东人数，谢谢关注！",
        "answerdate": "20160822",
        "id": "177947"
    }, {
        "symbol": "600000.sh",
        "questioner": "目不识丁",
        "question": "浦发银行(600000)贵公司的信用卡额度如何升级？？",
        "questondate": "20160808",
        "answerer": "浦发银行",
        "answer": "详情咨询公司信用卡中心4008880288，谢谢您的关注！",
        "answerdate": "20160808",
        "id": "176280"
    }, {
        "symbol": "600000.sh",
        "questioner": "林自然",
        "question": "浦发银行(600000)摸摸糊糊世上颜笑，真戏假演，以后你错，历史见证十六载德厚载物讽言猛语不忘初心一帆破浪继续前进。",
        "questondate": "20160805",
        "answerer": "浦发银行",
        "answer": "谢谢关注！",
        "answerdate": "20160808",
        "id": "176214"
    }, {
        "symbol": "600000.sh",
        "questioner": "公民2016",
        "question": "浦发银行(600000)向大股东增发。必须赶快进行，虽然稀释了绝大多数股东的权益财富。让大股东获得了利益。以低价格配股给资本市场。才是最好的平等方式。管理层必须反省。尊重绝大多数投资者的权益。是公司发展增长的最大力量。管理意识上。必须充分配合股东权益。业务上给股东优惠。比如免费信用卡等。",
        "questondate": "20160720",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！我行信用卡已基本实现免年费。公司将会更加努力和进取，把银行的各项经营管理工作做好，进一步加大银行的透明度，回报投资者对我们管理层的信任与支持。",
        "answerdate": "20160722",
        "id": "173565"
    }, {
        "symbol": "600000.sh",
        "questioner": "TW1314",
        "question": "浦发银行(600000)你好，民营银行开放必将加大银行业竞争，随着利差缩小，公司以后的利润增长点在哪方面体现呢？",
        "questondate": "20160713",
        "answerer": "浦发银行",
        "answer": "公司将以推进“集团化、专业化、数字化、轻型化、国际化、集约化”战略任务，做强交易银行、投行和资管、同业和托管，做大零售和小微、非信贷资产，进一步推动业务转型，提高零售业务的综合实力，提升非利息收入在营业收入中的占比，提升公司竞争力。",
        "answerdate": "20160714",
        "id": "172536"
    }, {
        "symbol": "600000.sh",
        "questioner": "凯路行",
        "question": "浦发银行(600000)半年已过，公司在浙江地区的经营是否扭亏为盈？",
        "questondate": "20160706",
        "answerer": "浦发银行",
        "answer": "请关注公司披露的半年度报告，谢谢！",
        "answerdate": "20160708",
        "id": "171515"
    }, {
        "symbol": "600000.sh",
        "questioner": "孟广宝拉来王健林",
        "question": "浦发银行(600000)提供一条战略：兵贵神速，在孟广宝（华君控股海润光伏双料董事长）慢慢腾腾，定向增发时，像宝能举牌万科一样，调动资金，闪电举牌海润光伏（600401），拿下控股权，完成布局新能源光伏发电，让无股董事长孟广宝目瞪口呆。",
        "questondate": "20160627",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！",
        "answerdate": "20160628",
        "id": "169760"
    }, {
        "symbol": "600000.sh",
        "questioner": "龙哥",
        "question": "浦发银行(600000)您好，截至2016年5月底，股东人数是多少？谢谢您。",
        "questondate": "20160613",
        "answerer": "浦发银行",
        "answer": "公司将在定期报告中予披露截至报告期末的股东人数，谢谢关注！",
        "answerdate": "20160615",
        "id": "167897"
    }, {
        "symbol": "600000.sh",
        "questioner": "新山野",
        "question": "浦发银行(600000)公司在3月底发布信息说转让华一银行股权, 请问是在二季度交割的吗? 所形成的投资收益大致有多少?",
        "questondate": "20160603",
        "answerer": "浦发银行",
        "answer": "公司转让所持华一银行的股权正处在交易过程中，谢谢您的关注！",
        "answerdate": "20160606",
        "id": "167097"
    }, {
        "symbol": "600000.sh",
        "questioner": "新山野",
        "question": "浦发银行(600000)15年的红利分配什么时候实施? 兴业都跑到前面了, 浦发还没动静.",
        "questondate": "20160603",
        "answerer": "浦发银行",
        "answer": "确定时间后公司将予以公告，谢谢您的关注！",
        "answerdate": "20160606",
        "id": "167107"
    }, {
        "symbol": "600000.sh",
        "questioner": "实在赔不起",
        "question": "浦发银行(600000)请问，截至5月31日，公司的股东人数是多少？谢谢",
        "questondate": "20160601",
        "answerer": "浦发银行",
        "answer": "公司将在定期报告中予披露截至报告期末的股东人数，谢谢关注！",
        "answerdate": "20160601",
        "id": "166620"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请公司评价一下兴业银行的优缺点",
        "questondate": "20160531",
        "answerer": "浦发银行",
        "answer": "我们会比较研究同业，但不宜去评价其他银行，谢谢您的关注！",
        "answerdate": "20160601",
        "id": "166516"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请公司评价一下民生银行的优缺点",
        "questondate": "20160531",
        "answerer": "浦发银行",
        "answer": "我们会比较研究同业，但不宜去评价其他银行，谢谢您的关注！",
        "answerdate": "20160601",
        "id": "166518"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的小散户ixv2n8",
        "question": "浦发银行(600000)浦发第一季报中手续费及佣金收入高速增长67.6%，主要来源包括那些部分？每股收益的计算：是应该用股东利润还是用扣除非经常性损益后的股东利润除总股本？如果是前者，那每股收益应该是0.708元，而不是0.696元。",
        "questondate": "20160503",
        "answerer": "浦发银行",
        "answer": "增长的来源主要包括信用卡及理财产品等，每股收益的计算是按照净利润来计算，在计算本报告期的每股收益时，还须扣除浦发优2已宣告发放的优先股股息8.25亿元。谢谢！",
        "answerdate": "20160504",
        "id": "161074"
    }, {
        "symbol": "600000.sh",
        "questioner": "认真的小散户ixv2n8",
        "question": "浦发银行(600000)浦发第一季报合并报表是否应该、是否包括了上海国际信托？如果是，为何手续费及佣金收入浦银集团为120.60亿，浦发银行为119.46亿，差额仅为1.14亿（2015年1-3月上海国际信托的手续费及佣金收入就已达5.62亿）？主营收入集团与浦发银行二者差额为6亿，仅上海国际信托去年1-3月主营就达8亿。",
        "questondate": "20160503",
        "answerer": "浦发银行",
        "answer": "2016年3月15日公司完成了上海信托97.33%股权过户事宜，相关工商变更登记手续已办理完毕，上海信托成为公司的控股子公司。 鉴于此，上海信托纳入公司财务报表合并范围的并表日为3月15日。",
        "answerdate": "20160504",
        "id": "161075"
    }, {
        "symbol": "600000.sh",
        "questioner": "chloe",
        "question": "浦发银行(600000)保险",
        "questondate": "20160429",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注！",
        "answerdate": "20160504",
        "id": "160926"
    }, {
        "symbol": "600000.sh",
        "questioner": "阿明仔",
        "question": "浦发银行(600000)今年营收状况？",
        "questondate": "20160425",
        "answerer": "浦发银行",
        "answer": "有关今年的营收情况还请您关注公司4月30日披露的季度报告，谢谢！",
        "answerdate": "20160426",
        "id": "160162"
    }, {
        "symbol": "600000.sh",
        "questioner": "大罗杰",
        "question": "浦发银行(600000)浦发银行提到未来要构建金融旗舰企业，公司相继投资构建了上海信托，浦银基金，浦银租赁等良好平台，但是这与国内其他股份制银行相比并无特色之处，相对的我们是否实践取得券商牌照或计划措施？另近年银行基层员工辞职率较以往有所提高，普遍反应薪酬增幅低，激励机制相对落后，公司如何看人才问题？",
        "questondate": "20160419",
        "answerer": "浦发银行",
        "answer": "公司将初步构建银行控股的集团经营架构，在巩固银行主业核心竞争优势基础上，推动多牌照业务融合与协同发展，显著增强综合化金融服务能力，打造适应能力强、发展优势突出、轻型化程度高的高绩效全能型银行集团。谢谢您的关注!",
        "answerdate": "20160426",
        "id": "159269"
    }, {
        "symbol": "600000.sh",
        "questioner": "dadaxiaoxiao",
        "question": "浦发银行(600000)申购新股时，ETF算不算市值？？",
        "questondate": "20160426",
        "answerer": "浦发银行",
        "answer": "这还请您咨询证券交易所，谢谢！",
        "answerdate": "20160426",
        "id": "160285"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)首先我承认公司的分红符合公司章程及证监会的各项规定，但这不是我需要你回答的问题。我的问题是：每年坚持分红30%，逐年提高，资本不够了再增发，为什么不可以，而且也已经这样做了，为什么要降低分红率？请正面回答问题。",
        "questondate": "20160418",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！历年的利润分配预案公司都会通过多种形式听取多方股东意见和诉求，总体上看，2015年度利润分配预案既考虑了国家经济的新常态、银行业监管机构的相关要求，又密切结合了公司的行业特点、发展阶段，以及自身盈利水平和资本补充等因素，兼顾了投资者特别是中小投资者分享公司成长和取得合理投资回报等要求。",
        "answerdate": "20160419",
        "id": "159109"
    }, {
        "symbol": "600000.sh",
        "questioner": "TW1314",
        "question": "浦发银行(600000)你好 央行实行规定信用卡透支利率设上下限 取消滞纳金对公司经营利润有何影响？",
        "questondate": "20160415",
        "answerer": "浦发银行",
        "answer": "信用卡透支利息、滞纳金收入在公司营业收入占比很小，央行新规定不会对公司经营利润产生实质影响。",
        "answerdate": "20160418",
        "id": "158967"
    }, {
        "symbol": "600000.sh",
        "questioner": "林自然",
        "question": "浦发银行(600000)與投資者什麽關係",
        "questondate": "20160418",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注！",
        "answerdate": "20160418",
        "id": "159049"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)我们认为公司对股东的承诺与客户借钱还款是一样的，有借有还，还了，再借不难。同样公司也应该保持一个持续稳定的分红历史，这样即便下次再融资甚至公开配股，股东都是可以接受的，并且也同样能达到你上述说的三点考虑，同时每次再融资时也能够让公司重新审视对股东的承诺，请问公司是否同意上述观点？",
        "questondate": "20160413",
        "answerer": "浦发银行",
        "answer": "《公司章程》明确公司利润分配的基本原则、具体政策、决策程序、组织实施及利润分配政策的变更，明确公司现金分红方案应遵循监管机构的相关规定，除特殊情况外，最近三年现金分红累计分配的利润应不少于最近三年实现的年均可分配利润的百分之三十。公司最近三年（2013年度-2015年度）由董事会拟定以及经股东大会审议通过的利润分配方案，现金分红累计分配的利润占最近三年实现的年均可分配利润的47.76%，符合公司章程的相关要求。谢谢您的关注！",
        "answerdate": "20160418",
        "id": "158298"
    }, {
        "symbol": "600000.sh",
        "questioner": "投资者_145594",
        "question": "浦发银行(600000)请问前段时间停牌那么久公司的动态是什么?_?",
        "questondate": "20160411",
        "answerer": "浦发银行",
        "answer": "因筹划向上海国际集团有限公司等非公开发行普通股股票重大事项，经向上海证券交易所申请，公司自2016年2月16日起停牌，3月11日披露了董事会审议通过的相关方案（详见公司公告，公告编号：临2016-021），公司股票同日复牌交易，该等方案拟提交4月28日召开的公司2015年度股东大会审议。",
        "answerdate": "20160412",
        "id": "158003"
    }, {
        "symbol": "600000.sh",
        "questioner": "凯路行",
        "question": "浦发银行(600000)浙江作为经济大省，公司业务却连年亏损到底是何原因？公司有无扭亏为盈计划采取措施扭亏为盈？",
        "questondate": "20160408",
        "answerer": "浦发银行",
        "answer": "主要原因还是受到该地区不良贷款反弹的影响，公司将进一步强化该地区风险监测预警、加大清收化解的力度，控制风险成本。",
        "answerdate": "20160412",
        "id": "157525"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)本次分红仅为利润的20%，虽满足公司章程，但分红率较上年下降10%，在业绩并无下降的情况下分红没有一个连续性的过程，究竟是基于何种考虑？既然明年预计资产增幅在7.5%左右，按照现在的利润留存量也完全能够满足资本充足率，还有余量，并且今年也进行了增发。",
        "questondate": "20160407",
        "answerer": "浦发银行",
        "answer": "这次现金分红比例为2015年度净利润的20%，低于往年30%的水平。主要是基于以下考虑：一是国际、国内外部资本监管要求都更为严格，特别是央行的宏观审慎监管体系，对商业银行资本充足水平提出了更高的要求。随着金融脱媒和互联网金融的发展，利率、汇率市场化改革的进程加快，银行面临的经营环境更加复杂。在此背景下，商业银行必须壮大资本实力，提升充足水平，直面市场的挑战和冲击。二是国内经济继续保持韧性好、潜力足、回旋空间大的基本特质，预计国内经济将保持6.5%的中高速增长态势；而商业银行将在社会资金配置中继续发挥主导力量，银行发展相对更可预期。因此，适当提升利润留存以补充核心一级资本，有利于公司各项业务的持续、健康发展，有利于公司整体盈利能力和核心竞争力的有效提升，有利于公司为全体股东带来更丰厚的回报。三是公司正在研究制定“十三五”规划，未来五年，公司的基本目标是：初步构建银行控股的集团治理架构和经营架构，在巩固银行主业核心竞争优势基础上，推动多牌照金融业务的融合与协同发展，推动综合化经营取得显著进展。为此，公司必须通过多种渠道补充资本，而适当的利润留存补充资本是公司补充核心一级资本的重要途径之一。",
        "answerdate": "20160412",
        "id": "157276"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)公司对股东的回报究竟体现在哪项指标？普通股股东的理解就是净资产收益率，既然分红减少了，明年的利润预测增速又只有3%，请问公司如何保持现有的净资产收益率？公司目前总部为汇丰银行旧址，汇丰银行150年的经营史能够在业绩下滑的时候提高分红比率，保持足够的ROE，堪称银行界楷模，望公司借鉴。",
        "questondate": "20160407",
        "answerer": "浦发银行",
        "answer": "谢谢您的建议！虽然当前中国经济步入新常态，但国内经济仍将继续保持韧性好、潜力足、回旋空间大的基本特质，商业银行将在社会资金配置中继续发挥主导力量，银行发展仍更可预期保持相对稳定的增长，投资者仍可分享到公司的成长和经营成果。",
        "answerdate": "20160412",
        "id": "157277"
    }, {
        "symbol": "600000.sh",
        "questioner": "实在赔不起",
        "question": "浦发银行(600000)请问，截至3月31日，公司的股东人数是多少？谢谢",
        "questondate": "20160401",
        "answerer": "浦发银行",
        "answer": "截至3月31日股东人数为184,005，详见公司2015年度报告报告，谢谢您的关注！",
        "answerdate": "20160407",
        "id": "156443"
    }, {
        "symbol": "600000.sh",
        "questioner": "实在赔不起",
        "question": "浦发银行(600000)请问，截至3月31日，公司的股东人数是多少？谢谢",
        "questondate": "20160401",
        "answerer": "浦发银行",
        "answer": "截至3月31日股东人数为184,005，详见公司2015年度报告报告，谢谢您的关注！",
        "answerdate": "20160407",
        "id": "156451"
    }, {
        "symbol": "600000.sh",
        "questioner": "储哥",
        "question": "浦发银行(600000)请问公司截至16年4月1日的股东人数，谢谢！",
        "questondate": "20160405",
        "answerer": "浦发银行",
        "answer": "截至3月31日股东人数为184,005，详见公司2015年度报告报告，谢谢您的关注！",
        "answerdate": "20160407",
        "id": "156627"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)上次收购上海信托的增发价除权后是16.36元/股，但时隔半年，浦发的价值应该是提高了的，为什么反而比上次增发价格低，请给一个解释？93%的打折率是依据什么算出来的？我觉得你这个问题的回答不漂亮，你应该回答我们认为当时受市场影响上海信托也是被高估了的，这样我就无话可说了。",
        "questondate": "20160324",
        "answerer": "浦发银行",
        "answer": "本次非公开发行股票价格为16.09元/股，相当于定价基准日前20个交易日公司A股股票交易均价的93%。与收购上海信托发行定价时候比，浦发银行每股净资产值是在增长，但是股票交易的价格是在不断变化，本次定价以前20个交易日的均价是市场决定的。本次非公开发行的定价系与发行对象基于商业谈判后协商一致的结果，不仅高于公司2015年度业绩快报计算的每股净资产15.29元/股，亦高于市场上定价发行股票所普遍采用的90%的法规最低标准，且限售期为三年。一方面符合有关法律法规的规定，另一方面在法规规定的发行底价的基础上增加了一定的溢价，有利于保障中小投资者利益及体现发行对象对于浦发银行未来发展的信心。",
        "answerdate": "20160325",
        "id": "155089"
    }, {
        "symbol": "600000.sh",
        "questioner": "安全配资13167102891",
        "question": "浦发银行(600000)浦发信用卡万用金的确定标准是什么??",
        "questondate": "20160321",
        "answerer": "浦发银行",
        "answer": "欢迎您拨打我行信用卡专线电话400-820-8788或登录信用卡中心官方网站（http://www.spdbccc.com.cn）了解具体的情况，谢谢！",
        "answerdate": "20160322",
        "id": "154550"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)招行、民行都相继实行了员工持股计划，万科实行了合伙人跟投制度，请问浦发银行有没有相应的计划，大致什么时候开展？",
        "questondate": "20160315",
        "answerer": "浦发银行",
        "answer": "我们注意到，在2014年证监会制定并发布《关于上市公司实施员工持股计划试点的指导意见》后，上市银行中，民生银行、招商银行等先后公告了员工持股计划方案。员工持股计划的实施，有利于将员工利益和上市公司利益密切结合，有利于促进上市公司的价值创造，也有利于上市公司在资本市场上的形象。浦发银行长期来就对上市银行的股权激励制度进行探索，也分析研究了同业的股权方案和特点，但当前国有商业银行实施股权激励在政策上尚需进一步明晰。",
        "answerdate": "20160317",
        "id": "153901"
    }, {
        "symbol": "600000.sh",
        "questioner": "太阳的星星",
        "question": "浦发银行(600000)关注更多信息",
        "questondate": "20160316",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注！",
        "answerdate": "20160317",
        "id": "154061"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)上次收购上海信托的增发价除权后是16.38元/股，但时隔半年，浦发的价值应该是提高了的，为什么反而比上次增发价格低，请给一个解释？93%的打折率是依据什么算出来的？",
        "questondate": "20160311",
        "answerer": "浦发银行",
        "answer": "本次非公开发行价格为16.09元/股，该价格相当于定价基准日前20个交易日公司A股股票交易均价的93%，高于《上市公司发行证券管理办法》规定及市场上较为普遍的定价基准日前20个交易日均价的90%。该发行价格系公司与本次认购对象经协商确定的价格。体现了认购对象对于浦发银行未来发展的信心。",
        "answerdate": "20160314",
        "id": "153596"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请问公司对3月11日开盘浦发银行股价即可逼近跌停有何看法（请谨慎回答），增发价格16.09元低于市场停牌前均价93%，日前证监会还发文称鼓励以停牌前一天价格作为增发价格，公司没有响应证监会号召，反而打折增发，是否是不认可现在的股价，打算给大股东送礼？请认真回答",
        "questondate": "20160311",
        "answerer": "浦发银行",
        "answer": "公司本次非公开发行募集资金拟全部用于补充公司核心一级资本，以增强公司资本实力，提高风险抵御能力，实现稳健经营。资本补充能够为公司各项业务的快速、持续、健康发展提供充足的资金支持，提升公司的整体盈利能力和核心竞争力，在促进公司更好更快发展的同时为全体股东带来更丰厚的回报，为公司战略目标的实现奠定基础。 本次非公开发行价格符合相关法律法规的要求。本次发行价格为16.09元/股，该价格相当于定价基准日前20个交易日公司A股股票交易均价的93%，高于《上市公司发行证券管理办法》规定及市场上较为普遍的定价基准日前20个交易日均价的90%。该发行价格系公司与本次认购对象经协商确定的价格。体现了认购对象对于浦发银行未来发展的信心。",
        "answerdate": "20160314",
        "id": "153590"
    }, {
        "symbol": "600000.sh",
        "questioner": "王为君",
        "question": "浦发银行(600000)能否告知大致投资事项吗？",
        "questondate": "20160217",
        "answerer": "浦发银行",
        "answer": "本次筹划非公开发行的事宜请关注公司后续公告，谢谢！",
        "answerdate": "20160219",
        "id": "151175"
    }, {
        "symbol": "600000.sh",
        "questioner": "Noenemy股神",
        "question": "浦发银行(600000)请问刚出的公告说的非公开增发，是收购上海信托的事情，还是另外有别的事情？",
        "questondate": "20160216",
        "answerer": "浦发银行",
        "answer": "本次筹划非公开发行与发行股收购资产（上海国际信托）不同，谢谢您关注！",
        "answerdate": "20160219",
        "id": "151084"
    }, {
        "symbol": "600000.sh",
        "questioner": "吃受制与牙",
        "question": "浦发银行(600000)交款后股份什么时候才能到账",
        "questondate": "20160202",
        "answerer": "浦发银行",
        "answer": "不太清楚你指什么交款，谢谢您的关注！",
        "answerdate": "20160204",
        "id": "150616"
    }, {
        "symbol": "600000.sh",
        "questioner": "吃吃吃",
        "question": "浦发银行(600000)请问公司股东人数是多少",
        "questondate": "20160125",
        "answerer": "浦发银行",
        "answer": "公司将在定期报告中予以披露，请予以关注！",
        "answerdate": "20160128",
        "id": "149371"
    }, {
        "symbol": "600000.sh",
        "questioner": "lt123",
        "question": "浦发银行(600000)你好",
        "questondate": "20160125",
        "answerer": "浦发银行",
        "answer": "谢谢你的关注",
        "answerdate": "20160128",
        "id": "149388"
    }, {
        "symbol": "600000.sh",
        "questioner": "amay1106",
        "question": "浦发银行(600000)明天涨有希望吗",
        "questondate": "20160125",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注",
        "answerdate": "20160128",
        "id": "149357"
    }, {
        "symbol": "600000.sh",
        "questioner": "dlou",
        "question": "浦发银行(600000)明天能涨吗",
        "questondate": "20160125",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注！",
        "answerdate": "20160128",
        "id": "149346"
    }, {
        "symbol": "600000.sh",
        "questioner": "吃吃吃",
        "question": "浦发银行(600000)浦发今天行情多少",
        "questondate": "20160125",
        "answerer": "浦发银行",
        "answer": "谢谢您的关注",
        "answerdate": "20160128",
        "id": "149356"
    }, {
        "symbol": "600000.sh",
        "questioner": "莎士比亚",
        "question": "浦发银行(600000)关注",
        "questondate": "20160106",
        "answerer": "浦发银行",
        "answer": "谢谢！",
        "answerdate": "20160114",
        "id": "146568"
    }, {
        "symbol": "600000.sh",
        "questioner": "wishyl",
        "question": "浦发银行(600000)请问目前股东人数是多少？谢谢",
        "questondate": "20160112",
        "answerer": "浦发银行",
        "answer": "公司将在定期报告中予以披露，谢谢您的关注！",
        "answerdate": "20160114",
        "id": "147687"
    }],
    "aggregate": [],
    "start": 0,
    "end": 2000,
    "count": 772,

    "message": null,
    "code": 0
    /*暴露外部用的方法*/
};exports.TEST_NEWSINTERACT_DATA = TEST_NEWSINTERACT_DATA;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/60000.sh.NewsInteract.js
// module id = 305
// module chunks = 0